import React from "react";

import {
  Button,
  Col,
  FormLabel,
  Row,
  Table,
  FormControl,
} from "react-bootstrap";
import { AppContext } from "../AppContext.js";
import { ConfigManager } from "../config/ConfigManager.js";
import {
  COUNTABLE_UOM_TYPE,
  LENGTH_UOM_TYPE,
  NEW_ENTRY,
  WEIGHT_UOM_TYPE,
} from "../ds/App_Constants";
import { BaseBean, NodeData, RestReportBean } from "../ds/client_ds.js";
import {
  AddressBean,
  CustomerBean,
  FabricStyleBean,
  MailInfoBean,
  PackingListPrintRequest,
  PageListBean,
  PickTicketBean,
  PickTicketBoxPalletLineDetailBean,
  PickTicketLineBean,
  PickTicketLinePalletDetailBean,
  PickTicketModuleDependenciesBean,
  PickTicketRollAndRollSkuLabelsRequest,
  PickTicketRollLineBean,
  PickTicketSearchCriteria,
  PickTicketShipmentBoxDetailBean,
  ReasonBean,
  RestEntityUnLockRequest,
  RestPackingListMailRequest,
  RestPickTicketListRequest,
  RestPickTicketRequest,
  RestPickTicketShipmentLabelPrintRequest,
  RestPickTicketShipmentRateRequest,
  RestPickTicketVoidShipmentRequest,
  RestPickTicket_v1Request,
  RestReadRequest,
  ShipmentRateBean,
  ShipmentRateCriteria,
  ShipmentRateResultBean,
  SKUBatchInventorySearchCriteria,
} from "../ds/ds.js";
import { LogicConstants } from "../ds/LogicConstants.js";
import {
  AddIcon,
  DeleteIcon,
  DropDwnDown,
  DropDwnUp,
} from "../gui_components/Icons.js";
import {
  AlertToolBox,
  BootstrapDataGrid,
  BootstrapDataGridColumnDefinition,
  ColumnDefinition,
  DataGridColumnDefinition,
  DatePickerComponent,
  EditableDataGrid,
  InputCheckbox,
  InputTextbox,
  MultiViewPopup,
  NumberFormatInputbox,
  ReasonCaptureComponent,
  ShowError,
} from "../gui_components/UIComponents.js";
import {
  isEmpty,
  isEmptyArray,
  isEmptyString,
} from "../gui_components/Util.js";
import { GenericAttributeLookupHandler } from "../lookup/GenericAttributeLookupHandler.js";
import { PickTicketLineLookupHandler } from "../lookup/PickTicketLineLookupHandler";
import { PickTicketLookupHandler } from "../lookup/PickTicketLookupHandler.js";
import { PopupInvoiceModule, PopupSalesModule } from "../modules/ModuleUtil.js";
import { SecurityAccessManager } from "../security/SecurityAccessManager.js";
import { InventoryService } from "../services/InventoryService.js";
import { InvoiceService } from "../services/InvoiceService.js";
import { PickTicketService } from "../services/PickTicketService.js";
import { ReportService } from "../services/ReportService.js";
import { SalesOrderService } from "../services/SalesOrderService.js";
import { PickTicketModuleToolBar } from "../toolBar/PickTicketModuleToolBar.js";
import {
  BaseNodeBar,
  BaseNotification,
  BaseToolBar,
  ModuleToolBar,
} from "./BaseModule.js";
import { ModuleUtils } from "./ModuleUtils.js";
import CustomTable from "../gui_components/CustomTable.js";
class PickTicketList extends React.Component {
  static contextType = AppContext;

  constructor(props) {
    super(props);
    this.entryFormRef = React.createRef();
    this.lineDetailDialogRef = React.createRef();
    this.cancelReasonDialogRef = React.createRef();
    this.boxDetailDialogRef = React.createRef();
    this.rateDetailDialogRef = React.createRef();
    this.rateDetailDialogStyles = {
      width: "90%",
      height: "calc(80% - 90px)",
      marginTop: "-230px",
      marginLeft: "-46%",
      overflowX: "none",
      top: "50%",
      overflowY: "scroll",
    };
    this.boxDetailDialogStyles = {
      width: "90%",
      height: "calc(80% - 90px)",
      marginTop: "-230px",
      marginLeft: "-46%",
      overflowX: "none",
      top: "50%",
      overflowY: "scroll",
    };
    this.lineDetailDialogStyles = {
      width: "90%",
      height: "calc(80% - 90px)",
      marginTop: "-230px",
      marginLeft: "-46%",
      overflowX: "none",
      top: "50%",
      overflowY: "scroll",
    };
    this.state = {
      pageTitle: "PickTicketMaintenance",
      moduleKeyCode: NEW_ENTRY,
      selectedNodeKey: "headerView",
      moduleCaption: "PickTicket",
      isLoading: false,

      isEntryFormOpen: false,
      isListFormOpen: true,
      isShippingInformationFormOpened: false,
      isChangesHistoryFormOpened: false,
      isInvoicesFormOpened: false,
      isPalletFormOpened: false,

      isShowModuleSearchContainer: false,
      isShowNodes: false,
      pickTicketList: [],

      nodeList: [],
      pickTicketListUpdateNeeded: false,
      pickTicketData: new PickTicketBean(),
      pickTicketLineData: new PickTicketLineBean(),
      pickTicketBoxLineData: new PickTicketShipmentBoxDetailBean(),
      pageList: new PageListBean(),
      pickTicketCriteria: new PickTicketSearchCriteria(),
      dependenciesBean: new PickTicketModuleDependenciesBean(),
      skuBatchInventories: [],

      cityList: [],
      stateList: [],
      countryList: [],
      freightMethods: [],
      shipVias: [],
      shipTos: [],
      logisticMethods: [],
      boxTypes: [],
      reasonData: new ReasonBean(),
      cancelReasons: [],
      shipmentRateResult: new ShipmentRateResultBean(),
      isShowSaveButton: true,
      isShowBackButton: false,
      isShowGenerateInvoiceButton: false,
      isShowUpdateInvoiceButton: false,
      isShowPrintLabelButton: false,
      isShowPackingListButton: false,
      isShowSyncButton: true,
      isReadOnlyOrDisabled: false,
      isSpecialViewMode: false,
      moduleForPopup: [],
      isShowLinePopup: false,
      isShowBoxPopup: false,
      isShowRatePopup: false,
      simplePopupContent: [],
      alertMessage: [],
      alertType: "",
      isShowAlert: false,
      pickTicketLookupHandler: null,
      isShowModuleSearchContainer: false,
      moduleKeyCode: NEW_ENTRY,
      isResetModule: false,
      moduleOrderStatus: "",
      disabled: false,
      isResetView: false,
      isFocus: false,
      isFocusLookup: true,
      isShowMailPackingButton: false,
      isShowExcelPackingButton: false,
      order: "asc",
      sortField: "",
      mailInfoData: new MailInfoBean(),
      isShowMailPickTicketPopup: false,
      isShowOpenInvoicesPopup: false,
      isMaintenanceMode: true,
      isDisabledFields: false,
      showAutoCompleteShipToList: true,
      shipToPageListForAutoCompleteList: new Array(),
      showAutoCompleteBoxTypeList: true,
      boxTypePageListForAutoCompleteList: new Array(),
      isShowRollPopup: false,
      pickTicketRollLineData: new PickTicketRollLineBean(),
      rollList: [],
      selectedRollLines: [],
      isShowRollPopupAlert: false,
      isShowPopupAlert: false,
      isShowAlertLvl3: false,
      isShowLvl3Alert: false,
      isShowShippingButton: false,
      isShowAdvanceSearchPopup: false,
      isAdvanceSearch: false,
      selectedLines: [],
      isShowShipperPopup: false,
      isShowPackerPopup: false,
      isShowAlertLvl7: false,
      shipperAndPackerData: new PickTicketBean(),
      is3PL: false,
      showAutoCompleteShipViaList: false,
      shipViaPageListForAutoCompleteList: new Array(),
      showAutoCompleteFreightMethodList: false,
      freightMethodPageListForAutoCompleteList: new Array(),
      showAutoCompleteLogisticList: false,
      logisticPageListForAutoCompleteList: new Array(),
      showAutoCompleteCityList: false,
      cityPageListForAutoCompleteList: new Array(),
      showAutoCompleteStateList: false,
      statePageListForAutoCompleteList: new Array(),
      showAutoCompleteCountryList: false,
      countryPageListForAutoCompleteList: new Array(),
      isShowInvoiceModule: false,
      selectedRowDataList: new Array(),
      isShowCancelReasonPopup: false,
      showAutoCompleteReasonList: false,
      reasonPageListForAutoCompleteList: new Array(),
      isShowPalletPopup: false,
      isShowAlertLvl5: false,
      palletData: new PickTicketBoxPalletLineDetailBean(),
      palletPtLineLookupHandler: null,
      showAutoCompletePtLineList: false,
      ptLinePageListForAutoCompleteList: new Array(),
      palletLines: new Array(),
      isShowPalletSummary: false,
      palletSummary_List: new Array(),
      isShowAlertLvl4: false,
      isReseted: false,
      isViewMode: false,
      isShowSalesModule: false,
      isShowPtLnPalletDetailsPopup: false,
      ptLnPalletData: new PickTicketLinePalletDetailBean(),
      ptLnPalletLines: new Array(),
      isShowPtlnPalletEntyPopup: false,
      weightUOMs: new Array(),
      lengthUOMs: new Array(),
      showAutoCompleteWeightUomList: false,
      weightUomPageListForAutoCompleteList: new Array(),

      showAutoCompleteDimensionUomList: false,
      dimensionUomPageListForAutoCompleteList: new Array(),
      pt_rollLines: new Array(),

      locations: [],
      locationPageListForAutoCompleteList: new Array(),
      showAutoCompleteLocationList: true,

      _pickTicketLine: new PickTicketLineBean(),
    };
  }
  code = NEW_ENTRY;
  isLocked = false;
  componentDidMount() {
    const { appData } = this.context;
    this.companyCode = appData.companyCode;
    this.report_url = appData.reportURL;
    const { cache } = appData;
    this.cache = cache;
    if (ConfigManager.isPurchaseBasedOnCustomerFlag()) {
      this.setState({
        is3PL: true,
      });
    }
    ModuleUtils.getPickTicketStatusList();
    ModuleUtils.getInvoiceStatusList();
    this.state.pickTicketCriteria = new PickTicketSearchCriteria();
    this.state.pickTicketCriteria.companyCode = this.companyCode;
    this.state.pageList = new PageListBean();
    this.state.pageList.pageSize = 50;

    this.loadCacheDetails();
    let isReadOnly = this.state.isReadOnlyOrDisabled;
    let isSpecialViewMode = this.state.isSpecialViewMode;

    if (this.props.isSpecialViewMode) {
      isSpecialViewMode = this.props.isSpecialViewMode;
      isReadOnly = this.props.isSpecialViewMode;
    }

    this.setState({
      isReadOnlyOrDisabled: isReadOnly,
      isSpecialViewMode: isSpecialViewMode,
      isResetView: false,
    });

    if (
      this.props.pickTicketCode !== "" &&
      this.props.pickTicketCode !== undefined
    ) {
      this.code = this.props.pickTicketCode;
      this.editPickTicket(this.props.pickTicketCode);

      this.setState({
        isResetView: false,
        isMaintenanceMode: false,
        isDisabledFields: true,
        isDisableFields: true,
        disablePurchaseOrderFormFields: true,
        isViewMode: false,
      });
    } else {
      // this.loadPickTickets();
    }
    this.initLookupHandlers();
    this.loadPage();
  }
  initLookupHandlers = () => {
    let pickTicketLookupHandler = new PickTicketLookupHandler(
      this.companyCode,
      "PickTicket"
    );
    this.setState({ pickTicketLookupHandler: pickTicketLookupHandler });

    let boxTypeLookupHandler = new GenericAttributeLookupHandler(
      this.state.boxTypes,
      "BoxType"
    );
    this.setState({ boxTypeLookupHandler: boxTypeLookupHandler });

    let ptWeightUOMLookupHandler = new GenericAttributeLookupHandler(
      this.state.weightUOMs,
      "WEIGHT UOM"
    );
    this.setState({
      ptWeightUOMLookupHandler: ptWeightUOMLookupHandler,
    });
    let dimensionUOMLookupHandler = new GenericAttributeLookupHandler(
      this.state.lengthUOMs,
      "LENGTH UOM"
    );
    this.setState({
      dimensionUOMLookupHandler: dimensionUOMLookupHandler,
    });
  };
  loadCacheDetails = () => {
    // let attribute_cache = JSON.parse(localStorage.getItem("attributeCache"));
    const attribute_cache = { ...this.cache };

    const shipVias = new Array();
    if (!isEmptyArray(attribute_cache.shipVias))
      shipVias.push(...attribute_cache.shipVias);
    this.state.shipVias = shipVias;

    const logisticMethods = new Array();
    if (!isEmptyArray(attribute_cache.logisticMethods))
      logisticMethods.push(...attribute_cache.logisticMethods);
    this.state.logisticMethods = logisticMethods;

    const freightMethods = new Array();
    if (!isEmptyArray(attribute_cache.freightMethods))
      freightMethods.push(...attribute_cache.freightMethods);
    this.state.freightMethods = freightMethods;

    const cityList = new Array();
    if (!isEmptyArray(attribute_cache.cities))
      cityList.push(...attribute_cache.cities);
    this.state.cityList = cityList;

    const stateList = new Array();
    if (!isEmptyArray(attribute_cache.states))
      stateList.push(...attribute_cache.states);
    this.state.stateList = stateList;

    const countryList = new Array();
    if (!isEmptyArray(attribute_cache.countries))
      countryList.push(...attribute_cache.countries);
    this.state.countryList = countryList;

    const boxTypes = new Array();
    if (!isEmptyArray(attribute_cache.boxTypes))
      boxTypes.push(...attribute_cache.boxTypes);
    this.state.boxTypes = boxTypes;

    const cancelReasons = new Array();
    if (!isEmptyArray(attribute_cache.salesOrderCancelReasons))
      cancelReasons.push(...attribute_cache.salesOrderCancelReasons);
    this.state.cancelReasons = boxTypes;

    const warehouses = new Array();
    if (!isEmptyArray(attribute_cache.warehouses))
      warehouses.push(...attribute_cache.warehouses);
    this.state.locations = warehouses;

    const countUOMs = new Array();
    const lengthUOMs = new Array();
    const weightUOMs = new Array();
    if (!isEmptyArray(attribute_cache.uoms)) {
      attribute_cache.uoms.map((x) => {
        if (x.uomType === COUNTABLE_UOM_TYPE) countUOMs.push(x);
        if (x.uomType === LENGTH_UOM_TYPE) lengthUOMs.push(x);
        if (x.uomType === WEIGHT_UOM_TYPE) weightUOMs.push(x);
      });
    }
    this.state.countUOMs = countUOMs;
    this.state.lengthUOMs = lengthUOMs;
    this.state.weightUOMs = weightUOMs;
  };

  loadPickTicketsResponse = (response) => {
    let pickTicketList = new Array();
    if (!isEmpty(response.data) && !isEmpty(response.data.pickTicketPageList)) {
      pickTicketList = response.data.pickTicketPageList.pickTickets;
      this.state.pageList.totalCount =
        response.data.pickTicketPageList.totalCount;
      this.state.pageList.currentPage =
        response.data.pickTicketPageList.currentPage;
    } else {
      pickTicketList = new Array();
    }
    let loading = this.state.isLoading;
    loading = false;

    this.setState({
      isLoading: loading,
      pickTicketList: pickTicketList,
    });
  };
  loadPickTicketsError = (error) => {
    ShowError("Error : ", error);
  };
  loadPickTickets = () => {
    let requestInput = new RestPickTicketListRequest();
    requestInput.pageInput = this.state.pageList;
    requestInput.searchCriteria = this.state.pickTicketCriteria;
    this.setState({
      isLoading: true,
      isResetView: false,
      isMaintenanceMode: false,
    });
    if (SecurityAccessManager.PickticketMaintenanceView_IsAccessible()) {
      PickTicketService.getPickTicketPageList(
        requestInput,
        this.loadPickTicketsResponse,
        this.loadPickTicketsError
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };

  //#region Paging Related
  loadFirst = () => {
    this.loadPage(1);
  };

  loadPrevious = () => {
    let currentPage = this.state.pageList.currentPage;
    let previousPage = currentPage - 1;
    this.loadPage(previousPage);
  };

  loadNext = () => {
    let currentPage = this.state.pageList.currentPage;
    let nextPage = currentPage + 1;
    this.loadPage(nextPage);
  };

  loadLast = () => {
    let pageSize = this.state.pageList.pageSize;
    let totalCount = this.state.pageList.totalCount;
    let totalPages = totalCount / pageSize;
    totalPages += totalCount % pageSize == 0 ? 0 : 1;
    //totalPages = totalPages.toFixed(1);
    this.loadPage(totalPages);
  };
  loadPage = (pageNumber) => {
    let pageInput = new PageListBean();
    pageInput.pageSize = 50;
    pageInput.currentPage = pageNumber;
    this.state.pageList = pageInput;
    this.loadPickTickets();
  };
  filterPickTicket = () => {
    this.loadPage(1);
  };

  resetFilteredPickTicket = (criteria) => {
    criteria = new PickTicketSearchCriteria();
    criteria.companyCode = this.companyCode;

    this.state.pickTicketCriteria = criteria;
    this.setState({ criteria: criteria });
    this.loadPage(1);
  };
  //#endregion

  //#region Edit PickTicket
  editPickTicketResponse = (response) => {
    this.setState({
      isLoading: false,
      loadingText: "",
    });
    if (response.data.lockResponse != null) {
      if (!isEmpty(response.data.lockResponse.errors)) {
        this.showErrorMessage(response.data.lockResponse);
        this.state.isViewMode = true;
      }
    }
    if (response.data.mainOperationResponse != null) {
      const pickTicket = response.data.mainOperationResponse.pickTicket;
      let isDisableFields = false;

      //this.state.moduleCaption = "PickTicket";
      let pageTitle = this.state.moduleCaption + " - EDIT";

      if (pickTicket !== null) {
        let moduleKeyCode = pickTicket.code;
        let shipperAndPackerData = new PickTicketBean();
        shipperAndPackerData.packedUpBy = pickTicket.packedUpBy;
        shipperAndPackerData.packedUpDate = pickTicket.packedUpDate;
        shipperAndPackerData.shippedBy = pickTicket.shippedBy;
        shipperAndPackerData.shippedDate = pickTicket.shippedDate;
        if (
          pickTicket.status ==
            LogicConstants.PICKTICKET_PARTIALLY_INVOICED_STATUS ||
          pickTicket.status == LogicConstants.PICKTICKET_INVOICED_STATUS ||
          pickTicket.status == LogicConstants.PICKTICKET_CANCEL_STATUS
        ) {
          isDisableFields = true;
          pageTitle = this.state.moduleCaption + " - VIEW";
        }

        if (pickTicket.isFetched) isDisableFields = true;
        let dependenciesBean = null;
        if (response.data.pickTicketDependencyResponse != null) {
          dependenciesBean =
            response.data.pickTicketDependencyResponse
              .pickTicketModuleDependencyBean;
        }
        let shipTos = [];
        if (
          !isEmpty(dependenciesBean) &&
          !isEmpty(dependenciesBean.customer) &&
          !isEmptyArray(dependenciesBean.customer.shipTos)
        ) {
          shipTos = dependenciesBean.customer.shipTos;
        }
        this.state.pickTicketData = pickTicket;

        this.setState({
          pickTicketData: pickTicket,
          shipperAndPackerData: shipperAndPackerData,
          pageTitle: pageTitle,
          isDisableFields: isDisableFields,
          isShowNodes: true,
          pickTicketListUpdateNeeded: true,
          moduleKeyCode: moduleKeyCode,
          dependenciesBean: dependenciesBean,
          shipTos: shipTos,
          isListFormOpen: false,
          isFocusLookup: false,
          isFocus: true,
        });
        this.isLocked = true;
        this.getNodeList();

        this.openEntryForm();
      } else {
        //New PickTicket not Permitable
      }
    }
  };

  editPickTicketError = (error) => {
    this.setState({
      isLoading: false,
      loadingText: "",
    });
    ShowError("Error : ", error);
  };
  editPickTicket = (pickTicketNumber) => {
    this.setState({
      isLoading: true,
    });
    let readrestInput = new RestReadRequest();
    readrestInput.companyCode = this.companyCode;
    readrestInput.code = pickTicketNumber;
    // readrestInput.isLockRequired = true;
    let isLockRequired = NEW_ENTRY === pickTicketNumber ? false : true;
    readrestInput.isLockRequired = isLockRequired;
    this.state.isDisableFields = true;
    this.setState({
      pickTicketListUpdateNeeded: false,
    });
    if (SecurityAccessManager.PickticketMaintenance_IsAccessible()) {
      PickTicketService.initPickTicketModule(
        readrestInput,
        this.editPickTicketResponse,
        this.editPickTicketError
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };

  onMailChange = (e) => {
    let temp_mailData = this.state.mailInfoData;
    temp_mailData[e.target.name] = e.target.value;

    this.setState({ mailInfoData: temp_mailData });
  };

  onChange = (e) => {
    let temp_pickTicketData = this.state.pickTicketData;
    temp_pickTicketData[e.target.name] = e.target.value;
    // if (e.target.name == "shipToCode") {
    //   this.onShipToCodeChange(e.target.value);
    // }
    this.setState({ pickTicketData: temp_pickTicketData });
  };

  locationCodeOnChange = (e) => {
    let locationCode = e.target.value;
    this.state.showAutoCompleteLocationList = true;
    let temp_criteria = this.state.pickTicketData;
    let showAutoCompleteList = this.state.showAutoCompleteLocationList;
    if (isEmpty(locationCode)) {
      this.state.showAutoCompleteLocationList = false;
      let showAutoCompleteList = this.state.showAutoCompleteLocationList;
      let criteria = this.state.pickTicketData;
      criteria.prefferedLocationCode = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteLocationList: showAutoCompleteList,
        pickTicketData: criteria,
        locationPageListForAutoCompleteList: suggestion,
        locationData: null,
      });
    } else if (showAutoCompleteList === true && locationCode !== "") {
      this.readLocationBySearchString(locationCode);
    }
    temp_criteria[e.target.name] = e.target.value;
    this.setState({ pickTicketData: temp_criteria });
    this.readLocation(locationCode);
  };

  readLocation = (locationCode) => {
    let locationBean = null;
    let locationData = null;
    this.state.locations.map((ln) => {
      if (ln.code === locationCode) {
        locationBean = ln;

        locationData = new BaseBean();
        locationData.code = ln.code;
        locationData.description = ln.description;
      }
    });
    if (!isEmpty(locationBean)) {
      let temp_criteria = this.state.pickTicketData;
      temp_criteria.prefferedLocationCode = locationBean.code;
      this.state.showAutoCompleteLocationList = false;
      let showAutoCompleteList = this.state.showAutoCompleteLocationList;
      this.setState({
        pickTicketData: temp_criteria,
        showAutoCompleteList: showAutoCompleteList,
      });
    }
    this.setState({ locationList: locationBean, locationData: locationData });
  };
  readLocationBySearchString = (searchString) => {
    let locationData = this.state.locations;
    let simpleAutoCompleteList = new Array();
    if (locationData.length > 0 && locationData != null) {
      locationData.map((sp) => {
        let locationBean = {
          code: sp.code,
          description: sp.description,
        };
        simpleAutoCompleteList.push(locationBean);
      });
    }
    let userInput = searchString;
    let filteredSuggestions = new Array();
    filteredSuggestions = simpleAutoCompleteList.filter(
      (autoList) =>
        autoList.code.toLowerCase().indexOf(userInput.toLowerCase()) > -1
    );
    this.setState({
      locationPageListForAutoCompleteList: filteredSuggestions,
    });
  };
  locationEnterKeyEventHandler = (e) => {
    let locationCode = e.target.value;
    this.readLocation(locationCode);
    this.setState({
      locationPageListForAutoCompleteList: new Array(),
    });
  };
  displayAutoCompleteLocationList = (showAutoCompleteList) => {
    this.setState({ showAutoCompleteLocationList: showAutoCompleteList });
  };

  onShipViaChange = (e) => {
    let shipViaCode = e.target.value;
    this.state.showAutoCompleteShipViaList = true;

    let temp_pickTicketData = this.state.pickTicketData;
    let showAutoCompleteList = this.state.showAutoCompleteShipViaList;

    if (isEmptyString(shipViaCode)) {
      this.state.showAutoCompleteShipViaList = false;
      let showAutoCompleteList = this.state.showAutoCompleteShipViaList;
      let temp_pickTicketData = this.state.pickTicketData;
      temp_pickTicketData.shipViaCode = "";
      let suggestion = [];

      this.setState({
        showAutoCompleteList: showAutoCompleteList,
        pickTicketData: temp_pickTicketData,
        shipViaPageListForAutoCompleteList: suggestion,
      });
    } else if (showAutoCompleteList === true && shipViaCode !== "") {
      this.readShipViaBySearchString(shipViaCode);
    }
    if (e.target.name == "shipViaCode") {
      temp_pickTicketData["shipViaCode"] = e.target.value;
      let shipViaList = this.state.shipVias;
      shipViaList.map((pdtType) => {
        if (pdtType.code == e.target.value) {
          temp_pickTicketData["shipViaCode"] = pdtType.code;
          this.state.showAutoCompleteShipViaList = false;
          let showAutoCompleteList = this.state.showAutoCompleteShipViaList;
          this.setState({ showAutoCompleteShipViaList: showAutoCompleteList });
        }
      });
    }

    this.setState({
      pickTicketData: temp_pickTicketData,
    });
  };
  readShipViaBySearchString(searchString) {
    let shipViaData = this.state.shipVias;
    let simpleAutoCompleteList = new Array();
    if (shipViaData.length > 0 && shipViaData != null) {
      shipViaData.map((shipVias) => {
        let simpleItemBean = {
          code: shipVias.code,
          description: shipVias.description,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    let userInput = searchString;

    let filteredSuggestions = new Array();

    filteredSuggestions = simpleAutoCompleteList.filter(
      (simpleAutoCompleteShipToLists) =>
        simpleAutoCompleteShipToLists.code
          .toLowerCase()
          .indexOf(userInput.toLowerCase()) > -1
    );
    this.setState({ shipViaPageListForAutoCompleteList: filteredSuggestions });
  }
  shipViaEnterKeyEventHandler = (e) => {
    let pickTicketData = this.state.pickTicketData;
    pickTicketData["shipViaCode"] = e.target.value;
    let shipViaCode_List = this.state.shipVias;
    let shipViaCodeBean = null;
    shipViaCode_List.map((ship) => {
      if (ship.code == e.target.value) {
        shipViaCodeBean = ship;
      }
    });
    if (!isEmpty(shipViaCodeBean)) {
      let pickTicketData = this.state.pickTicketData;
      pickTicketData.shipViaCode = shipViaCodeBean.code;

      this.setState({
        pickTicketData: pickTicketData,
        shipViaPageListForAutoCompleteList: new Array(),
      });
    }
  };

  displayAutoCompleteShipViaList = (showAutoCompleteList) => {
    this.setState({ showAutoCompleteShipViaList: showAutoCompleteList });
  };
  onLogisticMethodCodeChange = (e) => {
    let logisticMethodCode = e.target.value;
    this.state.showAutoCompleteLogisticList = true;

    let temp_pickTicketData = this.state.pickTicketData;
    let showAutoCompleteList = this.state.showAutoCompleteLogisticList;

    if (isEmpty(logisticMethodCode)) {
      this.state.showAutoCompleteLogisticList = false;
      let showAutoCompleteList = this.state.showAutoCompleteLogisticList;
      let temp_pickTicketData = this.state.pickTicketData;
      temp_pickTicketData.logisticMethodCode = "";
      let suggestion = [];

      this.setState({
        showAutoCompleteLogisticList: showAutoCompleteList,
        pickTicketData: temp_pickTicketData,
        logisticPageListForAutoCompleteList: suggestion,
      });
    } else if (showAutoCompleteList === true && logisticMethodCode !== "") {
      this.readLogisticMethodBySearchString(logisticMethodCode);
    }
    if (e.target.name == "logisticMethodCode") {
      temp_pickTicketData[e.target.name] = e.target.value;
      let logisticMethodList = this.state.logisticMethods;
      logisticMethodList.map((log) => {
        if (log.code == e.target.value) {
          temp_pickTicketData["logisticMethodCode"] = log.code;
          this.state.showAutoCompleteLogisticList = false;
          let showAutoCompleteList = this.state.showAutoCompleteLogisticList;
          this.setState({
            showAutoCompleteLogisticList: showAutoCompleteList,
          });
        }
      });
    }

    this.setState({
      pickTicketData: temp_pickTicketData,
    });
  };
  readLogisticMethodBySearchString(searchString) {
    let logisticMethodData = this.state.logisticMethods;
    let simpleAutoCompleteList = new Array();
    if (logisticMethodData.length > 0 && logisticMethodData != null) {
      logisticMethodData.map((logMethods) => {
        let simpleItemBean = {
          code: logMethods.code,
          description: logMethods.description,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    let userInput = searchString;

    let filteredSuggestions = new Array();

    filteredSuggestions = simpleAutoCompleteList.filter(
      (simpleAutoCompleteLogisticLists) =>
        simpleAutoCompleteLogisticLists.code
          .toLowerCase()
          .indexOf(userInput.toLowerCase()) > -1
    );
    this.setState({
      logisticPageListForAutoCompleteList: filteredSuggestions,
    });
  }
  logisticEnterKeyEventHandler = (e) => {
    let pickTicketData = this.state.pickTicketData;
    pickTicketData["logisticMethodCode"] = e.target.value;
    let logisticMethodCode_List = this.state.logisticMethods;
    let logisticMethodCodeBean = null;
    logisticMethodCode_List.map((lm) => {
      if (lm.code == e.target.value) {
        logisticMethodCodeBean = lm;
      }
    });
    if (!isEmpty(logisticMethodCodeBean)) {
      let pickTicketData = this.state.pickTicketData;
      pickTicketData.logisticMethodCode = logisticMethodCodeBean.code;

      this.setState({
        pickTicketData: pickTicketData,
        logisticPageListForAutoCompleteList: new Array(),
      });
    }
  };

  displayAutoCompleteLogisticList = (showAutoCompleteList) => {
    this.setState({ showAutoCompleteLogisticList: showAutoCompleteList });
  };
  onFreightMethodChange = (e) => {
    let freightMethodCode = e.target.value;
    this.state.showAutoCompleteFreightMethodList = true;

    let temp_pickTicketData = this.state.pickTicketData;
    let showAutoCompleteList = this.state.showAutoCompleteFreightMethodList;

    if (isEmpty(freightMethodCode)) {
      this.state.showAutoCompleteFreightMethodList = false;
      let showAutoCompleteList = this.state.showAutoCompleteFreightMethodList;
      let temp_pickTicketData = this.state.pickTicketData;
      temp_pickTicketData.freightMethodCode = "";
      let suggestion = [];

      this.setState({
        showAutoCompleteList: showAutoCompleteList,
        pickTicketData: temp_pickTicketData,
        freightMethodPageListForAutoCompleteList: suggestion,
      });
    } else if (showAutoCompleteList === true && freightMethodCode !== "") {
      this.readFreightMethodBySearchString(freightMethodCode);
    }
    if (e.target.name == "freightMethodCode") {
      temp_pickTicketData[e.target.name] = e.target.value;
      let freightMethodList = this.state.freightMethods;
      freightMethodList.map((pdtType) => {
        if (pdtType.code == e.target.value) {
          temp_pickTicketData["freightMethodCode"] = pdtType.code;
          this.state.showAutoCompleteFreightMethodList = false;
          let showAutoCompleteList =
            this.state.showAutoCompleteFreightMethodList;
          this.setState({
            showAutoCompleteFreightMethodList: showAutoCompleteList,
          });
        }
      });
    }

    this.setState({
      pickTicketData: temp_pickTicketData,
    });
  };
  readFreightMethodBySearchString(searchString) {
    let freightMethodData = this.state.freightMethods;
    let simpleAutoCompleteList = new Array();
    if (freightMethodData.length > 0 && freightMethodData != null) {
      freightMethodData.map((freightMethods) => {
        let simpleItemBean = {
          code: freightMethods.code,
          description: freightMethods.description,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    let userInput = searchString;

    let filteredSuggestions = new Array();

    filteredSuggestions = simpleAutoCompleteList.filter(
      (simpleAutoCompleteShipToLists) =>
        simpleAutoCompleteShipToLists.code
          .toLowerCase()
          .indexOf(userInput.toLowerCase()) > -1
    );
    this.setState({
      freightMethodPageListForAutoCompleteList: filteredSuggestions,
    });
  }
  freightMethodEnterKeyEventHandler = (e) => {
    let pickTicketData = this.state.pickTicketData;
    pickTicketData["freightMethodCode"] = e.target.value;
    let freightMethodCode_List = this.state.freightMethods;
    let freightMethodCodeBean = null;
    freightMethodCode_List.map((fm) => {
      if (fm.code == e.target.value) {
        freightMethodCodeBean = fm;
      }
    });
    if (!isEmpty(freightMethodCodeBean)) {
      let pickTicketData = this.state.pickTicketData;
      pickTicketData.freightMethodCode = freightMethodCodeBean.code;

      this.setState({
        pickTicketData: pickTicketData,
        freightMethodPageListForAutoCompleteList: new Array(),
      });
    }
  };

  displayAutoCompleteFreightMethodList = (showAutoCompleteList) => {
    this.setState({ showAutoCompleteFreightMethodList: showAutoCompleteList });
  };
  displayAutoCompleteShipToList = (showAutoCompleteList) => {
    this.setState({ showAutoCompleteShipToList: showAutoCompleteList });
  };

  onCityChange = (e) => {
    let city = e.target.value;
    this.state.showAutoCompleteCityList = true;
    let temp_PickticketData = this.state.pickTicketData;
    // temp_PickticketData.shipToAddress = new AddressBean();
    if (temp_PickticketData.shipToAddress == null) {
      temp_PickticketData.shipToAddress = new AddressBean();
    }
    let temp_addressData = this.state.addressData;
    temp_addressData = temp_PickticketData.shipToAddress;
    let showAutoCompleteList = this.state.showAutoCompleteCityList;
    if (isEmpty(city)) {
      this.state.showAutoCompleteCityList = false;
      let showAutoCompleteList = this.state.showAutoCompleteCityList;
      let addressData = this.state.addressData;
      addressData = temp_PickticketData.shipToAddress;
      addressData.city = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteCityList: showAutoCompleteList,
        addressData: addressData,
        cityPageListForAutoCompleteList: suggestion,
      });
    } else if (showAutoCompleteList === true && city !== "") {
      this.readcityBySearchString(city);
    }
    if (e.target.name == "city") {
      temp_addressData["city"] = e.target.value;
      let cityList = this.state.cityList;
      cityList.map((pdtType) => {
        if (pdtType.code == e.target.value) {
          temp_addressData["city"] = pdtType.code;
          this.state.showAutoCompleteCityList = false;
          let showAutoCompleteList = this.state.showAutoCompleteCityList;
          this.setState({ showAutoCompleteCityList: showAutoCompleteList });
        }
      });
    }
    temp_PickticketData.shipToAddress = temp_addressData;
    this.setState({
      pickTicketData: temp_PickticketData,
      addressData: temp_addressData,
    });
  };
  readcityBySearchString(searchString) {
    let cityData = this.state.cityList;
    let simpleAutoCompleteList = new Array();
    if (cityData.length > 0 && cityData != null) {
      cityData.map((cityDatas) => {
        let simpleItemBean = {
          code: cityDatas.code,
          description: cityDatas.description,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    let userInput = searchString;
    let filteredSuggestions = new Array();
    filteredSuggestions = simpleAutoCompleteList.filter(
      (simpleAutoCompletecityLists) =>
        simpleAutoCompletecityLists.code
          .toLowerCase()
          .indexOf(userInput.toLowerCase()) > -1
    );
    this.setState({ cityPageListForAutoCompleteList: filteredSuggestions });
  }
  cityEnterKeyEventHandler = (e) => {
    let city = e.target.value;
    let city_List = this.state.cityList;
    let cityBean = null;
    city_List.map((city) => {
      if (city.code == e.target.value) {
        cityBean = city;
      }
    });
    if (!isEmpty(cityBean)) {
      let temp_addressData = this.state.addressData;
      temp_addressData.city = cityBean.code;
      let temp_PickticketData = this.state.pickTicketData;
      temp_PickticketData.shipToAddress = temp_addressData;
      this.setState({
        addressData: temp_addressData,
        cityPageListForAutoCompleteList: new Array(),
        pickTicketData: temp_PickticketData,
      });
    }
  };
  displayAutoCompleteCityList = (showAutoCompleteList) => {
    this.setState({ showAutoCompleteCityList: showAutoCompleteList });
  };

  onStateChange = (e) => {
    let state = e.target.value;
    this.state.showAutoCompleteStateList = true;
    let temp_PickticketData = this.state.pickTicketData;
    // temp_PickticketData.shipToAddress = new AddressBean();
    if (temp_PickticketData.shipToAddress == null) {
      temp_PickticketData.shipToAddress = new AddressBean();
    }
    let temp_addressData = this.state.addressData;
    temp_addressData = temp_PickticketData.shipToAddress;
    let showAutoCompleteList = this.state.showAutoCompleteStateList;
    if (isEmpty(state)) {
      this.state.showAutoCompleteStateList = false;
      let showAutoCompleteList = this.state.showAutoCompleteStateList;
      let addressData = this.state.addressData;
      addressData = temp_PickticketData.shipToAddress;
      addressData.state = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteStateList: showAutoCompleteList,
        addressData: addressData,
        statePageListForAutoCompleteList: suggestion,
      });
    } else if (showAutoCompleteList === true && state !== "") {
      this.readStateBySearchString(state);
    }
    if (e.target.name == "state") {
      temp_addressData["state"] = e.target.value;
      let stateList = this.state.stateList;
      stateList.map((pdtType) => {
        if (pdtType.code == e.target.value) {
          temp_addressData["state"] = pdtType.code;
          this.state.showAutoCompleteStateList = false;
          let showAutoCompleteList = this.state.showAutoCompleteStateList;
          this.setState({ showAutoCompleteStateList: showAutoCompleteList });
        }
      });
    }
    temp_PickticketData.shipToAddress = temp_addressData;
    this.setState({
      pickTicketData: temp_PickticketData,
      addressData: temp_addressData,
    });
  };
  readStateBySearchString(searchString) {
    let stateData = this.state.stateList;
    let simpleAutoCompleteList = new Array();
    if (stateData.length > 0 && stateData != null) {
      stateData.map((stateDatas) => {
        let simpleItemBean = {
          code: stateDatas.code,
          description: stateDatas.description,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    let userInput = searchString;
    let filteredSuggestions = new Array();
    filteredSuggestions = simpleAutoCompleteList.filter(
      (simpleAutoCompletecityLists) =>
        simpleAutoCompletecityLists.code
          .toLowerCase()
          .indexOf(userInput.toLowerCase()) > -1
    );
    this.setState({ statePageListForAutoCompleteList: filteredSuggestions });
  }
  stateEnterKeyEventHandler = (e) => {
    let state = e.target.value;
    let state_List = this.state.stateList;
    let stateBean = null;
    state_List.map((state) => {
      if (state.code == e.target.value) {
        stateBean = state;
      }
    });
    if (!isEmpty(stateBean)) {
      let temp_addressData = this.state.addressData;
      temp_addressData.state = stateBean.code;
      let temp_PickticketData = this.state.pickTicketData;
      temp_PickticketData.shipToAddress = temp_addressData;
      this.setState({
        addressData: temp_addressData,
        statePageListForAutoCompleteList: new Array(),
        pickTicketData: temp_PickticketData,
      });
    }
  };
  displayAutoCompleteStateList = (showAutoCompleteList) => {
    this.setState({ showAutoCompleteStateList: showAutoCompleteList });
  };

  onCountryChange = (e) => {
    let country = e.target.value;
    this.state.showAutoCompleteCountryList = true;
    let temp_PickticketData = this.state.pickTicketData;
    // temp_PickticketData.shipToAddress = new AddressBean();
    if (temp_PickticketData.shipToAddress == null) {
      temp_PickticketData.shipToAddress = new AddressBean();
    }
    let temp_addressData = this.state.addressData;
    temp_addressData = temp_PickticketData.shipToAddress;
    let showAutoCompleteList = this.state.showAutoCompleteCountryList;
    if (isEmpty(country)) {
      this.state.showAutoCompleteCountryList = false;
      let showAutoCompleteList = this.state.showAutoCompleteCountryList;
      let addressData = this.state.addressData;
      addressData = temp_PickticketData.shipToAddress;
      addressData.country = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteCountryList: showAutoCompleteList,
        addressData: addressData,
        countryPageListForAutoCompleteList: suggestion,
      });
    } else if (showAutoCompleteList === true && country !== "") {
      this.readCountryBySearchString(country);
    }
    if (e.target.name == "country") {
      temp_addressData["country"] = e.target.value;
      let countryList = this.state.countryList;
      countryList.map((pdtType) => {
        if (pdtType.code == e.target.value) {
          temp_addressData["country"] = pdtType.code;
          this.state.showAutoCompleteCountryList = false;
          let showAutoCompleteList = this.state.showAutoCompleteCountryList;
          this.setState({ showAutoCompleteCountryList: showAutoCompleteList });
        }
      });
    }
    temp_PickticketData.shipToAddress = temp_addressData;
    this.setState({
      pickTicketData: temp_PickticketData,
      addressData: temp_addressData,
    });
  };
  readCountryBySearchString(searchString) {
    let stateData = this.state.countryList;
    let simpleAutoCompleteList = new Array();
    if (stateData.length > 0 && stateData != null) {
      stateData.map((stateDatas) => {
        let simpleItemBean = {
          code: stateDatas.code,
          description: stateDatas.description,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    let userInput = searchString;
    let filteredSuggestions = new Array();
    filteredSuggestions = simpleAutoCompleteList.filter(
      (simpleAutoCompletecityLists) =>
        simpleAutoCompletecityLists.code
          .toLowerCase()
          .indexOf(userInput.toLowerCase()) > -1
    );
    this.setState({ countryPageListForAutoCompleteList: filteredSuggestions });
  }
  countryEnterKeyEventHandler = (e) => {
    let country = e.target.value;
    let country_List = this.state.countryList;
    let countryBean = null;
    country_List.map((country) => {
      if (country.code == e.target.value) {
        countryBean = country;
      }
    });
    if (!isEmpty(countryBean)) {
      let temp_addressData = this.state.addressData;
      temp_addressData.country = countryBean.code;
      let temp_PickticketData = this.state.pickTicketData;
      temp_PickticketData.shipToAddress = temp_addressData;
      this.setState({
        addressData: temp_addressData,
        countryPageListForAutoCompleteList: new Array(),
        pickTicketData: temp_PickticketData,
      });
    }
  };
  displayAutoCompleteCountryList = (showAutoCompleteList) => {
    this.setState({ showAutoCompleteCountryList: showAutoCompleteList });
  };

  onShipToChange = (e) => {
    let shipToCode = e.target.value;
    this.state.showAutoCompleteShipToList = true;

    let temp_pickTicketData = this.state.pickTicketData;
    let showAutoCompleteList = this.state.showAutoCompleteShipToList;

    if (isEmpty(shipToCode)) {
      this.state.showAutoCompleteShipToList = false;
      let showAutoCompleteList = this.state.showAutoCompleteShipToList;
      let temp_pickTicketData = this.state.pickTicketData;
      temp_pickTicketData.shipToCode = "";
      temp_pickTicketData.shipToAddress = new AddressBean();
      let suggestion = [];

      this.setState({
        showAutoCompleteList: showAutoCompleteList,
        pickTicketData: temp_pickTicketData,
        shipToPageListForAutoCompleteList: suggestion,
      });
    } else if (showAutoCompleteList === true && shipToCode !== "") {
      this.readShipToBySearchString(shipToCode);
    }
    if (e.target.name == "shipToCode") {
      temp_pickTicketData[e.target.name] = e.target.value;
      this.readShipTo(shipToCode);
    }

    this.setState({
      pickTicketData: temp_pickTicketData,
    });
  };
  readShipTo = (code) => {
    let temp_pickTicketData = this.state.pickTicketData;
    let shipToList = this.state.shipTos;
    let shipToBean = null;
    if (shipToList != null) {
      shipToList.map((pdtType) => {
        if (pdtType.code == code) {
          shipToBean = pdtType;
          temp_pickTicketData["shipToCode"] = pdtType.code;
          temp_pickTicketData["shipToName"] = pdtType.description;
          temp_pickTicketData.shipViaCode = shipToBean.shipViaCode;
          if (!isEmpty(shipToBean.address)) {
            let address = new AddressBean();
            address.address1 = shipToBean.address.address1;

            address.address1 = shipToBean.address.address1;
            address.address2 = shipToBean.address.address2;
            address.address3 = shipToBean.address.address3;
            address.city = shipToBean.address.city;
            address.country = shipToBean.address.country;
            address.state = shipToBean.address.state;
            address.zip = shipToBean.address.zip;
            address.phone1 = shipToBean.address.phone1;
            address.phone2 = shipToBean.address.phone2;
            address.mobilePhone = shipToBean.address.mobilePhone;
            temp_pickTicketData.shipToAddress = address;
          }
        }
      });
    }
    this.setState({ pickTicketData: temp_pickTicketData });
  };
  readShipToBySearchString(searchString) {
    let shipToData = this.state.shipTos;
    let simpleAutoCompleteList = new Array();
    if (shipToData.length > 0 && shipToData != null) {
      shipToData.map((shipTos) => {
        let simpleItemBean = {
          code: shipTos.code,
          description: shipTos.description,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    let userInput = searchString;

    let filteredSuggestions = new Array();

    filteredSuggestions = simpleAutoCompleteList.filter(
      (simpleAutoCompleteShipToLists) =>
        simpleAutoCompleteShipToLists.code
          .toLowerCase()
          .indexOf(userInput.toLowerCase()) > -1
    );
    this.setState({ shipToPageListForAutoCompleteList: filteredSuggestions });
  }
  shipToEnterKeyEventHandler = (e) => {
    let temp_pickTicketData = this.state.pickTicketData;
    temp_pickTicketData[e.target.name] = e.target.value;
    this.readShipTo(e.target.value);
    this.setState({
      pickTicketData: temp_pickTicketData,
      shipToPageListForAutoCompleteList: new Array(),
    });
  };
  onShipToCodeChange = (shipToCode) => {
    let shipToBean = null;
    this.state.shipTos.map((ln) => {
      if (ln.code === shipToCode) {
        shipToBean = ln;
      }
    });
    if (!isEmpty(shipToBean)) {
      let temp_pickTicketData = this.state.pickTicketData;
      temp_pickTicketData.shipToName = shipToBean.description;

      temp_pickTicketData.shipViaCode = shipToBean.shipViaCode;
      if (!isEmpty(shipToBean.address)) {
        let address = new AddressBean();
        address.address1 = shipToBean.address.address1;

        address.address1 = shipToBean.address.address1;
        address.address2 = shipToBean.address.address2;
        address.address3 = shipToBean.address.address3;
        address.city = shipToBean.address.city;
        address.country = shipToBean.address.country;
        address.state = shipToBean.address.state;
        address.zip = shipToBean.address.zip;
        address.phone1 = shipToBean.address.phone1;
        address.phone2 = shipToBean.address.phone2;
        address.mobilePhone = shipToBean.address.mobilePhone;
        temp_pickTicketData.shipToAddress = address;
      }

      this.setState({ pickTicketData: temp_pickTicketData });
    }
  };

  onShipToAddressChange = (e) => {
    let temp_pt = this.state.pickTicketData;
    let tempAddress = new AddressBean();
    if (!isEmpty(temp_pt) && !isEmpty(temp_pt.shipToAddress)) {
      tempAddress = temp_pt.shipToAddress;
      tempAddress[e.target.name] = e.target.value;
    }
    temp_pt.shipToAddress = tempAddress;
    this.setState({ pickTicketData: temp_pt });
  };

  onLineChange = (e) => {
    let temp_pickTicketLineData = this.state.pickTicketLineData;
    temp_pickTicketLineData[e.target.name] = e.target.value;

    this.setState({ pickTicketLineData: temp_pickTicketLineData });
  };
  /* open PickTicket entry form*/
  openEntryForm = () => {
    this.clearError();
    let pickTicketData = this.state.pickTicketData;
    this.closeAllNodeViews();
    this.setState({
      isListFormOpen: false,
      isEntryFormOpen: true,
      isShowClearCriteriaButton: false,
      isShowClearErrorButton: true,
      isShowBackButton: true,
      isShowPDFReportButton: true,
      isShowApproveButton: false,
      isShowUnApproveButton: false,
      isShowGenerateInvoiceButton: false,
      isShowUpdateInvoiceButton: false,
      isShowCancelButton: true,
      isShowSaveButton: true,
      // isShowPrintLabelButton: true,
      isShowModuleSearchContainer: true,
      pickTicketLineData: new PickTicketLineBean(),
      isResetCustomerDynamicAutoComplete: false,
      isShowNodes: true,
      isResetView: false,
      isShowShippingButton: false,
    });
    if (this.state.isSpecialViewMode == false) {
      this.setState({
        isResetView: true,
        isMaintenanceMode: true,
        isListFormOpen: false,
        disabled: false,
        isDisableNodeFields: false,
        isDisabledFields: false,
        isDisableFields: false,
      });
      if (this.state.isViewMode) {
        let pageTitle = this.state.moduleCaption + " - VIEW";
        this.setState({
          disabled: true,
          isDisableNodeFields: true,
          isDisabledFields: true,
          isDisableFields: true,
          pageTitle: pageTitle,
        });
      }
    } else {
      this.setState({
        isDisabledFields: true,
        isDisableFields: true,
        disabled: true,
      });
    }
    if (this.state.moduleKeyCode != NEW_ENTRY) {
      this.setState({ disabled: true });
    }
    //set button visibility for PickTicketModuleToolBar using PickTicket Status
    //TO:DO :- visibility using lock
    this.initModuleButtons();

    this.getNodeList();
  };

  initModuleButtons = () => {
    let pickTicketData = this.state.pickTicketData;
    if (pickTicketData.status == LogicConstants.PICKTICKET_UNAPPROVE_STATUS) {
      this.setState({
        isShowCancelButton: true,
        isDisableFields: false,
        isShowSaveButton: true,
        disableUpdatableFields: false,
        isShowPackingListButton: false,
        isDisabledFields: false,
        isShowSyncButton: true,
        isShowPrintLabelButton: false,
      });
    } else if (
      pickTicketData.status == LogicConstants.PICKTICKET_APPROVE_STATUS
    ) {
      this.setState({
        isShowCancelButton: false,
        isDisableFields: false,
        isShowSaveButton: true,
        isShowPackingListButton: false,
        isDisabledFields: false,
        isShowPrintLabelButton: true,
      });
    } else if (
      pickTicketData.status == LogicConstants.PICK_TICKET_PICKED_STATUS ||
      pickTicketData.status ==
        LogicConstants.PICK_TICKET_PARTIALLY_PICKED_STATUS
    ) {
      let generateInvoicePosible = true;
      let isCancelPosible = true;
      let isActiveInvoiceExist = false;
      let isShippingPosible = true;

      if (!pickTicketData.isPackedFlag) generateInvoicePosible = false;
      if (pickTicketData.isShippedFlag) isShippingPosible = false;
      isActiveInvoiceExist = this.isActiveInvoiceExist();
      if (isActiveInvoiceExist) {
        isCancelPosible = false;
        generateInvoicePosible = false;
      }

      this.setState({
        isShowGenerateInvoiceButton: generateInvoicePosible,
        isShowUpdateInvoiceButton: generateInvoicePosible,
        isShowCancelButton: isCancelPosible,
        isShowSaveButton: true,
        isShowPackingListButton: true,
        isShowMailPackingButton: true,
        isShowExcelPackingButton: true,
        isShowShippingButton: isShippingPosible,
        isDisabledFields: false,
        isShowSyncButton: true,
        isShowPrintLabelButton: true,
      });
    } else if (
      pickTicketData.status == LogicConstants.PICK_TICKET_CANCEL_STATUS
    ) {
      this.setState({
        isShowCancelButton: false,
        isShowGenerateInvoiceButton: false,
        isShowUpdateInvoiceButton: false,
        //isShowSaveButton: false,
        isShowPackingListButton: false,
        isShowMailPackingButton: false,
        isShowExcelPackingButton: false,
        isShowShippingButton: false,
        isDisabledFields: true,
        isShowSyncButton: false,
        isShowPrintLabelButton: true,
      });
    } else if (
      pickTicketData.status ==
        LogicConstants.PICK_TICKET_PARTIALLY_INVOICED_STATUS ||
      pickTicketData.status == LogicConstants.PICK_TICKET_PICKED_STATUS ||
      pickTicketData.status ==
        LogicConstants.PICK_TICKET_PARTIALLY_PICKED_STATUS
    ) {
      this.setState({
        isShowCancelButton: false,
        isShowSaveButton: true,
        isShowBackButton: false,
        isShowGenerateInvoiceButton: true,
        isShowUpdateInvoiceButton: true,
        isShowPackingListButton: true,
        isShowMailPackingButton: true,
        isShowExcelPackingButton: true,
        isShowShippingButton: true,
        isDisabledFields: false,
        isShowSyncButton: true,
        isShowPrintLabelButton: true,
      });
    } else if (
      pickTicketData.status == LogicConstants.PICK_TICKET_INVOICED_STATUS
    ) {
      this.setState({
        isShowCancelButton: false,
        //isShowSaveButton: false,
        isShowBackButton: false,
        isShowGenerateInvoiceButton: false,
        isShowUpdateInvoiceButton: false,
        disableUpdatableFields: true,
        isShowPackingListButton: true,
        isShowMailPackingButton: true,
        isShowExcelPackingButton: true,
        isDisabledFields: true,
        isShowSyncButton: false,
        isShowPrintLabelButton: true,
      });
    } else if (
      pickTicketData.status == LogicConstants.PICK_TICKET_FINISHED_STATUS
    ) {
      this.setState({
        isShowCancelButton: false,
        isShowSaveButton: false,
        isShowBackButton: false,
        isShowGenerateInvoiceButton: false,
        isShowUpdateInvoiceButton: false,
        isDisabledFields: true,
        isShowSyncButton: false,
        isShowPrintLabelButton: true,
      });
    }
    if (this.state.isViewMode) {
      this.setState({
        disabled: true,
        isDisableNodeFields: true,
        isDisabledFields: true,
        isDisableFields: true,
      });
    }
  };

  isActiveInvoiceExist = () => {
    let isActiveInvoiceExist = false;

    if (
      !isEmpty(this.state.dependenciesBean) &&
      !isEmptyArray(this.state.dependenciesBean.invoices)
    ) {
      this.state.dependenciesBean.invoices.map((pt) => {
        if (pt.invoiceStatus == LogicConstants.INVOICE_UNAPPROVE_STATUS)
          isActiveInvoiceExist = true;
        else if (pt.invoiceStatus == LogicConstants.INVOICE_APPROVE_STATUS)
          isActiveInvoiceExist = true;
        else if (
          pt.invoiceStatus == LogicConstants.INVOICE_PARTIALLY_PAID_STATUS
        )
          isActiveInvoiceExist = true;
      });
    }
    return isActiveInvoiceExist;
  };
  /* close PickTicket entry form*/

  closeEntryForm = () => {
    this.closeAllNodeViews();
    let pageTitle = this.state.moduleCaption;
    this.setState({
      isListFormOpen: true,
      isEntryFormOpen: false,
      isShowSaveButton: false,
      isShowClearCriteriaButton: false,
      isShowClearErrorButton: false,
      isShowPDFReportButton: false,
      isShowBackButton: false,
      sShowCancelButton: false,
      shipperAndPackerData: new PickTicketBean(),
      pageTitle: pageTitle,
      isShowNodes: false,

      errorList: [],
      isShowModuleSearchContainer: false,
      moduleKeyCode: NEW_ENTRY,
      disabled: false,
      isResetView: false,
      isMaintenanceMode: false,
      isDisabledFields: false,
      showAutoCompleteShipViaList: false,
      shipViaPageListForAutoCompleteList: new Array(),
      showAutoCompleteFreightMethodList: false,
      freightMethodPageListForAutoCompleteList: new Array(),
      showAutoCompleteCityList: false,
      cityPageListForAutoCompleteList: new Array(),
      showAutoCompleteStateList: false,
      statePageListForAutoCompleteList: new Array(),
      showAutoCompleteCountryList: false,
      countryPageListForAutoCompleteList: new Array(),
      isViewMode: false,
      isSpecialViewMode: false,
    });
    this.hideAlertCallBack();
  };
  //#endregion
  //#region Module
  startProgressBar = () => {
    this.setState({ isLoading: true });
  };
  stopProgressBar = () => {
    this.setState({ isLoading: false });
  };
  moduleExit = () => {
    let pickTicketData = this.state.pickTicketData;
    if (this.isLocked) {
      this.isLocked = false;
      if (!this.state.isViewMode) this.unLockPickTicket(pickTicketData.code);
    } else {
      this.isLocked = false;
    }
    this.props.onModuleExit();
  };
  clearError = () => {
    this.setState({ error_list: [] });
  };
  back = () => {
    if (this.state.pickTicketListUpdateNeeded) {
      this.loadPage(1);
    }
    this.closeEntryForm();
  };
  save = () => {
    this.savePickTicket();
  };
  onReasonDescChange = (e) => {
    let reasonData = this.state.reasonData;
    reasonData[e.target.name] = e.target.value;
    this.setState({ reasonData: reasonData });
  };
  onReasonChange = (e) => {
    let code = e.target.value;
    this.state.showAutoCompleteReasonList = true;

    let reasonData = this.state.reasonData;
    let showAutoCompleteList = this.state.showAutoCompleteReasonList;

    if (isEmpty(code)) {
      this.state.showAutoCompleteReasonList = false;
      let showAutoCompleteList = this.state.showAutoCompleteReasonList;
      let reason = this.state.reasonData;
      reason.code = "";
      reason.description = "";
      let suggestion = [];

      this.setState({
        showAutoCompleteReasonList: showAutoCompleteList,
        reasonData: reason,
        reasonPageListForAutoCompleteList: suggestion,
      });
    } else if (showAutoCompleteList === true && code !== "") {
      this.readReasonBySearchString(code);
    }
    if (e.target.name == "code") {
      reasonData["code"] = e.target.value;
      let reasonList = this.state.cancelReasons;
      reasonList.map((rsn) => {
        if (rsn.code == e.target.value) {
          reasonData["code"] = rsn.code;
          this.state.showAutoCompleteReasonList = false;
          let showAutoCompleteList = this.state.showAutoCompleteReasonList;
          this.setState({ showAutoCompleteReasonList: showAutoCompleteList });
        }
      });
    }

    this.setState({ reasonData: reasonData });
  };
  readReasonBySearchString(searchString) {
    let reasonData = this.state.cancelReasons;
    let simpleAutoCompleteList = new Array();
    if (reasonData.length > 0 && reasonData != null) {
      reasonData.map((reasons) => {
        let simpleItemBean = {
          code: reasons.code,
          description: reasons.description,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    let userInput = searchString;

    let filteredSuggestions = new Array();

    filteredSuggestions = simpleAutoCompleteList.filter(
      (simpleAutoCompleteLocationLists) =>
        simpleAutoCompleteLocationLists.code
          .toLowerCase()
          .indexOf(userInput.toLowerCase()) > -1
    );
    this.setState({ reasonPageListForAutoCompleteList: filteredSuggestions });
  }
  reasonEnterKeyEventHandler = (e) => {
    let reasonData = this.state.reasonData;
    let code = e.target.value;

    reasonData["code"] = e.target.value;
    let reasonList = this.state.cancelReasons;
    let reasonCodeBean = null;
    reasonList.map((rsn) => {
      if (rsn.code == e.target.value) {
        reasonCodeBean = rsn;
      }
    });
    if (!isEmpty(reasonCodeBean)) {
      let reasonData = this.state.reasonData;
      reasonData.code = reasonCodeBean.code;
      this.setState({
        reasonData: reasonData,
        reasonPageListForAutoCompleteList: new Array(),
      });
    }
  };
  displayAutoCompleteReasonList = (showAutoCompleteList) => {
    this.setState({ showAutoCompleteReasonList: showAutoCompleteList });
  };
  closeReasonModelCallBack = () => {
    this.setState({
      isShowCancelReasonPopup: false,
      reasonData: new ReasonBean(),
      showAutoCompleteReasonList: false,
      reasonPageListForAutoCompleteList: new Array(),
    });
  };
  openReasonCapture = (type) => {
    if (type === 1) {
      this.setState({
        isShowCancelReasonPopup: true,
      });
    } else if (type === 2) {
      this.setState({
        isShowUnApproveReasonPopup: true,
      });
    }
    this.setState({
      showAutoCompleteReasonList: false,
      reasonPageListForAutoCompleteList: new Array(),
    });
  };
  cancelPickTicket = () => {
    this.openReasonCapture(1);
  };

  onCancelReasonContinue = () => {
    this.saveCancelPickTicket();
    this.closeReasonModelCallBack();
  };

  saveCancelPickTicketResponse = (response) => {
    this.setState({ isLoading: false });
    let isSuccess = this.handleResponse(response.data);
    let soData = this.state.pickTicketData;
    if (isSuccess) {
      if (!isEmpty(response.data) && !isEmpty(response.data.pickTicket)) {
        let pickTicketBean = response.data.pickTicket;
        if (pickTicketBean != null) {
          this.setState({
            pickTicketData: pickTicketBean,
          });
          if (this.isLocked) {
            this.code = pickTicketBean.code;
            this.unLockPickTicket(pickTicketBean.code);
          }
        }
      }
    }
  };
  saveCancelPickTicketError = (error) => {
    this.setState({ isLoading: false });
    ShowError("Error : " + error);
  };
  saveCancelPickTicket = () => {
    this.setState({
      isLoading: true,
      loadingText: "Cancelling PickTicket",
    });
    let ptData = this.state.pickTicketData;
    let input = new RestPickTicketRequest();
    input.pickTicketBean = ptData;
    input.reason = this.state.reasonData;
    input.companyCode = this.companyCode;
    input.code = ptData.code;
    if (SecurityAccessManager.PickticketMaintenanceCancel_IsAccessible()) {
      PickTicketService.cancelPickTicket(
        input,
        this.saveCancelPickTicketResponse,
        this.saveCancelPickTicketError
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  isValidReason = () => {
    let isValid = true;
    let err_list = [];
    let errorMsg = "";
    if (isEmpty(this.state.reasonData)) {
      let errMsg = " Reason is Required";
      errorMsg = errorMsg + errMsg;
      err_list.push(errMsg);
    }
    if (isEmptyString(this.state.reasonData.code)) {
      let errMsg = " Reason is Required";
      errorMsg = errorMsg + errMsg;
      err_list.push(errMsg);
    }
    this.setState({
      alertMessage: err_list,
      alertType: "danger",
      isShowAlert: true,
    });
    //ShowError(errorMsg);
    //this.setState({ error_list: err_list });
    if (err_list.length > 0) isValid = false;

    return isValid;
  };

  generateInvoiceResponse = (response) => {
    this.setState({
      isLoading: false,
      loadingText: "",
    });
    let invoice = response.data.invoiceResponse;
    if (response.data != null) {
      this.handleResponse(response.data);
    }

    if (response.data.mainOperationResponse != null) {
      this.showErrorMessage(response.data.mainOperationResponse);
    }
    if (response.data.invoiceResponse != null) {
      let isSuccess = this.handleResponse(response.data.invoiceResponse);
      if (isSuccess) {
        let pickTicket = response.data.mainOperationResponse.pickTicket;
        if (response.data.mainOperationResponse != null && pickTicket != null) {
          this.setState({
            pickTicketData: pickTicket,
          });
          // this.unLockPickTicket(pickTicket.code, false);
          this.editPickTicket(pickTicket.code);
          // if(this.isLocked){
          //   this.code = pickTicket.code;
          //   this.unLockPickTicket(pickTicket.code);
          // }
        }
      }
    }
  };
  generateInvoiceError = (error) => {
    this.setState({
      isLoading: false,
      loadingText: "",
    });
    ShowError("Error : " + error);
  };
  generateInvoice = () => {
    this.setState({ isLoading: true, loadingText: "Generating Invoice" });
    let pickTicket = this.state.pickTicketData;
    pickTicket = this.preProcessSave(pickTicket);
    let request = new RestPickTicket_v1Request();
    request.companyCode = this.companyCode;
    request.code = pickTicket.code;
    request.pickTicketBean = pickTicket;
    request.isLockRequired = true;
    if (SecurityAccessManager.PickticketMaintenance_IsAccessible()) {
      PickTicketService.updatePickTicketAndCreateInvoice(
        request,
        this.generateInvoiceResponse,
        this.generateInvoiceError
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };

  savePickTicketResponse = (response) => {
    this.setState({
      isLoading: false,
      loadingText: "",
    });
    this.handleResponse(response.data);
    if (response.data != null && response.data.pickTicket != null) {
      const pickTicketBean = response.data.pickTicket;
      let pageTitle = this.state.moduleCaption + " - EDIT";
      this.setState({
        pickTicketData: pickTicketBean,
        pageTitle: pageTitle,
        isLoading: false,
        loadingText: "",
      });
      if (this.isLocked) {
        this.code = pickTicketBean.code;
        this.unLockPickTicket(pickTicketBean.code);
      }
    }
  };

  savePickTicketError = (error) => {
    this.setState({
      isLoading: false,
      loadingText: "",
    });
    ShowError("Error : " + error);
  };
  savePickTicket = () => {
    this.setState({
      isLoading: true,
      loadingText: "Saving ..",
    });
    let pickTicketData = { ...this.state.pickTicketData };
    // pickTicketData = this.preProcessSave(pickTicketData);
    if (pickTicketData.isFetched) {
      if (SecurityAccessManager.PickticketMaintenanceEdit_IsAccessible()) {
        PickTicketService.updatePickTicket(
          pickTicketData,
          this.savePickTicketResponse,
          this.savePickTicketError
        );
      } else {
        let errMsg = "Access Denied";
        let errList = [];
        errList.push(errMsg);
        this.setState({
          alertMessage: errList,
          alertType: "danger",
          isShowAlert: true,
        });
      }
    }
  };

  preProcessSave = (pickTicketData) => {
    if (
      !isEmpty(pickTicketData) &&
      !isEmptyArray(pickTicketData.pickTicketLines)
    ) {
      pickTicketData.pickTicketLines.map((ln) => {
        if (ln.rollLines != null) {
          ln.rollLines.map((rl) => {
            if (rl.isFetched == true) {
              rl.currentlyPickedQuantity = 0;
            }
          });
        }
      });
    }
    return pickTicketData;
  };
  generatePDFResponse = (response) => {
    this.setState({
      isLoading: false,
      loadingText: "",
    });
    let reportFilePath = response.data.reportResult.reportFileID;
    window.open(this.report_url + reportFilePath);
  };
  generatePDFError = (error) => {
    this.setState({
      isLoading: false,
      loadingText: "",
    });
    ShowError("Erro : " + error);
  };
  generatePDF = () => {
    this.setState({
      isLoading: true,
      loadingText: "Generating PDF",
    });
    let ptData = this.state.pickTicketData;
    if (SecurityAccessManager.PickticketMaintenanceReport_IsAccessible()) {
      ReportService.generatePickTicketPrintReport(
        ptData,
        this.generatePDFResponse,
        this.generatePDFError
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  generatePrintLabelResponse = (response) => {
    this.setState({
      isLoading: false,
      loadingText: "",
    });
    let reports = response.data.reportResult.reports;
    if (!isEmpty(reports)) {
      reports.map((line) => {
        if (line != null) {
          let reportFilePath = line.reportFileID;
          window.open(this.report_url + reportFilePath);
        }
      });
    }
  };
  generatePrintLabelError = (error) => {
    this.setState({
      isLoading: false,
      loadingText: "",
    });
    ShowError("Erro : " + error);
  };
  excelPacking = () => {
    this.setState({
      isLoading: true,
      loadingText: "Excel Packing",
    });
    let ptData = this.state.pickTicketData.code;
    let reportBean = new RestReportBean();
    reportBean.reportType = 2;

    let request = new PackingListPrintRequest();
    request.companyCode = this.companyCode;
    request.pickTicketNumber = ptData;
    request.reportBean = reportBean;
    request.isDirectPrint = true;
    if (SecurityAccessManager.PickticketMaintenance_IsAccessible()) {
      ReportService.generatePackingListPrintReport(
        request,
        this.excelPackingResponse,
        this.excelPackingError
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  excelPackingResponse = (response) => {
    this.setState({
      isLoading: false,
      loadingText: "",
    });
    let reportFilePath = response.data.reportResult.reportFileID;
    window.open(this.report_url + reportFilePath);
  };
  excelPackingError = (error) => {
    this.setState({
      isLoading: false,
      loadingText: "",
    });
    ShowError("Erro : " + error);
  };
  mailPacking = () => {
    this.setState({
      isLoading: true,
      loadingText: "Mail Packing",
    });
    let pickTicketData = this.state.pickTicketData;
    let request = new RestReadRequest();
    request.companyCode = this.companyCode;
    request.code = pickTicketData.code;
    if (SecurityAccessManager.PickticketMaintenance_IsAccessible()) {
      SalesOrderService.fetchPackingListMailDefaultInfoBean(
        request,
        this.mailInvoiceResponse,
        this.mailInvoiceError
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  mailInvoiceResponse = (response) => {
    this.setState({
      isLoading: false,
      loadingText: "",
    });
    let mailInfo = response.data.mailDefaultInfo;
    this.setState({
      mailInfoData: mailInfo,
      isShowMailPickTicketPopup: true,
    });
  };
  mailInvoiceError = (error) => {
    this.setState({
      isLoading: false,
      loadingText: "",
    });
  };
  mailInvoiceContinue = (e) => {
    if (e.detail === 1) {
      let request = new RestPackingListMailRequest();

      let mailInfoData = this.state.mailInfoData;

      let pickTicketData = this.state.pickTicketData;
      request.companyCode = this.companyCode;
      request.entityCode = pickTicketData.code;

      request.infoBean = mailInfoData;
      if (SecurityAccessManager.PickticketMaintenance_IsAccessible()) {
        SalesOrderService.sendPackingListMail(
          request,
          this.mailInvoiceContinueResponse,
          this.mailInvoiceContinueError
        );
      } else {
        let errMsg = "Access Denied";
        let errList = [];
        errList.push(errMsg);

        this.setState({
          alertMessage: errList,
          alertType: "danger",
          isShowAlert: true,
        });
      }
    }
  };
  mailInvoiceContinueResponse = (response) => {
    let isSuccess = this.handleMailResponse(response.data);
    if (isSuccess) {
      if (response.data.success) {
        setTimeout(() => {
          this.closeAlertModalCallBack(false);
        }, 200);
      }
    }
  };
  mailInvoiceContinueError = (error) => {};

  generatePrintLabel = () => {
    this.setState({
      isLoading: true,
      loadingText: "Generating Print Label ..",
    });
    let ptData = this.state.pickTicketData.code;
    let reportBean = new RestReportBean();
    reportBean.reportType = 1;

    let request = new PickTicketRollAndRollSkuLabelsRequest();
    request.companyCode = this.companyCode;
    request.pickTicketNumber = ptData;
    request.input = reportBean;
    if (SecurityAccessManager.PickticketMaintenance_IsAccessible()) {
      ReportService.printPickTicketRollAndRollSkuLabels(
        request,
        this.generatePrintLabelResponse,
        this.generatePrintLabelError
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };

  generatePackingListResponse = (response) => {
    this.setState({
      isLoading: false,
      loadingText: "",
    });
    if (
      !isEmpty(response.data) &&
      !isEmpty(response.data.reportResult) &&
      !isEmptyString(response.data.reportResult.reportFileID)
    ) {
      let reportFilePath = response.data.reportResult.reportFileID;
      window.open(this.report_url + reportFilePath);
    }
  };
  generatePackingListError = (error) => {
    this.setState({
      isLoading: false,
      loadingText: "",
    });
    ShowError("Erro : " + error);
  };
  generatePackingList = () => {
    this.setState({
      isLoading: true,
      loadingText: "Generating Packing List",
    });
    let ptData = this.state.pickTicketData.code;
    let reportBean = new RestReportBean();
    reportBean.reportType = 1;

    let request = new PackingListPrintRequest();
    request.companyCode = this.companyCode;
    request.pickTicketNumber = ptData;
    request.reportBean = reportBean;
    if (SecurityAccessManager.PickticketMaintenance_IsAccessible()) {
      ReportService.generatePackingListPrintReport(
        request,
        this.generatePackingListResponse,
        this.generatePackingListError
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  generateSyncSO = () => {
    this.setState({
      isLoading: true,
      loadingText: "Generating ...",
    });
    let ptData = this.state.pickTicketData;
    if (SecurityAccessManager.PickticketMaintenance_IsAccessible()) {
      PickTicketService.syncPickTicketWithSalesOrder(
        ptData,
        this.syncPickTicketResponse,
        this.syncPickTicketError
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  syncPickTicketResponse = (response) => {
    this.setState({
      isLoading: false,
      loadingText: "",
    });
    this.handleResponse(response.data);
    if (response.data != null && response.data.pickTicket != null) {
      let pickticket = response.data.pickTicket;
      this.setState({
        pickTicketData: pickticket,
      });
      if (this.isLocked) {
        this.code = pickticket.code;
        this.unLockPickTicket(pickticket.code);
      }
    }
  };
  syncPickTicketError = (error) => {
    this.setState({
      isLoading: false,
      loadingText: "",
    });
    ShowError("Error :", error);
  };

  shippingPickTicket = () => {
    let pickTicketData = this.state.pickTicketData;
    this.setState({ isLoading: true, loadingText: "Shipping" });
    if (SecurityAccessManager.PickticketMaintenance_IsAccessible()) {
      PickTicketService.updateShippedStatusInPickTicket(
        pickTicketData,
        this.updateShippedResponse,
        this.updateShippedError
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  updateShippedResponse = (response) => {
    this.setState({ isLoading: false, loadingText: "" });
    let success = this.handleResponse(response.data);
    if (success) {
      let pickTicketBean = response.data.pickTicket;
      if (pickTicketBean != null) {
        this.setState({
          pickTicketData: pickTicketBean,
        });
        if (this.isLocked) {
          this.code = pickTicketBean.code;
          this.unLockPickTicket(pickTicketBean.code);
        }
      }
    }
  };
  updateShippedError = (error) => {
    ShowError("Error :", error);
    this.setState({ isLoading: false, loadingText: "" });
  };

  unLockPickTicket = (code) => {
    let request = new RestEntityUnLockRequest();
    request.companyCode = this.companyCode;
    request.entityCode = code;
    if (SecurityAccessManager.PickticketMaintenance_IsAccessible()) {
      PickTicketService.unLockPickTicket(
        request,
        this.unlockPickTicketResponse,
        this.unlockPickTicketError
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };

  unlockPickTicketResponse = (response) => {
    if (!isEmpty(response.data)) {
      if (response.data.isSuccess) {
        if (this.isLocked) {
          this.editPickTicket(this.code);
        } else {
          this.isLocked = false;
        }
      } else {
        // this.isLocked = false; optional
        if (!this.state.isReseted) this.showErrorMessage(response.data);
      }
    }
  };

  unlockPickTicketError = (error) => {
    ShowError("Error : ", error);
  };

  showErrorMessage = (response) => {
    if (response.errors != null) {
      let errMsg = "";
      let errList = [];

      response.errors.map((err) => errList.push(err.messageDescription));
      //errList.push(response.errors.messageDescription);
      this.setState({ errorList: errList });
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };

  showInfoMessage = (response) => {
    if (response.infos != null) {
      let infoMsg = "";
      let successList = [];
      response.infos.map(
        (info) => (
          (infoMsg = infoMsg + info.messageDescription),
          successList.push(info.messageDescription)
        )
      );
      this.setState({
        alertMessage: successList,
        alertType: "success",
        isShowAlert: true,
      });
    }
  };

  handleMailResponse = (response) => {
    let success = false;
    if (response.errors != null) {
      let errMsg = "";
      let errList = [];
      response.errors.map(
        (err) => (
          (errMsg = errMsg + err.messageDescription),
          errList.push(err.messageDescription)
        )
      );
      this.setState({ errorList: errList });
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowLvl3Alert: true,
      });
      success = false;
    }
    if (response.infos != null) {
      let infoMsg = "";
      let successList = [];
      response.infos.map(
        (info) => (
          (infoMsg = infoMsg + info.messageDescription),
          successList.push(info.messageDescription)
        )
      );
      this.setState({
        alertMessage: successList,
        alertType: "success",
        isShowLvl3Alert: true,
      });
      success = true;
    }
    return success;
  };
  handleResponse = (response) => {
    let success = false;
    if (response.errors != null) {
      let errMsg = "";
      let errList = [];
      response.errors.map(
        (err) => (
          (errMsg = errMsg + err.messageDescription),
          errList.push(err.messageDescription)
        )
      );
      this.setState({ errorList: errList });
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
      success = false;
    }
    if (response.infos != null) {
      let infoMsg = "";
      let successList = [];
      response.infos.map(
        (info) => (
          (infoMsg = infoMsg + info.messageDescription),
          successList.push(info.messageDescription)
        )
      );
      this.setState({
        alertMessage: successList,
        alertType: "success",
        isShowAlert: true,
      });
      success = true;
    }
    return success;
  };
  handleApproveResponse = (response) => {
    let success = false;
    let infoMsg = "";
    let errMsg = "";
    let errList = [];
    if (!isEmpty(response.mainOperationResponse)) {
      if (!isEmptyArray(response.mainOperationResponse.errors)) {
        response.mainOperationResponse.errors.map(
          (err) => (
            (errMsg = errMsg + err.messageDescription),
            errList.push(err.messageDescription)
          )
        );

        success = false;
      }
      if (!isEmptyArray(response.mainOperationResponse.infos)) {
        response.mainOperationResponse.infos.map(
          (info) => (infoMsg = infoMsg + info.messageDescription)
        );

        success = true;
      }
    }
    if (!isEmpty(response.additionalOperationResponse)) {
      if (!isEmptyArray(response.additionalOperationResponse.errors)) {
        response.additionalOperationResponse.errors.map(
          (err) => (
            (errMsg = errMsg + err.messageDescription),
            errList.push(err.messageDescription)
          )
        );

        success = false;
      }
      if (!isEmptyArray(response.additionalOperationResponse.infos)) {
        response.additionalOperationResponse.infos.map(
          (info) => (infoMsg = infoMsg + info.messageDescription)
        );

        success = true;
      }
    }
    if (!isEmptyArray(errList) && errList.length > 0) success = false;
    if (!isEmptyString(infoMsg) && !isEmptyString(errMsg)) {
      let msg = infoMsg + errMsg;
    }
    this.setState({ error_list: errList });
    return success;
  };

  handlePickTicketResponse = (response) => {
    let success = false;
    let infoMsg = "";
    let errMsg = "";
    let errList = [];
    if (!isEmpty(response.pickTicketResponse)) {
      if (!isEmptyArray(response.pickTicketResponse.errors)) {
        response.pickTicketResponse.errors.map(
          (err) => (
            (errMsg = errMsg + err.messageDescription),
            errList.push(err.messageDescription)
          )
        );

        success = false;
      }
      if (!isEmptyArray(response.pickTicketResponse.infos)) {
        response.pickTicketResponse.infos.map(
          (info) => (infoMsg = infoMsg + info.messageDescription)
        );

        success = true;
      }
    }
    if (!isEmpty(response.pickTicketPrintReportResponse)) {
      if (!isEmptyArray(response.pickTicketPrintReportResponse.errors)) {
        response.pickTicketPrintReportResponse.errors.map(
          (err) => (
            (errMsg = errMsg + err.messageDescription),
            errList.push(err.messageDescription)
          )
        );

        success = false;
      }
      if (!isEmptyArray(response.pickTicketPrintReportResponse.infos)) {
        response.pickTicketPrintReportResponse.infos.map(
          (info) => (infoMsg = infoMsg + info.messageDescription)
        );

        success = true;
      }
    }
    if (!isEmptyArray(errList) && errList.length > 0) success = false;
    if (!isEmptyString(infoMsg) && !isEmptyString(errMsg)) {
      let msg = infoMsg + errMsg;
    }
    this.setState({ error_list: errList });
    return success;
  };
  //#endregion
  //#region Node Details
  getEmptyView() {
    return <div></div>;
  }

  getNodeList = () => {
    let nodeList = [];
    let emptyObject = this.getEmptyView();
    let headerNode = new NodeData("headerView", "Header", emptyObject);
    let soData = this.state.pickTicketData;

    let shippingInformationNode = new NodeData(
      "shippingInformationView",
      "ShippingInfo",
      emptyObject
    );

    let invoicesNode = new NodeData("invoicesView", "Invoices", emptyObject);
    let changesHistoryNode = new NodeData(
      "changesHistoryView",
      "ChangesHistory",
      emptyObject
    );
    // let palletNode = new NodeData("palletView", "Pallet", emptyObject);

    nodeList["headerView"] = headerNode;

    if (soData.isFetched) {
      nodeList["shippingInformationView"] = shippingInformationNode;
      nodeList["invoicesView"] = invoicesNode;
      nodeList["changesHistoryView"] = changesHistoryNode;
      // if (this.state.is3PL) {
      //   nodeList["palletView"] = palletNode;
      // }
    }
    this.setState({ nodeList: nodeList });
  };

  nodeOnSelect = (selectedNode) => {
    this.setState({ selectedNodeKey: selectedNode });
    if (selectedNode == "headerView") {
      this.setPickTicketHeaderView();
    } else if (selectedNode == "shippingInformationView") {
      this.setShippingInformationView();
    } else if (selectedNode == "invoicesView") {
      this.setInvoicesView();
    } else if (selectedNode == "changesHistoryView") {
      this.setChangesHistoryView();
    }
    // else if (selectedNode == "palletView") {
    //   this.setPalletView();
    // }
  };

  setPickTicketHeaderView = () => {
    this.closeAllNodeViews();
    this.setState({
      isShowSaveButton: true,
      isShowBackButton: true,
      isEntryFormOpen: true,
    });
  };
  setShippingInformationView = () => {
    this.closeAllNodeViews();
    this.setState({
      isShippingInformationFormOpened: true,
      isShowBackButton: true,
    });
  };
  setChangesHistoryView = () => {
    this.closeAllNodeViews();
    this.setState({
      isChangesHistoryFormOpened: true,
      isShowBackButton: true,
    });
  };
  setInvoicesView = () => {
    this.closeAllNodeViews();
    this.setState({
      isInvoicesFormOpened: true,
    });
  };
  // setPalletView = () => {
  //   this.closeAllNodeViews();
  //   this.setState({
  //     isPalletFormOpened: true,
  //   });
  // };

  closeAllNodeViews = () => {
    this.setState({
      isEntryFormOpen: false,
      isListFormOpen: false,
      isShippingInformationFormOpened: false,
      isInvoicesFormOpened: false,
      isChangesHistoryFormOpened: false,
      isPalletFormOpened: false,
    });
  };

  //#endregion
  //#region Line Details
  loadRollLines = (pt_rollLines, skuBatchInventories) => {
    const pickTicketData = { ...this.state.pickTicketData };
    const pickTicketLine = { ...this.state.pickTicketLineData };
    let pickTicketRollLineNumber = 1;
    skuBatchInventories.map((inventoryRoll, idx) => {
      if (!inventoryRoll.isPickedFlag) {
        let existingRollLine = null;
        if (!isEmptyArray(pt_rollLines)) {
          pt_rollLines.map((line) => {
            if (line.rollSkuNumber == inventoryRoll.rollSkuNumber) {
              // line.currentlyPickedQuantity = 0;
              existingRollLine = line;
              // if(line.isSelected === true){
              //   line.currentlyPickedQuantity = 0;
              // }
            }
          });
        }
        if (existingRollLine == null) {
          const rollLine = new PickTicketRollLineBean();
          rollLine.companyCode = pickTicketLine.companyCode;
          rollLine.pickTicketNumber = pickTicketLine.pickTicketNumber;
          rollLine.customerCode = pickTicketLine.customerCode;
          rollLine.customerName = pickTicketLine.customerName;
          pickTicketRollLineNumber = pt_rollLines.length + 1;
          rollLine.pickTicketRollLineNumber = pickTicketRollLineNumber++;
          rollLine.pickTicketLineNumber = pickTicketLine.pickTicketLineNumber;
          rollLine.fabricStyleCode = pickTicketLine.fabricStyleCode;
          rollLine.fabricStyleName = pickTicketLine.fabricStyleName;
          rollLine.colorCode = pickTicketLine.colorCode;
          rollLine.widthCode = pickTicketLine.widthCode;
          rollLine.skuNumber = pickTicketLine.skuNumber;

          rollLine.rollSkuNumber = inventoryRoll.rollSkuNumber;
          rollLine.rollNumber = inventoryRoll.rollNumber;
          rollLine.purchasOrderNumber = inventoryRoll.purchaseOrderNumber;
          rollLine.purchaseOrderReceiptNumber =
            inventoryRoll.referenceEntityNumber;
          rollLine.vendorBatchNumber = inventoryRoll.vendorBatchNumber;
          rollLine.vendorCode = "";
          rollLine.boxNumber = inventoryRoll.boxNumber;
          rollLine.availableQuantity = inventoryRoll.onHandQuantity;
          rollLine.locationCode = inventoryRoll.locationCode;
          rollLine.orderUomCode = pickTicketLine.orderUomCode;
          rollLine.inventoryUomCode = pickTicketLine.inventoryUomCode;
          rollLine.uomConversionRate = pickTicketLine.uomConversionRate;
          rollLine.inventoryReceivedQuatity = inventoryRoll.receivedQuantity;
          rollLine.isCloseOutInventory = inventoryRoll.closeOutInventory;
          rollLine.binLocation = inventoryRoll.aisleInfoText;
          rollLine.isSelected = false;
          pt_rollLines.push(rollLine);
        } else {
          pt_rollLines.map((ln) => {
            if (
              existingRollLine.pickedQuantity > 0 ||
              existingRollLine.isFetched
            ) {
              if (ln.pickedQuantity > 0) {
                if (ln.currentlyPickedQuantity < 0) {
                  ln.currentlyPickedQuantity = -ln.pickedQuantity;
                } else if (ln.currentlyPickedQuantity > 0) {
                  if (existingRollLine.isFetched) {
                    ln.currentlyPickedQuantity =
                      parseFloat(ln.currentlyPickedQuantity) -
                      parseFloat(ln.currentlyPickedQuantity);
                  }
                }
                ln.isSelected = true;
              } else {
                if (
                  pickTicketData.status ===
                    LogicConstants.PICK_TICKET_UNAPPROVE_STATUS &&
                  !ln.isSelected
                ) {
                  ln.currentlyPickedQuantity = 0;
                }
              }
            }
          });
          existingRollLine.availableQuantity = inventoryRoll.onHandQuantity;
          existingRollLine.locationCode = inventoryRoll.locationCode;
          existingRollLine.binLocation = inventoryRoll.aisleInfoText;
        }
      }
    });
    // if (!isEmptyArray(rollLines)) pt_rollLines = rollLines;
    //  pickTicketLine.rollLines = rollLines;
    this.setState({
      // pickTicketLineData: pickTicketLine,
      pt_rollLines: pt_rollLines,
    });
    this.openLineDetailsDialog();
  };

  updateLine = (e) => {
    if (e.detail === 1) {
      const ptData = { ...this.state.pickTicketData };
      const ptLineData = { ...this.state.pickTicketLineData };
      let toBePickedQty = 0;
      const pt_rollLines = [...this.state.pt_rollLines];
      // toBePickedQty =
      //   parseFloat(ptLineData.orderQuantity) -
      //   (parseFloat(ptLineData.pickedQuantity) +
      //     parseFloat(ptLineData.currentlyPickedQuantity));

      // ptLineData.toBePickedQuantity = parseFloat(toBePickedQty);
      ptLineData.rollLines = pt_rollLines;
      let x = 0;
      if (!isEmptyArray(pt_rollLines)) {
        pt_rollLines.map((roll) => {
          if (roll.currentlyPickedQuantity != 0)
            x += roll.currentlyPickedQuantity;
        });
      }
      ptLineData.currentlyPickedQuantity = x;
      const index = ptData.pickTicketLines.findIndex(
        (ln) => ln.pickTicketLineNumber === ptLineData.pickTicketLineNumber
      );

      if (index != -1) {
        ptData.pickTicketLines.splice(index, 1);
        ptData.pickTicketLines.push(ptLineData);
      }
      this.setState({ pickTicketData: ptData });

      this.closeLineDetailsDialog();
    }
  };
  openLineDetailsDialog = () => {
    // if (this.lineDetailDialogRef.current != null) {
    // this.lineDetailDialogRef.current.show();
    //}
    this.setState({ isShowLinePopup: true });
  };

  closeLineDetailsDialog = () => {
    //if (this.lineDetailDialogRef.current != null) {
    //this.lineDetailDialogRef.current.hide();
    //}
    this.setState({ isShowLinePopup: false, pt_rollLines: new Array() });
  };
  displayAutoCompleteBoxTypeList = (showAutoCompleteList) => {
    this.setState({ showAutoCompleteBoxTypeList: showAutoCompleteList });
  };
  onBoxTypeChange = (e) => {
    let boxType = e.target.value;
    this.state.showAutoCompleteBoxTypeList = true;

    let temp_pickTicketData = this.state.pickTicketBoxLineData;
    let showAutoCompleteList = this.state.showAutoCompleteBoxTypeList;

    if (isEmpty(boxType)) {
      this.state.showAutoCompleteBoxTypeList = false;
      let showAutoCompleteList = this.state.showAutoCompleteBoxTypeList;
      let temp_pickTicketData = this.state.pickTicketBoxLineData;
      temp_pickTicketData.boxType = "";
      let suggestion = [];

      this.setState({
        showAutoCompleteList: showAutoCompleteList,
        pickTicketData: temp_pickTicketData,
        boxTypePageListForAutoCompleteList: suggestion,
      });
    } else if (showAutoCompleteList === true && boxType !== "") {
      this.readboxTypeBySearchString(boxType);
    }
    //let temp_pickTicketData = this.state.pickTicketData;
    temp_pickTicketData[e.target.name] = e.target.value;
    this.setState({
      pickTicketBoxLineData: temp_pickTicketData,
    });
    this.onBoxTypeChanges(boxType);
  };
  readboxTypeBySearchString(searchString) {
    let boxTypeData = this.state.boxTypes;
    let simpleAutoCompleteList = new Array();
    if (boxTypeData.length > 0 && boxTypeData != null) {
      boxTypeData.map((boxTypes) => {
        let simpleItemBean = {
          code: boxTypes.code,
          description: boxTypes.description,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    let userInput = searchString;

    let filteredSuggestions = new Array();

    filteredSuggestions = simpleAutoCompleteList.filter(
      (simpleAutoCompleteBoxTypeLists) =>
        simpleAutoCompleteBoxTypeLists.code
          .toLowerCase()
          .indexOf(userInput.toLowerCase()) > -1
    );
    this.setState({ boxTypePageListForAutoCompleteList: filteredSuggestions });
  }
  boxTypeEnterKeyEventHandler = (e) => {
    let boxType = e.target.value;

    this.onBoxLineChange(e);
    this.setState({
      boxTypePageListForAutoCompleteList: new Array(),
    });
  };
  //#region Box Detail
  onBoxLineChange = (e) => {
    let temp_pickTicketBoxLineData = this.state.pickTicketBoxLineData;
    temp_pickTicketBoxLineData[e.target.name] = e.target.value;
    if (e.target.name == "boxType") {
      this.onBoxTypeChanges(temp_pickTicketBoxLineData);
    }
    this.setState({ pickTicketBoxLineData: temp_pickTicketBoxLineData });
  };
  onBoxTypeChanges = (boxLineData) => {
    let boxTypes = this.state.boxTypes;

    let selectedBoxType = null;
    if (!isEmptyArray(boxTypes)) {
      boxTypes.map((boxType) => {
        if (boxType.code == boxLineData.boxType) {
          selectedBoxType = boxType;
        }
      });
    }
    if (selectedBoxType != null) {
      boxLineData.heightInInces = selectedBoxType.heightInInces;
      boxLineData.widthInInces = selectedBoxType.widthInInces;
      boxLineData.lengthInInces = selectedBoxType.lengthInInces;
    }
  };
  addNewBoxLine = () => {
    let ptData = this.state.pickTicketData;
    let ptBoxLineData = new PickTicketShipmentBoxDetailBean();
    ptBoxLineData.companyCode = this.companyCode;
    ptBoxLineData.isFetched = false;
    ptBoxLineData.pickTicketNumber = ptData.code;
    this.setState({ pickTicketBoxLineData: ptBoxLineData });
    this.openBoxDetailsDialog();
  };
  lnkBoxLineDetailsClick = (rowData) => {
    let ptBoxLine = new PickTicketShipmentBoxDetailBean();
    ptBoxLine = { ...rowData };
    this.state.pickTicketBoxLineData = ptBoxLine;
    const palletLines = ptBoxLine.boxPalletLines;
    this.setState({
      pickTicketBoxLineData: ptBoxLine,
      palletLines: palletLines,
    });

    this.openBoxDetailsDialog();
  };

  fetchRatesResponse = (response) => {
    this.setState({
      isLoading: false,
      loadingText: "",
    });
    let isSuccess = this.handleResponse(response.data);
    if (isSuccess) {
      if (!isEmpty(response.data.rateResult)) {
        this.state.shipmentRateResult = response.data.rateResult;

        this.openRateDetailsDialog();
        // this.openRateDetailsDialog();
      }
    }
  };

  openRateDetailsDialog = () => {
    // if (this.rateDetailDialogRef.current != null) {
    // this.rateDetailDialogRef.current.show();
    // }
    this.setState({ isShowRatePopup: true });
  };

  closeRateDetailsDialog = () => {
    // if (this.rateDetailDialogRef.current != null) {
    // this.rateDetailDialogRef.current.hide();
    //}
    this.setState({ isShowRatePopup: false });
    let ptData = this.state.pickTicketData;
  };

  fetchRatesError = (error) => {
    this.setState({
      isLoading: false,
      loadingText: "",
    });
    ShowError("Error : " + error);
  };
  fetchRates = () => {
    this.setState({
      isLoading: true,
      loadingText: "Fetching Rates",
    });
    let shipmentRateResult = new ShipmentRateResultBean();
    let rates = [];
    let rate = new ShipmentRateBean();
    rate.carrierCode = "carr";
    rate.serviceMethodCode = "smCode";
    rate.serviceMethodName = "smname";
    rate.totalShipmentRate = 20;
    rates.push(rate);
    shipmentRateResult.rates = rates;
    this.state.shipmentRateResult = shipmentRateResult;

    let pickTicketData = { ...this.state.pickTicketData };
    let input = new RestPickTicketShipmentRateRequest();
    input.pickTicket = pickTicketData;

    let criteria = new ShipmentRateCriteria();
    criteria.carrierCode = "UPS";
    criteria.companyCode = this.companyCode;

    input.criteria = criteria;
    if (SecurityAccessManager.PickticketMaintenance_IsAccessible()) {
      PickTicketService.getShipmentRatesForPickTicket(
        input,
        this.fetchRatesResponse,
        this.fetchRatesError
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };

  updatePickTicketandFetchRatesResponse = (response) => {
    this.setState({
      isLoading: false,
      loadingText: "",
    });
    let isSuccess = this.handleResponse(response.data);
    if (isSuccess) {
      if (!isEmpty(response.data.pickTicket)) {
        this.fetchRates();
      }
    }
  };

  updatePickTicketandFetchRatesError = (error) => {
    this.setState({
      isLoading: false,
      loadingText: "",
    });
    ShowError("Error : " + error);
  };
  updatePickTicketandFetchRates = () => {
    this.setState({
      isLoading: true,
      loadingText: "Updating PickTicket Fetch Rates",
    });
    let pickTicketData = { ...this.state.pickTicketData };
    if (SecurityAccessManager.PickticketMaintenanceEdit_IsAccessible()) {
      PickTicketService.updatePickTicket(
        pickTicketData,
        this.updatePickTicketandFetchRatesResponse,
        this.updatePickTicketandFetchRatesError
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  updateandFetchRates = () => {
    let isValidBox = this.validateFetchRate();
    let isValidAddress = this.validateAddressDetails();

    if (isValidBox && isValidAddress) {
      this.updatePickTicketandFetchRates();
    }
  };
  saveShipmentResponse = (response) => {
    this.setState({
      isLoading: false,
      loadingText: "",
    });
  };
  saveShipmentError = (error) => {
    this.setState({
      isLoading: false,
      loadingText: "",
    });
    ShowError("Error : " + error);
  };
  saveShipment = () => {
    this.setState({
      isLoading: true,
      loadingText: "Saving Shipment ..",
    });
    let ptData = this.state.pickTicketData;
    if (SecurityAccessManager.PickticketMaintenance_IsAccessible()) {
      PickTicketService.updatePickTicketAndShipConfirmPickTicket(
        ptData,
        this.saveShipmentResponse,
        this.saveShipmentError
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };

  manualVoidShipmentResponse = (response) => {
    this.setState({
      isLoading: false,
      loadingText: "",
    });
    let success = this.handleResponse(response.data);
    if (success) {
      if (!isEmpty(response.data) && !isEmpty(response.data.pickTicket))
        this.editPickTicket(response.data.pickTicket.code);
    }
  };
  manualVoidShipmentError = (error) => {
    this.setState({
      isLoading: false,
      loadingText: "",
    });
    ShowError("Error : " + error);
  };
  manualVoidShipment = () => {
    let isvalid = false;
    isvalid = this.validateVoidShipment();
    if (isvalid) {
      this.setState({
        isLoading: true,
        loadingText: "Manual Void Shipment",
      });
      let ptData = this.state.pickTicketData;
      let input = new RestPickTicketVoidShipmentRequest();
      input.companyCode = this.companyCode;
      input.pickTicketNumber = ptData.code;
      input.isManualVoid = true;
      if (
        SecurityAccessManager.PickticketMaintenanceVoidShipment_IsAccessible()
      ) {
        PickTicketService.voidShipment(
          input,
          this.manualVoidShipmentResponse,
          this.manualVoidShipmentError
        );
      } else {
        let errMsg = "Access Denied";
        let errList = [];
        errList.push(errMsg);

        this.setState({
          alertMessage: errList,
          alertType: "danger",
          isShowAlert: true,
        });
      }
    }
  };

  generateAllLabelsResponse = (response) => {
    this.setState({
      isLoading: false,
      loadingText: "",
    });

    let reportFilePath = response.data.reportResult.reportFileID;
    window.open(this.report_url + reportFilePath);
  };
  generateAllLabelsError = (error) => {
    this.setState({
      isLoading: false,
      loadingText: "",
    });
    ShowError("Error : " + error);
  };
  generateAllLabels = () => {
    this.setState({
      isLoading: true,
      loadingText: "Generate Labels",
    });
    let ptData = this.state.pickTicketData;
    let input = new RestPickTicketShipmentLabelPrintRequest();
    input.companyCode = this.companyCode;
    input.pickTicketNumber = ptData.code;
    if (SecurityAccessManager.PickticketMaintenance_IsAccessible()) {
      ReportService.printPickTicketAllBoxShipmentLabels(
        input,
        this.generateAllLabelsResponse,
        this.generateAllLabelsError
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };

  voidShipmentResponse = (response) => {
    this.setState({
      isLoading: false,
      loadingText: "",
    });
    let success = this.handleResponse(response.data);
    if (success) {
      if (!isEmpty(response.data) && !isEmpty(response.data.pickTicket))
        this.editPickTicket(response.data.pickTicket.code);
    }
  };
  voidShipmentError = (error) => {
    this.setState({
      isLoading: false,
      loadingText: "",
    });
    ShowError("Error : " + error);
  };
  voidShipment = () => {
    let isvalid = false;
    isvalid = this.validateVoidShipment();
    if (isvalid) {
      this.setState({
        isLoading: true,
        loadingText: "Void Shipment",
      });
      let ptData = this.state.pickTicketData;
      let input = new RestPickTicketVoidShipmentRequest();
      input.companyCode = this.companyCode;
      input.pickTicketNumber = ptData.code;
      input.isManualVoid = false;
      if (
        SecurityAccessManager.PickticketMaintenanceVoidShipment_IsAccessible()
      ) {
        PickTicketService.voidShipment(
          input,
          this.voidShipmentResponse,
          this.voidShipmentError
        );
      } else {
        let errMsg = "Access Denied";
        let errList = [];
        errList.push(errMsg);

        this.setState({
          alertMessage: errList,
          alertType: "danger",
          isShowAlert: true,
        });
      }
    }
  };

  validateVoidShipment = () => {
    let isValid = false;
    let ptData = this.state.pickTicketData;
    let errMsg = "";
    let err_list = [];
    if (!isEmpty(ptData)) {
      if (!ptData.shipConfirmProcessCompletedFlag) {
        errMsg = "VOID is not possible since Shipment is not confirmed Yet!";
        err_list.push(errMsg);
      }
    } else {
      errMsg = "Invalid Data";
      err_list.push(errMsg);
    }
    if (err_list.length > 0) {
      isValid = false;
      this.setState({
        alertMessage: err_list,
        alertType: "danger",
        isShowAlert: true,
      });
    } else isValid = true;
    return isValid;
  };

  validateFetchRate = () => {
    let isValid = false;
    let ptData = this.state.pickTicketData;
    let errMsg = "";
    let err_list = [];
    if (!isEmpty(ptData)) {
      if (isEmptyArray(ptData.boxDetails)) {
        errMsg = this.state.is3PL
          ? "Invalid Box Details!"
          : "Invalid Pallet Details!";
        err_list.push(errMsg);
      } else {
        ptData.boxDetails.map((boxDetail) => {
          if (boxDetail.WeightInLbs <= 0) {
            errMsg += "BOX# " + boxDetail.boxLineNumber + " Invalid Weight!";
          }
        });
      }
    } else {
      errMsg = "Invalid Data";
      err_list.push(errMsg);
    }

    if (err_list.length > 0) {
      isValid = false;
      this.setState({
        alertMessage: err_list,
        alertType: "danger",
        isShowAlert: true,
      });
    } else isValid = true;
    return isValid;
  };

  validateAddressDetails = () => {
    let isValid = false;
    let ptData = this.state.pickTicketData;
    let errMsg = "";
    let err_list = [];

    if (!isEmpty(ptData)) {
      if (isEmpty(ptData.shipToAddress)) {
        errMsg = "Invalid Address Details!";
      } else {
        if (isEmptyString(ptData.shipToAddress.address1)) {
          errMsg += "Enter valid Address!";
          err_list.push(errMsg);
        }
        if (isEmptyString(ptData.shipToAddress.city)) {
          errMsg += "Enter valid City!";
          err_list.push(errMsg);
        }
        if (isEmptyString(ptData.shipToAddress.state)) {
          errMsg += "Enter valid State!";
          err_list.push(errMsg);
        }
        if (isEmptyString(ptData.shipToAddress.country)) {
          errMsg += "Enter valid Country!";
          err_list.push(errMsg);
        }
        if (isEmptyString(ptData.shipToAddress.zip)) {
          errMsg += "Enter valid Zip!";
          err_list.push(errMsg);
        }
        if (ptData.shipToAddress.country == "USA") {
          ptData.shipToAddress.country = "US";
          err_list.push(errMsg);
        }
      }
    } else {
      errMsg = "Invalid Data";
    }
    if (err_list.length > 0) {
      isValid = false;
      this.setState({
        alertMessage: err_list,
        alertType: "danger",
        isShowAlert: true,
      });
    } else isValid = true;
    return isValid;
  };

  lnkServiceMethodClick = (e, selectedService) => {
    if (!isEmpty(selectedService)) {
      let ptData = this.state.pickTicketData;
      ptData.shipmentCarrier = selectedService.carrierCode;
      ptData.shipmentCarrierMethod = selectedService.serviceMethodCode;
      ptData.shipmentCarrierMethodName = selectedService.serviceMethodName;
      ptData.totalCarrierShipmentCharges = selectedService.totalShipmentRate;
      if (
        !isEmptyArray(ptData.boxDetails) &&
        !isEmptyArray(selectedService.boxRateDetail)
      ) {
        let i = 0;
        ptData.boxDetails.map((boxDetail) => {
          if (selectedService.boxRateDetail.length > i) {
            var boxRateBean = selectedService.boxRateDetail[0];
            if (boxRateBean != null) {
              boxDetail.shipmentCharges = boxRateBean.totalShipmentRate;
            }
          }
          i++;
        });
      }
      this.setState({ pickTicketData: ptData });
    }
    this.closeRateDetailsDialog();
  };

  addorupdateBoxLine = (e) => {
    if (e.detail === 1) {
      let ptData = this.state.pickTicketData;
      let ptLineData = this.state.pickTicketBoxLineData;

      if (isEmptyArray(ptData.boxDetails)) ptData.boxDetails = [];

      const index = ptData.boxDetails.findIndex(
        (ln) => ln.boxLineNumber === ptLineData.boxLineNumber
      );
      if (index != -1) {
        ptData.boxDetails.splice(index, 1);
        ptData.boxDetails.push(ptLineData);
      } else {
        var lineNumber = this.getBoxMaxLineNumber();
        ptLineData.boxLineNumber = ++lineNumber;
        if (isEmptyString(ptLineData.boxNumber)) {
          ptLineData.boxNumber = ptLineData.boxLineNumber;
        }
        ptData.boxDetails.push(ptLineData);
      }
      this.setState({ pickTicketData: ptData });

      this.closeBoxDetailsDialog();
    }
  };

  clearBoxLineValues = (e) => {
    if (e.detail === 1) {
      let boxLineData = new PickTicketShipmentBoxDetailBean();
      this.setState({ pickTicketBoxLineData: boxLineData });
    }
  };

  getBoxMaxLineNumber() {
    let maxLineNumber = 0;
    let boxDetails = this.state.pickTicketData.boxDetails;
    if (!isEmptyArray(boxDetails) && boxDetails.length > 0)
      boxDetails.map((line) => {
        if (line.boxLineNumber > maxLineNumber) {
          maxLineNumber = line.boxLineNumber;
        }
      });
    return maxLineNumber;
  }

  openBoxDetailsDialog = () => {
    // const pickTicketData = this.state.pickTicketData;
    // const palletLines = pickTicketData.boxDetails
    // , palletLines :palletLines
    this.setState({ isShowBoxPopup: true });
  };

  closeBoxDetailsDialog = () => {
    // if (this.boxDetailDialogRef.current != null) {
    // this.boxDetailDialogRef.current.hide();
    //}
    this.setState({ isShowBoxPopup: false });
  };

  executeAfterBoxDetailDialogClose = (e) => {};
  //#endregion

  executeAfterLineDetailDialogClose = (e) => {};

  onRollSelectedChange = (evt, rollLine) => {
    // let isSelected = false;
    const pickTicketLine = { ...this.state.pickTicketLineData };
    const _pickTicketLine = { ...this.state._pickTicketLine };

    const pt_rollLines = [...this.state.pt_rollLines];
    // isSelected = evt.target.value;

    rollLine.isSelected = evt.target.value;

    if (evt.target.value) {
      if (!rollLine.isCloseOutInventory) {
        const availableQty = rollLine.availableQuantity;
        const openQty =
          _pickTicketLine.toBePickedQuantity - _pickTicketLine.pickedQuantity;
        const useDefaultBinLocation =
          ConfigManager.getIsUseDefaultBinLocationOfTheWarehouse();

        if (openQty > availableQty) {
          if (useDefaultBinLocation) {
            rollLine.currentlyPickedQuantity = openQty;
          } else {
            rollLine.currentlyPickedQuantity = availableQty;
          }
        } else {
          rollLine.currentlyPickedQuantity = openQty;
        }

        // openQty = openQty - rollLine.currentlyPickedQuantity;

        const currAvailQty =
          rollLine.availableQuantity - rollLine.currentlyPickedQuantity;
        if (currAvailQty > 0) rollLine.isRollPartialInventoryFlag = true;
      } else {
      }
    } else {
      // const qty =
      //   rollLine.currentlyPickedQuantity -
      //   rollLine.currentlyPickedQuantity -
      //   rollLine.pickedQuantity;
      if (!rollLine.isCloseOutInventory) {
        if (
          rollLine.pickedQuantity > 0 &&
          rollLine.currentlyPickedQuantity == 0
        ) {
          rollLine.currentlyPickedQuantity = rollLine.pickedQuantity * -1;
          rollLine.isRollPartialInventoryFlag = false;
        } else if (rollLine.currentlyPickedQuantity > 0) {
          rollLine.currentlyPickedQuantity = 0;
          rollLine.isRollPartialInventoryFlag = false;
        }
        // rollLine.currentlyPickedQuantity = qty;
        // rollLine.isRollPartialInventoryFlag = false;
      }
    }
    // _pickTicketLine.rollLines.map((line) => {
    //   if (line.pickTicketRollLineNumber == rollLine.pickTicketRollLineNumber) {
    //     rollLine.companyCode = this.companyCode;
    //     line = rollLine;
    //   }
    // });

    pt_rollLines.map((line) => {
      if (line.pickTicketRollLineNumber == rollLine.pickTicketRollLineNumber) {
        rollLine.companyCode = this.companyCode;
        line = rollLine;
      }
    });
    this.calculateLineTotal(_pickTicketLine, pt_rollLines);
    this.setState({
      // pickTicketLineData: pickTicketLine,
      _pickTicketLine: _pickTicketLine,
      pt_rollLines: pt_rollLines,
    });
  };

  calculateLineTotal = (pickTicketLineData, pt_rollLines) => {
    let totalPickQty = 0;
    let totalCurrentPickQty = 0;
    if (
      !isEmpty(pickTicketLineData) &&
      // !isEmptyArray(pickTicketLineData.rollLines) &&
      !isEmptyArray(pt_rollLines)
    ) {
      // pickTicketLineData.rollLines.map((line) => {
      pt_rollLines.map((line) => {
        let pickedQuantity = 0;
        if (!isEmptyString(line.pickedQuantity))
          pickedQuantity = line.pickedQuantity;
        totalPickQty += parseFloat(pickedQuantity);
        let currentlyPickedQuantity = 0;
        if (!isEmptyString(line.currentlyPickedQuantity))
          currentlyPickedQuantity = line.currentlyPickedQuantity;
        totalCurrentPickQty += parseFloat(currentlyPickedQuantity);
      });
      pickTicketLineData.pickedQuantity = parseFloat(totalPickQty).toFixed(2);
      pickTicketLineData.currentlyPickedQuantity =
        parseFloat(totalCurrentPickQty).toFixed(2);
      let toBePickedQty = 0;
      // toBePickedQty =
      //   parseFloat(pickTicketLineData.toBePickedQuantity) -
      //   parseFloat(pickTicketLineData.pickedQuantity) +
      //   parseFloat(pickTicketLineData.currentlyPickedQuantity);
      toBePickedQty =
        parseFloat(pickTicketLineData.orderQuantity) -
        parseFloat(totalPickQty) -
        parseFloat(totalCurrentPickQty);
      if (toBePickedQty > 0) {
        pickTicketLineData.toBePickedQuantity = parseFloat(toBePickedQty);
      } else if (toBePickedQty <= 0) {
        pickTicketLineData.toBePickedQuantity = 0;
      }
    }
  };
  // calculateLineTotal = (pickTicketLineData) => {
  //   let totalPickQty = 0;
  //   let totalCurrentPickQty = 0;
  //   if (
  //     !isEmpty(pickTicketLineData) &&
  //     !isEmptyArray(pickTicketLineData.rollLines)
  //   ) {
  //     pickTicketLineData.rollLines.map((line) => {
  //       let pickedQuantity = 0;
  //       if (!isEmptyString(line.pickedQuantity))
  //         pickedQuantity = line.pickedQuantity;
  //       totalPickQty += parseFloat(pickedQuantity);
  //       let currentlyPickedQuantity = 0;
  //       if (!isEmptyString(line.currentlyPickedQuantity))
  //         currentlyPickedQuantity = line.currentlyPickedQuantity;
  //       totalCurrentPickQty += parseFloat(currentlyPickedQuantity);
  //     });

  //     pickTicketLineData.pickedQuantity = parseFloat(totalPickQty).toFixed(2);
  //     pickTicketLineData.currentlyPickedQuantity =
  //       parseFloat(totalCurrentPickQty).toFixed(2);

  //     let toBePickedQty = 0;

  //     // toBePickedQty =
  //     //   parseFloat(pickTicketLineData.toBePickedQuantity) -
  //     //   parseFloat(pickTicketLineData.pickedQuantity) +
  //     //   parseFloat(pickTicketLineData.currentlyPickedQuantity);

  //     toBePickedQty =
  //       parseFloat(pickTicketLineData.toBePickedQuantity) -
  //       parseFloat(pickTicketLineData.pickedQuantity) -
  //       parseFloat(pickTicketLineData.currentlyPickedQuantity);

  //     // toBePickedQty =
  //     //   parseFloat(pickTicketLineData.orderQuantity) -
  //     //   (parseFloat(pickTicketLineData.pickedQuantity) +
  //     //     parseFloat(pickTicketLineData.currentlyPickedQuantity));

  //     pickTicketLineData.toBePickedQuantity = parseFloat(toBePickedQty);
  //     if (-pickTicketLineData.toBePickedQuantity) {
  //       pickTicketLineData.toBePickedQuantity = 0;
  //     }
  //   }
  // };

  onLinePickedQtyChange = (evt, row) => {
    let ptLine = this.state.pickTicketLineData;
    let pt_rollLines = this.state.pt_rollLines;
    // if (!isEmpty(ptLine) && !isEmpty(row) && !isEmptyArray(ptLine.rollLines)) {
    if (!isEmpty(ptLine) && !isEmpty(row) && !isEmptyArray(pt_rollLines)) {
      pt_rollLines.map((line) => {
        if (evt.target.name == "currentlyPickedQuantity") {
          if (line.pickTicketRollLineNumber == row.pickTicketRollLineNumber) {
            line["currentlyPickedQuantity"] = evt.target.value;
            line.isSelected = true;
          }
        }
      });
      this.state.pickTicketLineData = ptLine;
    }
  };

  onLinePickedQtyBlur = (evt, row) => {
    if (!isEmpty(row) && row.isSelected) {
      let ptLine = this.state.pickTicketLineData;
      let pt_rollLines = this.state.pt_rollLines;
      this.calculateLineTotal(ptLine, pt_rollLines);
      this.setState({ pickTicketLineData: ptLine });
    }
  };

  extraOrderQtyOnClick = (e, val, rowData) => {
    let pickTicketLine = this.state.pickTicketLineData;
    let pt_rollLines = this.state.pt_rollLines;
    if (!rowData.isSelected) {
      let errMsg = "Entry not allowed since  Roll is not Selected !";
      let errList = [];
      errList.push(errMsg);
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowPopupAlert: true,
      });
    } else {
      let orderQty = 0;
      orderQty = pickTicketLine.orderQuantity;
      let currentlyPickedQuantity = 0;
      currentlyPickedQuantity = rowData.currentlyPickedQuantity;
      let totalPickedQty = 0;
      // pickTicketLine.rollLines.map((ln) => {
      //   if (ln.isSelected) {
      //     totalPickedQty += ln.pickedQuantity;
      //   }
      // });
      pt_rollLines.map((ln) => {
        if (ln.isSelected) {
          totalPickedQty += ln.pickedQuantity;
        }
      });
      let toBePickedQty = totalPickedQty - currentlyPickedQuantity;
      let exactRollQty = orderQty - totalPickedQty;

      if (rowData.availableQuantity > exactRollQty) {
        rowData.currentlyPickedQuantity = exactRollQty;
      } else {
        rowData.currentlyPickedQuantity = rowData.availableQuantity;
      }
    }

    // pickTicketLine.rollLines.map((line) => {
    //   if (line.pickTicketRollLineNumber == rowData.pickTicketRollLineNumber) {
    //     line = rowData;
    //   }
    // });
    pt_rollLines.map((line) => {
      if (line.pickTicketRollLineNumber == rowData.pickTicketRollLineNumber) {
        line = rowData;
      }
    });
    this.calculateLineTotal(pickTicketLine, pt_rollLines);
    this.setState({
      pickTicketLineData: pickTicketLine,
      pt_rollLines: pt_rollLines,
    });

    // this.calculateLineTotal(pickTicketLine)
    // this.setState({ pickTicketRollLineData: rowData ,pickTicketLineData : pickTicketLine});
  };

  /*RollLineLineDetailsColumnDefinitions = () => {
    let columnList = [];
    let moduleCaption = this.props.moduleCaption;
    let roll = new PickTicketRollLineBean();

    columnList.push(
      new BootstrapDataGridColumnDefinition()
        .setDetails(" ", "isSelected")
        .setColumnType("checkBox")
        .setColumnOnChangeLink(this.onRollSelectedChange)
        .setWidth("30px")
        .setSortColumn(true)
    );
    columnList.push(
      new BootstrapDataGridColumnDefinition()
        .setDetails("RollSKU#", "rollSkuNumber")
        .setWidth("80px")
        .setSortColumn(true)
    );
    columnList.push(
      new BootstrapDataGridColumnDefinition()
        .setDetails("Box#", "boxNumber")
        .setWidth("60px")
        .setSortColumn(true)
    );
    columnList.push(
      new BootstrapDataGridColumnDefinition()
        .setDetails("Roll#", "rollNumber")
        .setWidth("60px")
        .setSortColumn(true)
    );
    columnList.push(
      new BootstrapDataGridColumnDefinition()
        .setDetails("AvailQty", "availableQuantity")
        .setWidth("80px")
        .setSortColumn(true)
    );
    columnList.push(
      new BootstrapDataGridColumnDefinition()
        .setDetails("PickedQty", "pickedQuantity")
        .setWidth("80px")
        .setSortColumn(true)
    );

    columnList.push(
      new BootstrapDataGridColumnDefinition()
        .setEditable(true)

        .setDetails("PickedQty[Current]", "currentlyPickedQuantity")
        .setColumnType("Number")
        .setColumnOnChangeLink(this.onLinePickedQtyChange)
        .setColumnOnBlurLink(this.onLinePickedQtyBlur)
        .setWidth("160px")
        .setSortColumn(true)
    );
    columnList.push(
      new BootstrapDataGridColumnDefinition()
        .setDetails("VenLot#", "vendorBatchNumber")
        .setWidth("90px")
        .setSortColumn(true)
    );
    columnList.push(
      new BootstrapDataGridColumnDefinition()
        .setDetails("Location", "locationCode")
        .setWidth("100px")
        .setSortColumn(true)
    );

    columnList.push(
      new BootstrapDataGridColumnDefinition()
        .setDetails("PickedLoc", "pickedLocationCode")
        .setWidth("140px")
        .setSortColumn(true)
    );

    columnList.push(
      new BootstrapDataGridColumnDefinition()
        .setDetails("BinLoc", "binLocation")
        .setWidth("110px")
        .setSortColumn(true)
    );

    return columnList;
  };*/
  // graphValueProvider = (val, rowData) => {
  //   if (
  //     parseFloat(rowData.inventoryReceivedQuatity) ===
  //     parseFloat(rowData.availableQuantity)
  //   ) {
  //     return <div className="square-fill-blue"></div>;
  //   } else {
  //     return <div className="square-partial-yellow"></div>;
  //   }
  // };

  graphValueProvider = (column, row, data) => {
    if (
      parseFloat(row.inventoryReceivedQuatity) ===
      parseFloat(row.availableQuantity)
    ) {
      return "square-fill-blue";
    } else {
      return "square-partial-yellow";
    }
  };
  rollLineColumns = () => {
    const columns = new Array();
    columns.push(
      new ColumnDefinition()
        .setDetails("", "isSelected", false)
        .setInputDetails(
          false,
          false,
          true,
          null,
          this.onRollSelectedChange,
          null
        )
        .setStyleDetails("", "", "", "wt-1-5 ", "wt-1-5 ")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("RollSKU#", "rollSkuNumber", true)
        .setStyleDetails("left", "", "", "wt-4 ", "wt-4 ")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Box#", "boxNumber", true)
        .setStyleDetails("left", "", "", "wt-4 ", "wt-4 ")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Roll#", "rollNumber", true)
        .setStyleDetails("left", "", "", "wt-4 ", "wt-4 ")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("AvailQty", "availableQuantity", true, true)
        .setStyleDetails("right", "", "", "wt-4 ", "wt-4 ")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("PickedToDate", "pickedQuantity", true, true)
        .setStyleDetails("right", "", "", "wt-4 ", "wt-4 ")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Picked [Current]", "currentlyPickedQuantity", true)
        .setStyleDetails("right", "", "", "wt-4 ", "wt-4 ")
        .setInputDetails(
          false,
          true,
          false,
          this.onLinePickedQtyChange,
          null,
          this.onLinePickedQtyBlur
        )
    );

    columns.push(
      new ColumnDefinition()
        .setDetails("LOT#", "vendorBatchNumber", true)
        .setStyleDetails("left", "", "", "wt-4 ", "wt-4 ")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("PO#", "purchasOrderNumber", true)
        .setStyleDetails("left", "", "", "wt-4 ", "wt-4 ")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("PR#", "purchaseOrderReceiptNumber", true)
        .setStyleDetails("left", "", "", "wt-4 ", "wt-4 ")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Location", "locationCode", true)
        .setStyleDetails("left", "", "", "wt-4 ", "wt-4 ")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("PickedLoc", "pickedLocationCode", true)
        .setStyleDetails("left", "", "", "wt-4 ", "wt-4 ")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Bin#", "binLocation", true)
        .setStyleDetails("left", "", "", "wt-4 ", "wt-4 ")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("", "", true)
        .setGraphDetails(true, this.graphValueProvider)
        .setStyleDetails("left", "", "", "wt-2 ", "wt-2 ")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("", "ExtraOrderQty", false)

        .setClickDetails(
          false,
          true,
          this.extraOrderQtyOnClick,
          "ExtraOrderQty"
        )
        .setStyleDetails("", "", "", "wt-2 ", "wt-2 ")
    );

    return columns;
  };

  RollLineLineDetailsColumnDefinitions = () => {
    let columnList = [];
    // let moduleCaption = this.props.moduleCaption;
    // let roll = new PickTicketRollLineBean();

    columnList.push(
      new DataGridColumnDefinition()
        .setDetails("", "isSelected", 0, false, null, false, null)
        .setEditableDetails(
          false,
          "",
          null,
          false,
          null,
          true,
          this.onRollSelectedChange
        )
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails(
        this.state.is3PL ? "Inventory#" : "RollSKU#",
        "rollSkuNumber"
      )
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails("Box#", "boxNumber")
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails("Roll#", "rollNumber")
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails("AvailQty", "availableQuantity")
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails(
        "PickedToDate",
        "pickedQuantity"
      )
    );
    columnList.push(
      new DataGridColumnDefinition()
        .setDetails(
          "Picked [Current]",
          "currentlyPickedQuantity",
          0,
          false,
          null,
          false,
          null
        )
        .setEditableDetails(
          true,
          "currentlyPickedQuantity",
          this.onLinePickedQtyChange,
          false,
          null,
          false,
          null,
          this.onLinePickedQtyBlur
        )
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails("VenLot#", "vendorBatchNumber")
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails("PO#", "purchasOrderNumber")
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails(
        "PR#",
        "purchaseOrderReceiptNumber"
      )
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails("Location", "locationCode")
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails(
        "PickedLoc",
        "pickedLocationCode"
      )
    );
    // columnList.push(new DataGridColumnDefinition().setDetails("", "Image"));
    columnList.push(
      new DataGridColumnDefinition().setDetails("Bin#", "binLocation")
    );

    columnList.push(
      new DataGridColumnDefinition().setDetails(
        "",
        "",
        0,
        false,
        null,
        false,
        null,
        "8em",
        "14%",
        false,
        null,
        true,
        this.graphValueProvider
      )
    );
    columnList.push(
      new DataGridColumnDefinition()
        .setDetails(
          "",
          "ExtraOrderQty",
          // true,
          1,
          false,
          null,
          false,
          null, //image link call back
          "12em", //min-width
          "14%", //max-width
          false,
          null,
          false
        )
        .setEditableDetails(
          false,
          "",
          null,
          true,
          this.extraOrderQtyOnClick,
          false,
          null
        )
      // .setDisabled(disableSalesOrderFormFields)
    );

    return columnList;
  };

  RateDetailsColumnDefinitions = () => {
    let columnList = [];
    columnList.push(
      new BootstrapDataGridColumnDefinition()
        .setDetails("Service", "serviceMethodCode")
        .setColumnType("hyperLink")
        .callHyperLinkCallback(this.lnkServiceMethodClick)
        .setSortColumn(true)
        .setWidth("80px")
    );
    columnList.push(
      new BootstrapDataGridColumnDefinition()
        .setDetails("ServiceName", "serviceMethodName")
        .setWidth("80px")
        .setSortColumn(true)
    );
    columnList.push(
      new BootstrapDataGridColumnDefinition()
        .setDetails("Carrier", "carrierCode")
        .setWidth("90px")
        .setSortColumn(true)
    );
    columnList.push(
      new BootstrapDataGridColumnDefinition()
        .setDetails("Rate", "totalShipmentRate")
        .setWidth("90px")
        .setSortColumn(true)
    );
    columnList.push(
      new BootstrapDataGridColumnDefinition()
        .setDetails("Details", "rateDetails")
        .setWidth("260px")
        .setSortColumn(true)
    );
    return columnList;
  };
  onSelectedChange = (e, rowData) => {
    // let pickTicketData = this.state.pickTicketData;
    // const isActive = e.target.value;
    // if (isActive) {
    //   pickTicketData.salesInvoiceNumber = rowData.code;
    //   this.setState({
    //     pickTicketData: pickTicketData,
    //   });
    // }

    if (rowData.isActive === true) {
      let selectedLine = this.state.selectedRowDataList;
      selectedLine.push(rowData);
      this.setState({ selectedRowDataList: selectedLine });
    } else {
      let checkLines = this.state.selectedRowDataList;
      let selectedLine = [];
      for (let line of checkLines) {
        if (line.isActive != rowData.isActive) {
          selectedLine.push(line);
          this.setState({ selectedRowDataList: selectedLine });
        } else if (this.state.selectedRowDataList.length == 1) {
          this.setState({ selectedRowDataList: [] });
        }
      }
    }
  };
  closeModalCallBack = (isOpen) => {
    this.setState({
      isShowInvoiceModule: isOpen,
      moduleForPopup: [],
      isShowSalesModule: isOpen,
    });
  };
  onPopupModalExit = () => {
    this.closeModalCallBack(false);
  };
  viewInvoiceModule = (code, rowData) => {
    if (code !== "" && code !== undefined) {
      this.setState({
        isShowInvoiceModule: true,
        moduleForPopup: (
          <PopupInvoiceModule
            invoiceCode={code}
            onModuleExit={this.onPopupModalExit}
          />
        ),
      });
    }
  };
  InvoiceColumnDefinitions = () => {
    let columnList = [];
    columnList.push(
      new DataGridColumnDefinition()
        .setDetails("", "isActive")
        .setEditableDetails(
          false,
          "",
          null,
          false,
          null,
          true,
          this.onSelectedChange
        )
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails(
        "invoice",
        "code",
        // true,
        1,
        true,
        this.viewInvoiceModule,
        false,
        null
        // "3px", //min-width
        // "5%" //max-width
      )
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails(
        "S.O",
        "salesOrderNumber",
        1,
        true,
        null,
        false,
        null
        // "3px", //min-width
        // "5%" //max-width)
      )
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails(
        "PickTicket",
        "pickTicketNumber"
      )
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails("CreatedDate", "createdDate")
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails(
        "Invoice Amount",
        "grandTotalAmount"
      )
    );
    return columnList;
  };
  lnkLineDetailsClickReponse = (response) => {
    const pt_rollLines = new Array();
    const skuBatchInventories = new Array();
    const pickTicketLineData = { ...this.state.pickTicketLineData };
    if (!isEmptyArray(pickTicketLineData.rollLines))
      pt_rollLines.push(...pickTicketLineData.rollLines);
    // pt_rollLines = pickTicketLineData.rollLines;
    // this.state.pt_rollLines = pt_rollLines;
    // this.setState({ pt_rollLines: pt_rollLines });

    if (response.data != null) {
      if (!isEmptyArray(response.data.skuBatchInventories)) {
        // this.state.skuBatchInventories = response.data.skuBatchInventories;
        skuBatchInventories.push(...response.data.skuBatchInventories);
        this.setState({ isLoading: false, loadingText: "" });
      }
      this.loadRollLines(pt_rollLines, skuBatchInventories);
    } else {
      this.setState({ isLoading: false, loadingText: "" });
    }
  };

  lnkLineDetailsClickError = (error) => {
    ShowError("Error : " + error);
  };

  lnkLineDetailsClick = (rowData) => {
    this.setState({ isLoading: true, loadingText: "Loading.." });
    const ptLine = { ...rowData };
    this.state.pickTicketLineData = ptLine;
    this.state._pickTicketLine = { ...ptLine };
    const pickTicketData = { ...this.state.pickTicketData };
    const input = new SKUBatchInventorySearchCriteria();
    input.companyCode = this.companyCode;
    input.fabricStyleCode = ptLine.fabricStyleCode;
    input.colorCode = ptLine.colorCode;
    input.skuNumber = ptLine.skuNumber;
    input.reserveCustomerCode = pickTicketData.customerCode;
    input.locationCode = pickTicketData.prefferedLocationCode;
    if (
      pickTicketData.status != LogicConstants.PICK_TICKET_UNAPPROVE_STATUS &&
      ptLine != LogicConstants.PICK_TICKET_LINE_OPEN_STATUS
    ) {
      input.pickTicketNumber = pickTicketData.code;
      input.pickTicketLineNumber = ptLine.pickTicketLineNumber;
    }
    if (SecurityAccessManager.PickticketMaintenance_IsAccessible()) {
      InventoryService.getAvailableSKUBatchInventoriesNotInInitialInventoryForPickTicket(
        input,
        this.lnkLineDetailsClickReponse,
        this.lnkLineDetailsClickError
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  getMaxLineNumberForPTPalletLines = () => {
    let maxLineNumber = 0;
    let ptLnPalletLines = this.state.ptLnPalletLines;
    if (!isEmptyArray(ptLnPalletLines)) {
      ptLnPalletLines.map((line) => {
        if (line.palletLineNumber > maxLineNumber) {
          maxLineNumber = line.palletLineNumber;
        }
      });
    }
    return maxLineNumber;
  };
  palletLnHandler = (e) => {
    if (e.detail <= 1) {
      const pickTicketLineData = this.state.pickTicketLineData;

      const ptLnPalletData = new PickTicketLinePalletDetailBean();
      ptLnPalletData.companyCode = this.companyCode;
      ptLnPalletData.pickTicketNumber = pickTicketLineData.pickTicketNumber;
      ptLnPalletData.fabricStyleCode = pickTicketLineData.fabricStyleCode;
      ptLnPalletData.fabricStyleName = pickTicketLineData.fabricStyleName;
      ptLnPalletData.colorCode = pickTicketLineData.colorCode;
      ptLnPalletData.pickTicketLineNumber =
        pickTicketLineData.pickTicketLineNumber;
      let lineNumber = this.getMaxLineNumberForPTPalletLines();
      ptLnPalletData.palletLineNumber = ++lineNumber;
      this.setState({
        isShowPtlnPalletEntyPopup: true,
        ptLnPalletData: ptLnPalletData,
      });
    }
  };
  ptPlPalletLineOnchange = (e) => {
    let ptLnPalletData = this.state.ptLnPalletData;
    ptLnPalletData[e.target.name] = e.target.value;
    this.setState({ ptLnPalletData: ptLnPalletData });
  };
  addOrUpdatePtLnPalletLines = (e) => {
    if (e.detail === 1) {
      const pickTicketLineData = this.state.pickTicketLineData;
      const pickTicketData = this.state.pickTicketData;
      const ptLnPalletLines = this.state.ptLnPalletLines;
      if (!isEmptyArray(ptLnPalletLines)) {
        pickTicketLineData.palletLines = ptLnPalletLines;
        this.setState({
          pickTicketLineData: pickTicketLineData,
        });
        if (!isEmptyArray(pickTicketData.pickTicketLines)) {
          pickTicketData.pickTicketLines.map((line, i) => {
            if (
              line.pickTicketLineNumber ==
              pickTicketLineData.pickTicketLineNumber
            ) {
              pickTicketLineData.pickTicketLineNumber =
                line.pickTicketLineNumber;
              pickTicketLineData.isFetched = line.isFetched;
              pickTicketData.pickTicketLines[i] = pickTicketLineData;
            }
          });
        }
      }
      this.closeAlertModalCallBackLvl3();

      setTimeout(() => {
        this.setState({
          ptLnPalletLines: ptLnPalletLines,
        });
      }, 5000);
    }
  };
  validatePtLnPalletForm = (palletData) => {
    let isValid = false;
    let err_list = [];
    let errorMessage = "";
    if (palletData == null) {
      let errMsg = "Enter All Fields ";
      errorMessage = errorMessage + errMsg;
      err_list.push(errMsg);
    } else {
      if (isEmptyString(palletData.palletNumber)) {
        let errMsg = " PalletNumber is Required";
        errorMessage = errorMessage + errMsg;
        err_list.push(errMsg);
      }
      if (palletData.numberOfItemsPerPallet <= 0) {
        let errMsg = " No Of Items Per Pallet is Required";
        errorMessage = errorMessage + errMsg;
        err_list.push(errMsg);
      }
      if (palletData.weight <= 0) {
        let errMsg = " Weight is Required";
        errorMessage = errorMessage + errMsg;
        err_list.push(errMsg);
      }
      if (palletData.palletDimension <= 0) {
        let errMsg = " PalletDimension is Required";
        errorMessage = errorMessage + errMsg;
        err_list.push(errMsg);
      }
    }
    if (err_list.length > 0) {
      isValid = false;
      this.setState({
        alertMessage: err_list,
        alertType: "danger",
        isShowAlertLvl5: true,
      });
    } else {
      isValid = true;
      this.setState({ isShowAlertLvl5: false });
    }
    return isValid;
  };
  addOrUpdatePtLnPalletData = (e) => {
    if (e.detail === 1) {
      const ptLnPalletData = this.state.ptLnPalletData;
      ptLnPalletData.companyCode = this.companyCode;

      let ptLnPalletLines = new Array();
      if (!isEmptyArray(this.state.ptLnPalletLines)) {
        ptLnPalletLines = this.state.ptLnPalletLines;
      }
      let isValid = false;
      isValid = this.validatePtLnPalletForm(ptLnPalletData);
      if (isValid) {
        let isLineFound = false;
        if (!isEmptyArray(ptLnPalletLines)) {
          ptLnPalletLines.map((line, i) => {
            if (line.palletLineNumber == ptLnPalletData.palletLineNumber) {
              ptLnPalletData.palletLineNumber = line.palletLineNumber;
              ptLnPalletData.isFetched = line.isFetched;
              ptLnPalletLines[i] = ptLnPalletData;
              isLineFound = true;
            }
          });
        }
        if (!isLineFound) {
          ptLnPalletLines.push(ptLnPalletData);
        }
        this.state.ptLnPalletLines = ptLnPalletLines;
        this.setState({
          ptLnPalletLines: ptLnPalletLines,
        });
        this.closeAlertModalCallBackLvl5();
      }
    }
  };
  clearPtLnPalletData = (e) => {
    if (e.detail === 1) {
      const ptLnPalletData = new PickTicketLinePalletDetailBean();
      this.setState({
        ptLnPalletData: ptLnPalletData,
      });
    }
  };

  openPtLnPalletDetails = (e, rowData) => {
    if (e.detail === 1) {
      const ptLnPalletData = { ...rowData };
      this.setState({
        ptLnPalletData: ptLnPalletData,
        isShowPtlnPalletEntyPopup: true,
      });
    }
  };
  pickedQtyHandler = (rowData) => {
    let ptLnPalletLines = new Array();
    if (rowData.shippedQuantity != rowData.orderQuantity) {
      if (rowData.pickedQuantity > 0 && rowData.pickedQuantity != null) {
        if (!isEmptyArray(rowData.palletLines))
          ptLnPalletLines = rowData.palletLines;
        const pickTicketLineData = { ...rowData };
        this.setState({
          isShowPtLnPalletDetailsPopup: true,
          // ptLnPalletData: ptLnPalletData,
          ptLnPalletLines: ptLnPalletLines,
          pickTicketLineData: pickTicketLineData,
        });
      }
    }
  };
  //#endregion
  onCriteriaChange = (e) => {
    let criteria = this.state.pickTicketCriteria;
    criteria.companyCode = this.companyCode;
    // if (e.target.name == "criteriakey") {
    // criteria["purchaseOrderNumberContains"] = e.target.value;
    criteria[e.target.name] = e.target.value;
    // }
    this.setState({ pickTicketCriteria: criteria });
  };
  isModifyPosible = () => {
    let isModify = false;
    let pickTicketData = this.state.pickTicketData;
    if (
      pickTicketData.status == LogicConstants.PICK_TICKET_PICKED_STATUS ||
      pickTicketData.status ==
        LogicConstants.PICK_TICKET_PARTIALLY_PICKED_STATUS ||
      pickTicketData.status ==
        LogicConstants.PICK_TICKET_PARTIALLY_INVOICED_STATUS
    ) {
      isModify = true;
    }
    return isModify;
  };

  reArrangeBoxLineDisplayLineNumbers = (boxLineList) => {
    let maxLineNumber = 0;
    boxLineList.map((line) => {
      //if(line.deleted == false || line.isDeleted == false){
      ++maxLineNumber;
      line.displayLineNumber = maxLineNumber;
      //}
    });
  };

  printLabelBox = (rowData) => {
    let request = new RestPickTicketShipmentLabelPrintRequest();
    request.companyCode = this.companyCode;
    request.pickTicketNumber = rowData.pickTicketNumber;
    request.boxLineNumber = rowData.boxLineNumber;
    this.setState({
      isLoading: true,
      loadingText: "Printing..",
    });
    if (SecurityAccessManager.PickticketMaintenance_IsAccessible()) {
      ReportService.printPickTicketBoxShipmentLabel(
        request,
        this.printBoxResponse,
        this.printBoxError
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };

  printBoxResponse = (response) => {
    this.setState({
      isLoading: false,
      loadingText: "",
    });
    this.showErrorMessage(response.data);
    if (
      response.data != null &&
      response.data.reportResult != null &&
      !isEmptyString(response.data.reportResult.reportFileID)
    ) {
      let reportFilePath = response.data.reportResult.reportFileID;
      window.open(this.report_url + reportFilePath);
    }
  };
  printBoxError = (error) => {
    this.setState({
      isLoading: false,
      loadingText: "",
    });
    ShowError("Error : " + error);
  };

  deleteBoxLine = (rowData) => {
    let tempPickTicketData = this.state.pickTicketData;
    var temp_boxLine = tempPickTicketData.boxDetails;

    let line = rowData;

    // if (rowData.isFetched == false) {
    var index = temp_boxLine.indexOf(line);
    if (index > -1) {
      temp_boxLine.splice(index, 1);
    }
    this.reArrangeBoxLineDisplayLineNumbers(temp_boxLine);
    this.setState({ pickTicketData: tempPickTicketData });
  };

  advanceSearch = () => {
    this.setState({ isShowAdvanceSearchPopup: true });
  };

  onAdvanceSearchClick = (e) => {
    //this.state.pickTicketCriteria.specialSearchText = "";
    if (e.detail === 1) {
      this.loadPage(1);
      this.setState({
        isAdvanceSearch: true,
        isShowAdvanceSearchPopup: false,
        pickTicketCriteria: new PickTicketSearchCriteria(),
      });
    }
  };
  onAdvSearchChange = (e) => {
    let pickTicketCriteria = this.state.pickTicketCriteria;
    pickTicketCriteria.companyCode = this.companyCode;
    pickTicketCriteria[e.target.name] = e.target.value;
    this.setState({ pickTicketCriteria: pickTicketCriteria });
  };

  getCriteriaString = () => {
    let criteriaString = "";
    let moduleCaption = this.state.moduleCaption;
    if (this.state.pickTicketCriteria == null) {
      return <div />;
    } else {
      if (!isEmptyString(this.state.pickTicketCriteria.pickTicketCode))
        criteriaString =
          criteriaString +
          moduleCaption +
          "# : " +
          this.state.pickTicketCriteria.pickTicketCode +
          " ; ";
      if (!isEmptyString(this.state.pickTicketCriteria.pickTicketContains))
        criteriaString =
          criteriaString +
          moduleCaption +
          "# StartsWith : " +
          this.state.pickTicketCriteria.pickTicketContains +
          " ; ";
      if (!isEmptyString(this.state.pickTicketCriteria.pickTicketStartsWith))
        criteriaString =
          criteriaString +
          moduleCaption +
          "# Contains : " +
          this.state.pickTicketCriteria.pickTicketStartsWith +
          " ; ";

      if (!isEmptyString(this.state.pickTicketCriteria.salesOrderNumber))
        criteriaString =
          criteriaString +
          "Customer# : " +
          this.state.pickTicketCriteria.salesOrderNumber +
          " ; ";
    }
    return <div>{criteriaString}</div>;
  };
  handleSortingChange = (accessor) => {
    let sortField = accessor;
    let order = this.state.order;
    let sortOrder = accessor === sortField && order === "asc" ? "desc" : "asc";
    this.setState({
      order: sortOrder,
      sortField: sortField,
    });
    this.handleSorting(sortField, sortOrder);
  };
  handleSorting = (sortField, sortOrder) => {
    let pickTicketList = this.state.pickTicketList;
    if (sortField && !isEmptyArray(pickTicketList)) {
      const sorted = [...pickTicketList].sort((a, b) => {
        if (a[sortField] === null) return 1;
        if (b[sortField] === null) return -1;
        if (a[sortField] === null && b[sortField] === null) return 0;
        return (
          a[sortField].toString().localeCompare(b[sortField].toString(), "en", {
            numeric: true,
          }) * (sortOrder === "asc" ? 1 : -1)
        );
      });
      this.setState({ pickTicketList: sorted });
    }
  };
  getHeaderView() {
    return (
      <PickTicketEntryForm
        {...this.state}
        isFocus={this.state.isFocus}
        ref={this.entryFormRef}
        pickTicketData={this.state.pickTicketData}
        pickTicketLineData={this.state.pickTicketLineData}
        moduleCaption={this.state.moduleCaption}
        onChange={this.onChange}
        onLineChange={this.onLineChange}
        isModifyPosible={this.isModifyPosible}
        lnkLineDetailsClick={this.lnkLineDetailsClick}
        pickedQtyHandler={this.pickedQtyHandler}
        isReadOnlyOrDisabled={this.state.isReadOnlyOrDisabled}
        isDisabledFields={this.state.isDisabledFields}
        openShipperPopup={this.openShipperPopup}
        openPackerPopup={this.openPackerPopup}
        lnkSalesModule={this.lnkSalesModule}
        locationCodeOnChange={this.locationCodeOnChange}
        locationEnterKeyEventHandler={this.locationEnterKeyEventHandler}
        displayAutoCompleteLocationList={this.displayAutoCompleteLocationList}
      />
    );
  }
  getListView() {
    return (
      <PickTicketListForm
        {...this.state}
        pickTicketList={this.state.pickTicketList}
        pageList={this.state.pageList}
        pickTicketCriteria={this.state.pickTicketCriteria}
        filterPickTicket={this.filterPickTicket}
        loadFirst={this.loadFirst}
        loadNext={this.loadNext}
        loadPrevious={this.loadPrevious}
        loadLast={this.loadLast}
        editPickTicket={this.editPickTicket}
        resetFilteredPickTicket={this.resetFilteredPickTicket}
        isLoading={this.state.isLoading}
        advanceSearch={this.advanceSearch}
        getCriteriaString={this.getCriteriaString}
        isAdvanceSearch={this.state.isAdvanceSearch}
        moduleCaption={this.state.moduleCaption}
        onCriteriaChange={this.onCriteriaChange}
        handleSortingChange={this.handleSortingChange}
      />
    );
  }

  getShippingInformationView() {
    return (
      <ShippingInformationEntryForm
        {...this.state}
        ref={this.shippingInformationFormRef}
        pickTicketData={this.state.pickTicketData}
        moduleCaption={this.state.moduleCaption}
        onChange={this.onChange}
        isModifyPosible={this.isModifyPosible}
        onShipToAddressChange={this.onShipToAddressChange}
        addNewBoxLine={this.addNewBoxLine}
        lnkBoxLineDetailsClick={this.lnkBoxLineDetailsClick}
        updateandFetchRates={this.updateandFetchRates}
        saveShipment={this.saveShipment}
        generateAllLabels={this.generateAllLabels}
        manualVoidShipment={this.manualVoidShipment}
        voidShipment={this.voidShipment}
        freightMethods={this.state.freightMethods}
        shipVias={this.state.shipVias}
        cityList={this.state.cityList}
        stateList={this.state.stateList}
        countryList={this.state.countryList}
        shipTos={this.state.shipTos}
        isDisabledFields={this.state.isDisabledFields}
        onShipToChange={this.onShipToChange}
        shipToEnterKeyEventHandler={this.shipToEnterKeyEventHandler}
        shipToPageListForAutoCompleteList={
          this.state.shipToPageListForAutoCompleteList
        }
        showAutoCompleteShipToList={this.state.showAutoCompleteShipToList}
        displayAutoCompleteShipToList={this.displayAutoCompleteShipToList}
        deleteBoxLine={this.deleteBoxLine}
        printLabelBox={this.printLabelBox}
        onShipViaChange={this.onShipViaChange}
        shipViaEnterKeyEventHandler={this.shipViaEnterKeyEventHandler}
        displayAutoCompleteShipViaList={this.displayAutoCompleteShipViaList}
        onFreightMethodChange={this.onFreightMethodChange}
        freightMethodEnterKeyEventHandler={
          this.freightMethodEnterKeyEventHandler
        }
        displayAutoCompleteFreightMethodList={
          this.displayAutoCompleteFreightMethodList
        }
        onCityChange={this.onCityChange}
        cityEnterKeyEventHandler={this.cityEnterKeyEventHandler}
        displayAutoCompleteCityList={this.displayAutoCompleteCityList}
        onStateChange={this.onStateChange}
        stateEnterKeyEventHandler={this.stateEnterKeyEventHandler}
        displayAutoCompleteStateList={this.displayAutoCompleteStateList}
        onCountryChange={this.onCountryChange}
        countryEnterKeyEventHandler={this.countryEnterKeyEventHandler}
        displayAutoCompleteCountryList={this.displayAutoCompleteCountryList}
        onLogisticMethodCodeChange={this.onLogisticMethodCodeChange}
        logisticEnterKeyEventHandler={this.logisticEnterKeyEventHandler}
        displayAutoCompleteLogisticList={this.displayAutoCompleteLogisticList}
      />
    );
  }
  getInvoicesView() {
    return (
      <InvoicesForm
        pickTicketData={this.state.pickTicketData}
        dependenciesBean={this.state.dependenciesBean}
      />
    );
  }
  getChangesHistoryView() {
    return <ChangesHistoryForm pickTicketData={this.state.pickTicketData} />;
  }
  // getPalletView() {
  //   return (
  //     <PalletForm
  //       {...this.state}
  //       pickTicketData={this.state.pickTicketData}
  //       dependenciesBean={this.state.dependenciesBean}
  //     />
  //   );
  // }
  getModuleListView = () => {
    let pickTicketData = this.state.pickTicketData;
    if (this.isLocked) {
      this.isLocked = false;
      if (!this.state.isViewMode) this.unLockPickTicket(pickTicketData.code);
    } else {
      this.isLocked = false;
    }
    this.closeEntryForm();
    this.loadPickTickets();
  };
  resetView = () => {
    let pageTitle = this.state.moduleCaption + " - " + NEW_ENTRY;
    let pickTicket = this.state.pickTicketData;
    this.state.isReseted = true;
    if (this.isLocked) {
      this.isLocked = false;
      if (!this.state.isViewMode) this.unLockPickTicket(pickTicket.code);
    } else {
      this.isLocked = false;
    }
    this.setState({
      pickTicketData: new PickTicketBean(),
      shipperAndPackerData: new PickTicketBean(),
      isResetModule: true,
      moduleKeyCode: NEW_ENTRY,
      disabled: false,
      isFocus: false,
      isFocusLookup: true,
      isResetView: true,
      pageTitle: pageTitle,
      isShowCancelButton: false,
      isShowPDFReportButton: false,
      isShowGenerateInvoiceButton: false,
      isShowPrintLabelButton: false,
      isShowSyncButton: false,
      isShowShippingButton: false,
      isShowPackingListButton: false,
      isShowMailPackingButton: false,
      isShowExcelPackingButton: false,
      isShowUpdateInvoiceButton: false,
      showAutoCompleteShipViaList: false,
      isShowSaveButton: false,
      shipViaPageListForAutoCompleteList: new Array(),
      showAutoCompleteFreightMethodList: false,
      freightMethodPageListForAutoCompleteList: new Array(),
      showAutoCompleteCityList: false,
      cityPageListForAutoCompleteList: new Array(),
      showAutoCompleteStateList: false,
      statePageListForAutoCompleteList: new Array(),
      showAutoCompleteCountryList: false,
      countryPageListForAutoCompleteList: new Array(),
    });
    this.state.moduleKeyCode = NEW_ENTRY;
    this.code = NEW_ENTRY;
    this.state.isViewMode = false;
    this.getHeaderView();
    this.hideAlertCallBack();
  };
  onModuleKeyCodeChange = (e) => {
    let moduleKeyCode = this.state.moduleKeyCode;
    if (e.target.value !== NEW_ENTRY && e.target.value !== "undefined") {
      moduleKeyCode = e.target.value;
    }
    this.setState({ moduleKeyCode: moduleKeyCode });
  };

  onModuleKeyCodeWithCriteriaOnChange = (e) => {
    let moduleKeyCode = this.state.moduleKeyCode;
    if (e.target.value !== NEW_ENTRY && e.target.value !== "undefined") {
      moduleKeyCode = e.target.value.toUpperCase();
    }
    this.setState({ moduleKeyCode: moduleKeyCode });
  };
  selectButtonClick = (e) => {
    if (this.state.moduleKeyCode == NEW_ENTRY) {
      let errMsg = "New PickTicket Cannot be Created";
      let errList = [];
      errList.push(errMsg);
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    } else {
      if (!this.isLocked) {
        this.editPickTicket(this.state.moduleKeyCode);
      }
    }
    // this.disable();
  };
  // selectButtonClick = (e) => {
  //   let moduleKeyCode = this.state.moduleKeyCode;

  //   let pickTicketList = this.state.pickTicketList.filter(
  //     (pickTicket) => pickTicket.code == moduleKeyCode
  //   );

  //   let pickTicketObject = null;
  //   if (pickTicketList !== null) {
  //     pickTicketObject = pickTicketList[0];
  //   }

  //   if (pickTicketObject != null) {
  //     this.editPickTicket(this.state.moduleKeyCode);
  //   } else {
  //     this.openEntryForm(this.state.moduleKeyCode);
  //   }

  //   this.setState({
  //     isFocusLookup: false,
  //     isFocus: true,
  //   });
  //   this.disable();
  // };
  disable = () => {
    this.setState({
      disabled: true,
    });
  };
  moduleExit = () => {
    let pickTicketData = this.state.pickTicketData;
    if (this.isLocked) {
      this.isLocked = false;
      this.unLockPickTicket(pickTicketData.code);
    } else {
      this.isLocked = false;
    }
    this.props.onModuleExit();
  };
  hideAlertCallBack = (msgType, isDisplayed) => {
    this.setState({ isShowAlert: isDisplayed });
  };
  hideRollAlertCallBack = (msgType, isDisplayed) => {
    this.setState({ isShowRollPopupAlert: isDisplayed });
  };
  hidePopupAlertCallBack = (msgType, isDisplayed) => {
    this.setState({
      isShowPopupAlert: isDisplayed,
      isShowLvl3Alert: isDisplayed,
    });
  };
  clearOpenInvoices = () => {
    this.setState({
      openInvoiceLines: new Array(),
    });
  };
  closeAlertModalCallBack = (isShowPopup) => {
    this.setState({
      isShowLinePopup: isShowPopup,
      isShowBoxPopup: isShowPopup,
      isShowRatePopup: isShowPopup,
      isShowPopupAlert: isShowPopup,
      isShowMailPickTicketPopup: isShowPopup,
      isShowOpenInvoicesPopup: isShowPopup,
      isShowAlert: isShowPopup,
      isShowLvl3Alert: isShowPopup,
      isShowAdvanceSearchPopup: isShowPopup,
      palletLines: new Array(),
      pt_rollLines: new Array(),
      _pickTicketLine: new PickTicketLineBean(),
    });
    this.clearOpenInvoices();
  };
  closeAlertModalCallBackLvl4 = (isShowPopup) => {
    this.setState({
      isShowPalletSummary: false,
    });
    this.hideAlertCallBackLvl4();
  };
  hideAlertCallBackLvl4 = (msgType, isDisplayed) => {
    this.setState({
      isShowAlertLvl4: isDisplayed,
    });
  };
  closeAlertRollModalCallBack = (isShowPopup) => {
    this.setState({
      isShowRollPopup: isShowPopup,
      isShowRollPopupAlert: isShowPopup,
      rollList: [],
      selectedRollLines: [],
      pickTicketRollLineData: new PickTicketRollLineBean(),
    });
  };
  generatePalletSummary = (e) => {
    if (e.detail === 1) {
    }
  };
  newEntry = () => {
    let errMsg =
      "New PickTicket Not Allowed. Generate PickTicket Through SalesOrder";
    let errList = [];
    errList.push(errMsg);
    this.setState({
      alertMessage: errList,
      alertType: "danger",
      isShowAlert: true,
    });
  };

  openFindRollsLinePopup = (e) => {
    if (e.detail === 1) {
      let pickTicketLineData = this.state.pickTicketLineData;
      let pickTicketRollLineData = new PickTicketRollLineBean();
      pickTicketRollLineData.companyCode = pickTicketLineData.companyCode;
      pickTicketRollLineData.pickTicketNumber =
        pickTicketLineData.pickTicketNumber;
      pickTicketRollLineData.pickTicketLineNumber =
        pickTicketLineData.pickTicketLineNumber;
      pickTicketRollLineData.fabricStyleCode =
        pickTicketLineData.fabricStyleCode;
      pickTicketRollLineData.fabricStyleName =
        pickTicketLineData.fabricStyleName;
      pickTicketRollLineData.colorCode = pickTicketLineData.colorCode;
      pickTicketRollLineData.customerCode = pickTicketLineData.customerCode;
      pickTicketRollLineData.customerName = pickTicketLineData.customerName;

      this.setState({
        pickTicketRollLineData: pickTicketRollLineData,
        pickTicketLineData: pickTicketLineData,
        isShowRollPopup: true,
      });
    }
  };
  rollOnChange = (e) => {
    let pickTicketRollLineData = this.state.pickTicketRollLineData;
    pickTicketRollLineData[e.target.name] = e.target.value;
    this.setState({ pickTicketRollLineData: pickTicketRollLineData });
  };
  findRollsOnClick = () => {
    let rollLineData = this.state.pickTicketRollLineData;
    let pt_rollLines = [...this.state.pt_rollLines];
    if (
      rollLineData.availableQuantity == 0 &&
      isEmptyString(rollLineData.rollNumber) &&
      rollLineData.rollSkuNumber == 0 &&
      isEmptyString(rollLineData.vendorBatchNumber)
    ) {
      let errMsg = "Please Enter Filter Customer Criteria";
      let errList = [];
      errList.push(errMsg);
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowRollPopupAlert: true,
      });
    } else {
      let pickTicketLine = { ...this.state.pickTicketLineData };
      let rollList = [];
      let rolls = [];
      // pickTicketLine.rollLines.map((inventoryRoll) => {
      pt_rollLines.map((inventoryRoll) => {
        let rollLine = new PickTicketRollLineBean();
        rollLine.companyCode = pickTicketLine.companyCode;
        rollLine.pickTicketNumber = pickTicketLine.pickTicketNumber;
        rollLine.pickTicketLineNumber = pickTicketLine.pickTicketLineNumber;
        rollLine.fabricStyleCode = pickTicketLine.fabricStyleCode;
        rollLine.fabricStyleName = pickTicketLine.fabricStyleName;
        rollLine.colorCode = pickTicketLine.colorCode;
        rollLine.customerCode = pickTicketLine.customerCode;
        rollLine.customerName = pickTicketLine.customerName;

        rollLine.rollSkuNumber = inventoryRoll.rollSkuNumber;
        rollLine.rollNumber = inventoryRoll.rollNumber;
        rollLine.purchasOrderNumber = inventoryRoll.purchaseOrderNumber;
        rollLine.purchaseOrderReceiptNumber =
          inventoryRoll.purchaseOrderReceiptNumber;
        rollLine.vendorBatchNumber = inventoryRoll.vendorBatchNumber;
        rollLine.vendorCode = "";
        rollLine.boxNumber = inventoryRoll.boxNumber;
        rollLine.availableQuantity = inventoryRoll.availableQuantity;
        rollLine.locationCode = inventoryRoll.locationCode;
        rollLine.orderUomCode = pickTicketLine.orderUomCode;
        rollLine.inventoryUomCode = pickTicketLine.inventoryUomCode;
        rollLine.uomConversionRate = pickTicketLine.uomConversionRate;
        rollLine.inventoryReceivedQuatity =
          inventoryRoll.inventoryReceivedQuatity;
        rollLine.isCloseOutInventory = inventoryRoll.closeOutInventory;
        rollLine.binLocation = inventoryRoll.binLocation;
        rollLine.isSelected = inventoryRoll.isSelected;
        rollLine.currentlyPickedQuantity =
          inventoryRoll.currentlyPickedQuantity;
        rollLine.pickedQuantity = inventoryRoll.pickedQuantity;
        rollList.push(rollLine);
        //}
      });
      let rollLines = [];
      rollLines = rollList;
      rollLines.map((ln) => {
        if (
          rollLineData.rollNumber === ln.rollNumber ||
          rollLineData.rollSkuNumber === ln.rollSkuNumber ||
          rollLineData.vendorBatchNumber === ln.vendorBatchNumber ||
          rollLineData.availableQuantity <= ln.availableQuantity ||
          rollLineData.toAvailableQuantity >= ln.availableQuantity
        ) {
          rolls.push(ln);
        } else {
          let errMsg = "No Matching Data Found";
          let errList = [];
          errList.push(errMsg);
          this.setState({
            alertMessage: errList,
            alertType: "danger",
            isShowRollPopupAlert: true,
          });
        }
      });
      // rolls = [...rollList];
      this.setState({ rollList: rolls, pt_rollLines: pt_rollLines });
    }
  };

  selectedFindRollChange = (e, rowData) => {
    // let rowData = { ...rowDatas };
    let isSelected = false;
    let pickTicketRollLine = this.state.pickTicketRollLineData;
    let pickTicketLine = this.state.pickTicketLineData;

    let rollList = this.state.rollList;
    isSelected = e.target.value;
    rowData.isSelected = e.target.value;
    if (isSelected) {
      if (!rowData.isCloseOutInventory) {
        let availableQty = rowData.availableQuantity;
        let openQty =
          pickTicketLine.toBePickedQuantity - pickTicketRollLine.pickedQuantity;
        if (openQty > availableQty) {
          let useDefaultBinLocation = false;

          useDefaultBinLocation =
            ConfigManager.getIsUseDefaultBinLocationOfTheWarehouse();
          if (useDefaultBinLocation) {
            rowData.currentlyPickedQuantity = openQty;
          } else {
            rowData.currentlyPickedQuantity = availableQty;
          }
        } else {
          rowData.currentlyPickedQuantity = openQty;
        }

        let currAvailQty =
          rowData.availableQuantity - rowData.currentlyPickedQuantity;
        if (currAvailQty > 0) rowData.isRollPartialInventoryFlag = true;
      }
    } else {
      if (!rowData.isCloseOutInventory) {
        if (
          rowData.pickedQuantity > 0 &&
          rowData.currentlyPickedQuantity == 0
        ) {
          rowData.currentlyPickedQuantity = rowData.pickedQuantity * -1;
          rowData.isRollPartialInventoryFlag = false;
        } else if (rowData.currentlyPickedQuantity > 0) {
          rowData.currentlyPickedQuantity = 0;
          rowData.isRollPartialInventoryFlag = false;
        }
      }
    }

    let selectedRollLines = this.state.selectedRollLines;
    selectedRollLines.push(rowData);
    // selectedRollLines.map((ln) => {
    //   if (ln.currentlyPickedQuantity != pickTicketLine.toBePickedQuantity) {
    //     rowData.currentlyPickedQuantity = 0;
    //   }
    // });

    this.calculateRollTotal();

    this.setState({
      pickTicketLineData: pickTicketLine,
      selectedRollLines: selectedRollLines,
      //pickTicketRollLineData: rowData,
      // rollList: rollList,
    });
  };
  calculateRollTotal = () => {
    let totalPickQty = 0;
    let totalCurrentPickQty = 0;
    let pickTicketLineData = this.state.pickTicketLineData;
    let rollList = this.state.rollList;
    //let pickTicketRollLineData = rowData;
    if (!isEmptyArray(rollList)) {
      rollList.map((line) => {
        let pickedQuantity = 0;
        if (!isEmptyString(line.pickedQuantity))
          pickedQuantity = line.pickedQuantity;
        totalPickQty += parseFloat(pickedQuantity);
        let currentlyPickedQuantity = 0;
        if (!isEmptyString(line.currentlyPickedQuantity))
          currentlyPickedQuantity = line.currentlyPickedQuantity;
        totalCurrentPickQty += parseFloat(currentlyPickedQuantity);
      });
      // pickTicketRollLineData.pickedQuantity = parseFloat(totalPickQty);
      // pickTicketRollLineData.currentlyPickedQuantity =
      //   parseFloat(totalCurrentPickQty);

      let toBePickedQty = 0;

      toBePickedQty =
        parseFloat(pickTicketLineData.orderQuantity) -
        (parseFloat(totalPickQty) + parseFloat(totalCurrentPickQty));
      pickTicketLineData.toBePickedQuantity = parseFloat(toBePickedQty);

      // if (-pickTicketLineData.toBePickedQuantity) {
      //   pickTicketLineData.toBePickedQuantity = 0;
      // }
    }
    // return;
  };
  applyRollLines = (e) => {
    if (e.detail === 1) {
      let selectedRollLines = this.state.selectedRollLines;
      let pickTicketLineData = this.state.pickTicketLineData;
      let pt_rollLines = this.state.pt_rollLines;
      let totalCurrentPickQty = 0;
      let totalPickQty = 0;
      selectedRollLines.map((ln) => {
        // pickTicketLineData.rollLines.map((rl) => {
        pt_rollLines.map((rl) => {
          if (ln.isSelected === true) {
            if (ln.rollSkuNumber === rl.rollSkuNumber) {
              rl.isSelected = true;
              rl.pickedQuantity = ln.pickedQuantity;
              rl.currentlyPickedQuantity = ln.currentlyPickedQuantity;
              // totalPickQty += parseFloat(rl.pickedQuantity);
              // totalCurrentPickQty += parseFloat(rl.currentlyPickedQuantity);
            }
          } else {
            if (ln.rollSkuNumber === rl.rollSkuNumber) {
              rl.isSelected = false;
              rl.pickedQuantity = ln.pickedQuantity;
              rl.currentlyPickedQuantity = ln.currentlyPickedQuantity;
              // totalPickQty += parseFloat(rl.pickedQuantity);
              // totalCurrentPickQty += parseFloat(rl.currentlyPickedQuantity);
            }
          }
        });
      });

      // pickTicketLineData.pickedQuantity = parseFloat(totalPickQty);
      // pickTicketLineData.currentlyPickedQuantity =
      //   parseFloat(totalCurrentPickQty);
      this.calculateLineTotal(pickTicketLineData, pt_rollLines);
      this.setState({
        pickTicketLineData: pickTicketLineData,
        pt_rollLines: pt_rollLines,
      });
      this.closeAlertRollModalCallBack(false);
    }
  };

  clearRolls = () => {
    let pickTicketRollLineData = new PickTicketRollLineBean();
    pickTicketRollLineData.toAvailableQuantity = "";
    this.setState({
      selectedRollLines: [],
      rollList: [],
      pickTicketRollLineData: pickTicketRollLineData,
    });
  };

  cancelFindRolls = (e) => {
    if (e.detail === 1) {
      this.setState({
        selectedRollLines: [],
        rollList: [],
        pickTicketRollLineData: new PickTicketRollLineBean(),
      });
      this.closeAlertRollModalCallBack(false);
    }
  };

  selectAllRoll = () => {
    let rollList = [...this.state.rollList];
    let pickTicketLine = this.state.pickTicketLineData;
    let pickTicketRollLine = this.state.pickTicketRollLineData;
    let totalqty = 0;
    rollList.map((ln) => {
      ln.isSelected = true;

      if (!ln.isCloseOutInventory) {
        let availableQty = ln.availableQuantity;
        let openQty =
          pickTicketLine.toBePickedQuantity - pickTicketRollLine.pickedQuantity;
        if (openQty > availableQty) {
          let useDefaultBinLocation = false;

          useDefaultBinLocation =
            ConfigManager.getIsUseDefaultBinLocationOfTheWarehouse();
          if (useDefaultBinLocation) {
            ln.currentlyPickedQuantity = parseFloat(openQty).toFixed(2);
          } else {
            ln.currentlyPickedQuantity = availableQty;
          }
        } else {
          ln.currentlyPickedQuantity = parseFloat(openQty).toFixed(2);
        }

        let currAvailQty = ln.availableQuantity - ln.currentlyPickedQuantity;
        if (currAvailQty > 0) ln.isRollPartialInventoryFlag = true;

        // totalqty += ln.currentlyPickedQuantity;
        // if (totalqty === openQty) {
        // }
        // let sampleqty = openQty - ln.currentlyPickedQuantity;
        // if (pickTicketLine.toBePickedQuantity < totalqty) {
        //   // if (-pickTicketLine.toBePickedQuantity) {

        //   ln.currentlyPickedQuantity = 0;
        //   // }
        // }
      }
      this.calculateRollTotal();
    });

    // let calc = this.calculateRollTotal();
    this.setState({ selectedRollLines: rollList });
  };
  unSelectAllRoll = () => {
    let rollList = [...this.state.rollList];
    rollList.map((ln) => {
      ln.isSelected = false;
      ln.currentlyPickedQuantity = 0;
    });
    this.calculateRollTotal();
    this.setState({ selectedRollLines: rollList });
  };
  shipperAndPackerOnChange = (e) => {
    let shipperAndPackerData = this.state.shipperAndPackerData;
    shipperAndPackerData[e.target.name] = e.target.value;
    this.setState({ shipperAndPackerData: shipperAndPackerData });
  };
  updateShipperData = (e) => {
    if (e.detail === 1) {
      let shipperAndPackerData = this.state.shipperAndPackerData;
      let pickTicketData = this.state.pickTicketData;
      pickTicketData.shippedBy = shipperAndPackerData.shippedBy;
      pickTicketData.shippedDate = shipperAndPackerData.shippedDate;
      this.setState({ pickTicketData: pickTicketData });
      this.closeAlertModalCallBackLvl7();
    }
  };
  updatePackerData = (e) => {
    if (e.detail === 1) {
      let shipperAndPackerData = this.state.shipperAndPackerData;
      let pickTicketData = this.state.pickTicketData;
      pickTicketData.packedUpBy = shipperAndPackerData.packedUpBy;
      pickTicketData.packedUpDate = shipperAndPackerData.packedUpDate;
      this.setState({ pickTicketData: pickTicketData });
      this.closeAlertModalCallBackLvl7();
    }
  };
  openShipperPopup = () => {
    this.setState({ isShowShipperPopup: true });
  };
  openPackerPopup = () => {
    this.setState({ isShowPackerPopup: true });
  };
  closeAlertModalCallBackLvl7 = () => {
    this.setState({
      isShowShipperPopup: false,
      isShowPackerPopup: false,
      isShowAlertLvl7: false,
      shipperAndPackerData: new PickTicketBean(),
    });
  };
  hideAlertCallBackLvl7 = (msgType, isDisplayed) => {
    this.setState({ isShowAlertLvl7: isDisplayed });
  };
  errorCallBack = (error) => {
    ShowError("Error : ", error);
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: " ",
    });
  };
  UnApprovedInvoicesForCustomerResponse = (response) => {
    this.showErrorMessage(response.data);
    let openInvoiceLines = new Array();
    if (response.data != null && !isEmptyArray(response.data.invoice)) {
      openInvoiceLines = response.data.invoice;
    }
    this.setState({
      openInvoiceLines: openInvoiceLines,
      isShowOpenInvoicesPopup: true,
    });
  };
  updateExistingInvoice = () => {
    const pickTicketData = this.state.pickTicketData;
    const request = new RestReadRequest();
    request.companyCode = this.companyCode;
    request.code = pickTicketData.customerCode;
    InvoiceService.getUnApprovedInvoicesForCustomer(
      request,
      this.UnApprovedInvoicesForCustomerResponse,
      this.errorCallBack
    );
  };
  updatePickTicketAndUpdateExistingInvoiceResponse = (response) => {
    const pickTicketData = this.state.pickTicketData;
    if (response.data != null && response.data.mainOperationResponse != null) {
      if (response.data.isSucess) {
        this.closeAlertModalCallBack(false);
        this.editPickTicket(pickTicketData.pickticketNumber);
      } else {
        let errMsg = "Unable to generate Invoice";
        let err_list = new Array();
        err_list.push(errMsg);
        this.setState({
          alertMessage: err_list,
          alertType: "danger",
          isShowLvl3Alert: true,
        });
        this.closeAlertModalCallBack(false);
      }
    } else {
      let errMsg = "Unable to generate Invoice";
      let err_list = new Array();
      err_list.push(errMsg);
      this.setState({
        alertMessage: err_list,
        alertType: "danger",
        isShowAlert: true,
      });
      this.closeAlertModalCallBack(false);
    }
  };
  updateInvoice = (e) => {
    if (e.detail === 1) {
      const pickTicketData = this.state.pickTicketData;
      const selectedRowDataList = this.state.selectedRowDataList;
      if (!isEmptyArray(selectedRowDataList)) {
        pickTicketData.salesInvoiceNumber = selectedRowDataList[0].code;
        const Request = new RestPickTicket_v1Request();
        Request.pickTicketBean = pickTicketData;
        Request.isLockRequired = true;
        PickTicketService.updatePickTicketAndUpdateExistingInvoice(
          Request,
          this.updatePickTicketAndUpdateExistingInvoiceResponse,
          this.errorCallBack
        );
      } else {
        let errMsg = "Select Invoice Line";
        let err_list = new Array();
        err_list.push(errMsg);
        this.setState({
          alertMessage: err_list,
          alertType: "danger",
          isShowLvl3Alert: true,
        });
      }
    }
  };

  openPalletDetails = (e, rowData, type) => {
    if (e.detail <= 1) {
      let palletData = this.state.palletData;
      let pickTicketData = this.state.pickTicketData;
      // if(type === 1){

      // } else if(type === 2) {
      palletData = { ...rowData };
      // }
      let palletPtLineLookupHandler = new PickTicketLineLookupHandler(
        this.companyCode,
        "PickTicket Line",
        pickTicketData.code
      );
      this.setState({ palletPtLineLookupHandler: palletPtLineLookupHandler });
      this.setState({ isShowPalletPopup: true, palletData: palletData });
    }
  };
  openPalletSummary = () => {
    this.setState({
      isShowPalletSummary: true,
    });
  };
  closeAlertModalCallBackLvl5 = (isShowPopup) => {
    this.setState({
      isShowPalletPopup: false,
      palletData: new PickTicketBoxPalletLineDetailBean(),
      isShowPtlnPalletEntyPopup: false,
      ptLnPalletData: new PickTicketLinePalletDetailBean(),
    });
  };
  closeAlertModalCallBackLvl3 = (isShowPopup) => {
    this.setState({
      isShowPtLnPalletDetailsPopup: false,
      // ptLnPalletLines: new Array(),
    });
  };
  onPalletChange = (e) => {
    let palletData = this.state.palletData;
    palletData[e.target.name] = e.target.value;
    this.setState({ palletData: palletData });
  };

  onPalletPtLineChange = (e) => {
    let pickTicketLineNumber = e.target.value;
    this.state.showAutoCompletePtLineList = true;
    let palletData = this.state.palletData;
    let showAutoCompleteList = this.state.showAutoCompletePtLineList;
    if (isEmpty(pickTicketLineNumber)) {
      this.state.showAutoCompletePtLineList = false;
      let showAutoCompleteList = this.state.showAutoCompletePtLineList;
      let palletData = this.state.palletData;
      palletData.pickTicketLineNumber = "";
      palletData.fabricStyleCode = "";
      palletData.fabricStyleName = "";
      palletData.colorCode = "";
      palletData.skuNumber = "";

      let suggestion = [];
      this.setState({
        showAutoCompletePtLineList: showAutoCompleteList,
        palletData: palletData,
        ptLinePageListForAutoCompleteList: suggestion,
      });
    } else if (
      e.target.name == "pickTicketLineNumber" &&
      showAutoCompleteList === true &&
      pickTicketLineNumber !== ""
    ) {
      this.readPtLineBySearchString(e.target.value);
    }
    palletData[e.target.name] = e.target.value;
    this.setState({ palletData: palletData });
    // this.readPickTicketLines(e.target.value);
  };
  ptLinePalletCodeEnterKeyEventHandler = (e) => {
    this.readPickTicketLines(e.target.value);
    this.setState({
      ptLinePageListForAutoCompleteList: new Array(),
    });
  };

  readPtLineBySearchString(searchString) {
    let ptLineList = this.state.pickTicketData.pickTicketLines;
    let simpleAutoCompleteList = new Array();
    if (ptLineList.length > 0 && ptLineList != null) {
      ptLineList.map((pt) => {
        let simpleItemBean = {
          code: pt.pickTicketLineNumber,
          description: pt.fabricStyleCode,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    let userInput = searchString;
    let filteredSuggestions = new Array();
    filteredSuggestions = simpleAutoCompleteList.filter((list) => list.code);
    this.setState({ ptLinePageListForAutoCompleteList: filteredSuggestions });
  }
  displayAutoCompletePalletPtLineList = (showAutoCompleteList) => {
    this.setState({ showAutoCompletePtLineList: showAutoCompleteList });
  };
  readPickTicketLines = (no) => {
    let palletData = this.state.palletData;
    let pickTicketData = this.state.pickTicketData;
    pickTicketData.pickTicketLines.map((ln) => {
      if (parseInt(no) === ln.pickTicketLineNumber) {
        palletData.fabricStyleCode = ln.fabricStyleCode;
        palletData.fabricStyleName = ln.fabricStyleName;
        palletData.colorCode = ln.colorCode;
        palletData.skuNumber = ln.skuNumber;

        this.setState({ palletData: palletData });
      }
    });
    this.setState({ palletData: palletData });
  };
  validatePalletForm = (palletData) => {
    // const pickTicketData = this.state.pickTicketData;
    let isValidData = false;
    let err_list = [];
    let errorMessage = "";
    if (palletData == null) {
      let errMsg = "Enter All Fields ";
      errorMessage = errorMessage + errMsg;
      err_list.push(errMsg);
    } else {
      // if (palletData.pickedQuantity <= 0) {
      if (palletData.palletQuantity <= 0) {
        let errMsg = " Quantity is Required";
        errorMessage = errorMessage + errMsg;
        err_list.push(errMsg);
      }
      // if (palletData.palletQuantity > pickTicketData.picked) {
      //   let errMsg = " Quantity must be less than or equal to picked Qty";
      //   errorMessage = errorMessage + errMsg;
      //   err_list.push(errMsg);
      // }
    }
    if (err_list.length > 0) {
      isValidData = false;
      this.setState({
        alertMessage: err_list,
        alertType: "danger",
        isShowAlertLvl5: true,
      });
    } else {
      isValidData = true;
      this.setState({ isShowAlertLvl5: false });
    }
    return isValidData;
  };

  getMaxLineNumberPalletLines = () => {
    let maxLineNumber = 0;
    let pickTicketBoxLineData = this.state.pickTicketBoxLineData;
    if (
      !isEmpty(pickTicketBoxLineData) &&
      !isEmptyArray(pickTicketBoxLineData.boxPalletLines)
    ) {
      pickTicketBoxLineData.boxPalletLines.map((line) => {
        if (line.palletLineNumber > maxLineNumber) {
          maxLineNumber = line.palletLineNumber;
        }
      });
    }
    return maxLineNumber;
  };
  addOrUpdatePalletDetail = (e) => {
    if (e.detail === 1) {
      const pickTicketBoxLineData = this.state.pickTicketBoxLineData;
      const palletData = this.state.palletData;
      palletData.companyCode = this.companyCode;
      palletData.pickTicketNumber = pickTicketBoxLineData.pickTicketNumber;
      let boxLineNumber = this.getBoxMaxLineNumber();
      palletData.boxLineNumber = ++boxLineNumber;
      palletData.boxNumber = pickTicketBoxLineData.boxNumber;
      let palletLines = new Array();
      if (!isEmptyArray(this.state.palletLines)) {
        palletLines = this.state.palletLines;
      }
      let isValid = false;
      isValid = this.validatePalletForm(palletData);
      if (isValid) {
        var palletLineNumber = this.getMaxLineNumberPalletLines();
        let isLineFound = false;
        if (!isEmptyArray(palletLines)) {
          palletLines.map((line, i) => {
            if (line.palletLineNumber == palletData.palletLineNumber) {
              palletData.palletLineNumber = line.palletLineNumber;
              palletData.isFetched = line.isFetched;
              palletLines[i] = palletData;
              isLineFound = true;
            }
          });
        }
        if (!isLineFound) {
          palletData.palletLineNumber = ++palletLineNumber;
          palletLines.push(palletData);
        }
        pickTicketBoxLineData.boxPalletLines = palletLines;
        this.state.palletLines = palletLines;
        this.setState({
          pickTicketBoxLineData: pickTicketBoxLineData,
          palletLines: palletLines,
        });
      }
      this.closeAlertModalCallBackLvl5();
    }
  };
  hideAlertCallBackLvl5 = (msgType, isDisplayed) => {
    this.setState({
      isShowAlertLvl5: isDisplayed,
    });
  };
  hideAlertCallBackLvl3 = (msgType, isDisplayed) => {
    this.setState({
      isShowAlertLvl3: isDisplayed,
    });
  };
  lnkSalesModule = (e) => {
    if (e.detail === 1) {
      let pickTicketData = this.state.pickTicketData;
      let code = pickTicketData.salesOrderNumber;
      if (code !== "" && code !== undefined) {
        this.setState({
          isShowSalesModule: true,
          moduleForPopup: (
            <PopupSalesModule
              code={code}
              onModuleExit={this.onPopupModalExit}
            />
          ),
        });
      }
    }
  };
  onWeightUomChange = (e) => {
    let weightUomCode = e.target.value;
    this.state.showAutoCompleteWeightUomList = true;
    let tempData = this.state.ptLnPalletData;
    let showAutoCompleteList = this.state.showAutoCompleteWeightUomList;
    if (isEmpty(weightUomCode)) {
      this.state.showAutoCompleteWeightUomList = false;
      let showAutoCompleteList = this.state.showAutoCompleteWeightUomList;
      let ptLnPalletData = this.state.ptLnPalletData;
      ptLnPalletData.weightUomCode = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteWeightUomList: showAutoCompleteList,
        ptLnPalletData: ptLnPalletData,
        weightUomPageListForAutoCompleteList: suggestion,
      });
    } else if (showAutoCompleteList === true && weightUomCode !== "") {
      this.readWeightUomCodeBySearchString(weightUomCode);
    }
    if (e.target.name == "weightUomCode") {
      tempData["weightUomCode"] = e.target.value;
      let weightUomList = this.state.weightUOMs;
      weightUomList.map((uom) => {
        if (uom.code == e.target.value) {
          tempData["weightUomCode"] = uom.code;
          this.state.showAutoCompleteWeightUomList = false;
          let showAutoCompleteList = this.state.showAutoCompleteWeightUomList;
          this.setState({
            showAutoCompleteWeightUomList: showAutoCompleteList,
          });
        }
      });
    }
    this.setState({ ptLnPalletData: tempData });
  };
  readWeightUomCodeBySearchString(searchString) {
    let weightUomCodeList = this.state.weightUOMs;
    let simpleAutoCompleteList = new Array();
    if (weightUomCodeList.length > 0 && weightUomCodeList != null) {
      weightUomCodeList.map((weightUomCodes) => {
        let simpleItemBean = {
          code: weightUomCodes.code,
          description: weightUomCodes.description,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    let userInput = searchString;
    let filteredSuggestions = new Array();
    filteredSuggestions = simpleAutoCompleteList.filter(
      (simpleAutoCompleteweightUomCodeLists) =>
        simpleAutoCompleteweightUomCodeLists.code
          .toLowerCase()
          .indexOf(userInput.toLowerCase()) > -1
    );
    this.setState({
      weightUomPageListForAutoCompleteList: filteredSuggestions,
    });
  }
  weightUomEnterKeyEventHandler = (e) => {
    let tempData = this.state.ptLnPalletData;
    let weightUomCode = e.target.value;
    tempData["weightUomCode"] = e.target.value;
    let weightUomList = this.state.weightUOMs;
    let weightUomCodeBean = null;
    weightUomList.map((uom) => {
      if (uom.code == e.target.value) {
        weightUomCodeBean = uom;
      }
    });
    if (!isEmpty(weightUomCodeBean)) {
      let tempData = this.state.ptLnPalletData;
      tempData.weightUomCode = weightUomCodeBean.code;
      this.setState({
        ptLnPalletData: tempData,
        weightUomPageListForAutoCompleteList: new Array(),
      });
    }
  };

  displayAutoCompleteWeightUomList = (showAutoCompleteList) => {
    this.setState({
      showAutoCompleteWeightUomList: showAutoCompleteList,
    });
  };

  /******end******/

  /*****Dimension UOM****/

  onDimensionUomChange = (e) => {
    let dimensionUomCode = e.target.value;
    this.state.showAutoCompleteDimensionUomList = true;
    let tempData = this.state.ptLnPalletData;
    let showAutoCompleteList = this.state.showAutoCompleteDimensionUomList;
    if (isEmpty(dimensionUomCode)) {
      this.state.showAutoCompleteDimensionUomList = false;
      let showAutoCompleteList = this.state.showAutoCompleteDimensionUomList;
      let ptLnPalletData = this.state.ptLnPalletData;
      ptLnPalletData.dimensionUomCode = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteDimensionUomList: showAutoCompleteList,
        ptLnPalletData: ptLnPalletData,
        dimensionUomPageListForAutoCompleteList: suggestion,
      });
    } else if (showAutoCompleteList === true && dimensionUomCode !== "") {
      this.readDimensionUomCodeBySearchString(dimensionUomCode);
    }
    if (e.target.name == "dimensionUomCode") {
      tempData["dimensionUomCode"] = e.target.value;
      let ptLnPalletList = this.state.lengthUOMs;
      ptLnPalletList.map((uom) => {
        if (uom.code == e.target.value) {
          tempData["dimensionUomCode"] = uom.code;
          this.state.showAutoCompleteDimensionUomList = false;
          let showAutoCompleteList =
            this.state.showAutoCompleteDimensionUomList;
          this.setState({
            showAutoCompleteDimensionUomList: showAutoCompleteList,
          });
        }
      });
    }
    this.setState({ ptLnPalletData: tempData });
  };
  readDimensionUomCodeBySearchString(searchString) {
    let dimensionUomCodeList = this.state.lengthUOMs;
    let simpleAutoCompleteList = new Array();
    if (dimensionUomCodeList.length > 0 && dimensionUomCodeList != null) {
      dimensionUomCodeList.map((uomCodes) => {
        let simpleItemBean = {
          code: uomCodes.code,
          description: uomCodes.description,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    let userInput = searchString;
    let filteredSuggestions = new Array();
    filteredSuggestions = simpleAutoCompleteList.filter(
      (simpleAutoCompleteweightUomCodeLists) =>
        simpleAutoCompleteweightUomCodeLists.code
          .toLowerCase()
          .indexOf(userInput.toLowerCase()) > -1
    );
    this.setState({
      dimensionUomPageListForAutoCompleteList: filteredSuggestions,
    });
  }
  dimensionUomEnterKeyEventHandler = (e) => {
    let tempData = this.state.ptLnPalletData;
    let dimensionUomCode = e.target.value;
    tempData["dimensionUomCode"] = e.target.value;
    let uomList = this.state.lengthUOMs;
    let uomCodeBean = null;
    uomList.map((uom) => {
      if (uom.code == e.target.value) {
        uomCodeBean = uom;
      }
    });
    if (!isEmpty(uomCodeBean)) {
      let tempData = this.state.ptLnPalletData;
      tempData.dimensionUomCode = uomCodeBean.code;
      this.setState({
        ptLnPalletData: tempData,
        dimensionUomPageListForAutoCompleteList: new Array(),
      });
    }
  };

  displayAutoCompleteDimensionUomList = (showAutoCompleteList) => {
    this.setState({
      showAutoCompleteDimensionUomList: showAutoCompleteList,
    });
  };

  render() {
    let pickTicketData = this.state.pickTicketData;
    let pickTicketList = this.state.pickTicketList;
    const pickTicketLineData = this.state.pickTicketLineData;
    let pickTicketBoxLineData = this.state.pickTicketBoxLineData;
    let isLoading = this.state.isLoading;
    let disablePickTicketFormFields = this.state.isDisabledFields;
    let criteria = this.state.pickTicketCriteria;
    let shipperAndPackerData = this.state.shipperAndPackerData;
    let isModify = false;
    isModify = this.isModifyPosible();
    let shipmentRateResult = this.state.shipmentRateResult;
    let boxRateDetails = [];
    if (!isEmpty(shipmentRateResult) && !isEmptyArray(shipmentRateResult.rates))
      boxRateDetails = shipmentRateResult.rates;
    let rollLines = [];
    let pt_rollLines = this.state.pt_rollLines;
    // if (
    //   !isEmpty(pickTicketLineData) &&
    //   !isEmptyArray(pickTicketLineData.rollLines)
    // ) {
    //   rollLines = pickTicketLineData.rollLines;
    // }
    if (
      !isEmpty(pickTicketLineData) &&
      // !isEmptyArray(pickTicketLineData.rollLines) &&
      !isEmptyArray(pt_rollLines)
    ) {
      rollLines = pt_rollLines;
    }
    let isDisabledFields = this.state.isDisabledFields;
    let disableUpdatableFields = false;
    if (disablePickTicketFormFields) {
      //if (isModify) {
      disableUpdatableFields = false;
      //} else {
      // disableUpdatableFields = true;
      // }
    }

    let totalRolls = 0;
    let currentlyPickedQty = 0;
    let selectLines = [];
    if (
      !isEmpty(pickTicketLineData) &&
      // !isEmptyArray(pickTicketLineData.rollLines) &&
      !isEmptyArray(pt_rollLines)
    ) {
      // pickTicketLineData.rollLines.map((ln) => {
      pt_rollLines.map((ln) => {
        if (ln.isSelected) {
          selectLines.push(ln);
          totalRolls = selectLines.length;
          currentlyPickedQty += parseFloat(ln.currentlyPickedQuantity);
        }
      });
    }
    let inventories = [];
    if (
      !isEmpty(this.state.inventoryData) &&
      !isEmptyArray(this.state.inventoryData.inventoryDataDetails)
    ) {
      inventories = this.state.inventoryData.inventoryDataDetails;
    }

    let status = "Printed";
    if (!isEmpty(pickTicketData) && !isEmptyArray(pickTicketData.status))
      status = ModuleUtils.getPickTicketStatusCaption(pickTicketData.status);

    const textAreaStyle = {
      maxHeight: "75px",
      minHeight: "12em",
      resize: "none",
      padding: "9px",
      boxSizing: "border-box",
      fontSize: "15px",
    };
    var dataTableStyles = {
      header: {
        style: {
          minHeight: "0px",
        },
      },
      table: {
        style: {
          minHeight: "350px",
          maxHeight: "350px",
          overflowY: "auto",
        },
      },
    };
    let mailInfoData = this.state.mailInfoData;
    let is3PL = this.state.is3PL;
    let palletData = this.state.palletData;
    const palletLines = this.state.palletLines;
    const ptLnPalletData = this.state.ptLnPalletData;
    const ptLnPalletLines = this.state.ptLnPalletLines;
    return (
      <div>
        {!this.state.isSpecialViewMode ? (
          <AlertToolBox
            alertMsgList={this.state.alertMessage}
            alertErrorType={this.state.alertType}
            isShowAlert={this.state.isShowAlert}
            hideAlertCallBack={this.hideAlertCallBack}
          />
        ) : null}
        <ModuleToolBar
          isShowNewButton={false}
          onNewEntry={() => this.newEntry()}
          onModuleExit={() => this.moduleExit()}
          resetView={() => this.resetView()}
          pageTitle={this.state.pageTitle}
          loadingText={this.state.loadingText}
          isLoading={this.state.isLoading}
          isShowModuleSearchContainer={this.state.isShowModuleSearchContainer}
          //isMaintenanceMode={!this.state.isListFormOpen}
          isMaintenanceMode={this.state.isMaintenanceMode}
          onModuleKeyContainerButtonClick={this.editPickTicket}
          moduleKeyCode={this.state.moduleKeyCode}
          onModuleKeyCodeChange={this.onModuleKeyCodeChange}
          getModuleListView={this.getModuleListView}
          lookupRequired={true} //for f2 lookup
          lookupHandler={this.state.pickTicketLookupHandler} //for f2 lookup
          showCriteriaDialog={true} //for f2 lookup
          onModuleKeyCodeWithCriteriaOnChange={
            this.onModuleKeyCodeWithCriteriaOnChange
          }
          selectButtonClick={this.selectButtonClick}
          disabled={this.state.disabled}
          isSpecialViewMode={this.state.isSpecialViewMode}
          isResetView={this.state.isResetView}
          isFocusLookup={this.state.isFocusLookup}
        />

        {/*<ModuleToolBar
          isShowNewButton={false}
          onModuleExit={() => this.moduleExit()}
          pageTitle={this.state.pageTitle}
          isSpecialViewMode={this.state.isSpecialViewMode}
        />
        */}
        {!this.state.isListFormOpen &&
          this.state.isSpecialViewMode == false &&
          this.state.isViewMode == false && (
            <BaseToolBar
              // set PickTicketToolBar to BaseToolBar
              extend_toolbar={
                <PickTicketModuleToolBar
                  cancelPickTicket={this.cancelPickTicket}
                  generateInvoice={this.generateInvoice}
                  generatePrintLabel={this.generatePrintLabel}
                  generatePackingList={this.generatePackingList}
                  generateSync={this.generateSyncSO}
                  shippingPickTicket={this.shippingPickTicket}
                  updateExistingInvoice={this.updateExistingInvoice}
                  isShowGenerateInvoiceButton={
                    this.state.isShowGenerateInvoiceButton
                  }
                  isShowUpdateInvoiceButton={
                    this.state.isShowUpdateInvoiceButton
                  }
                  isShowCancelButton={this.state.isShowCancelButton}
                  isShowPrintLabelButton={this.state.isShowPrintLabelButton}
                  isShowPackingListButton={this.state.isShowPackingListButton}
                  isShowSyncButton={this.state.isShowSyncButton}
                  isShowMailPackingButton={this.state.isShowMailPackingButton}
                  mailPacking={this.mailPacking}
                  isShowExcelPackingButton={this.state.isShowExcelPackingButton}
                  isShowShippingButton={this.state.isShowShippingButton}
                  excelPacking={this.excelPacking}
                />
              }
              back={this.back}
              save={this.save}
              clearError={this.clearError}
              generatePDF={this.generatePDF}
              isShowSaveButton={this.state.isShowSaveButton}
              isShowClearCriteriaButton={this.state.isShowClearCriteriaButton}
              isShowClearErrorButton={this.state.isShowClearErrorButton}
              //isShowBackButton={this.state.isShowBackButton}
              isShowPDFButton={this.state.isShowPDFReportButton}
              pageTitle={this.state.pageTitle}
              isShowModuleSearchContainer={
                this.state.isShowModuleSearchContainer
              }
              onModuleKeyContainerButtonClick={this.editPickTicket}
              moduleKeyCode={this.state.moduleKeyCode}
              onModuleKeyCodeChange={this.onModuleKeyCodeChange}
            />
          )}
        {/* {isLoading ? <Loader /> : null} */}
        <BaseNotification errorList={this.state.errorList} />
        {this.state.isShowNodes && (
          <BaseNodeBar
            nodeList={this.state.nodeList}
            selectedNodeKey={this.state.selectedNodeKey}
            nodeOnSelect={this.nodeOnSelect}
            moduleStatus={status}
          />
        )}
        {!this.state.isShowNodes &&
          !this.state.isListFormOpen &&
          !this.state.isShippingInformationFormOpened &&
          !this.state.isInvoicesFormOpened &&
          !this.state.isChangesHistoryFormOpened &&
          !this.state.isPalletFormOpened &&
          this.state.isEntryFormOpen &&
          this.getHeaderView()}
        {this.state.isShowNodes &&
          !this.state.isListFormOpen &&
          !this.state.isShippingInformationFormOpened &&
          !this.state.isInvoicesFormOpened &&
          !this.state.isChangesHistoryFormOpened &&
          !this.state.isPalletFormOpened &&
          this.state.isEntryFormOpen &&
          this.getHeaderView()}

        {!this.state.isEntryFormOpen &&
          !this.state.isShippingInformationFormOpened &&
          !this.state.isChangesHistoryFormOpened &&
          !this.state.isInvoicesFormOpened &&
          this.state.isListFormOpen &&
          !this.state.isSpecialViewMode &&
          !this.state.isPalletFormOpened &&
          this.getListView()}

        {!this.state.isListFormOpen &&
          !this.state.isEntryFormOpen &&
          !this.state.isInvoicesFormOpened &&
          !this.state.isChangesHistoryFormOpened &&
          this.state.isShippingInformationFormOpened &&
          !this.state.isPalletFormOpened &&
          this.getShippingInformationView()}

        {!this.state.isListFormOpen &&
          !this.state.isEntryFormOpen &&
          !this.state.isChangesHistoryFormOpened &&
          !this.state.isShippingInformationFormOpened &&
          !this.state.isPalletFormOpened &&
          this.state.isInvoicesFormOpened &&
          this.getInvoicesView()}

        {!this.state.isListFormOpen &&
          !this.state.isEntryFormOpen &&
          !this.state.isShippingInformationFormOpened &&
          !this.state.isInvoicesFormOpened &&
          this.state.isChangesHistoryFormOpened &&
          !this.state.isPalletFormOpened &&
          this.getChangesHistoryView()}

        {/* {!this.state.isListFormOpen &&
          !this.state.isEntryFormOpen &&
          !this.state.isShippingInformationFormOpened &&
          !this.state.isInvoicesFormOpened &&
          !this.state.isChangesHistoryFormOpened &&
          this.state.isPalletFormOpened &&
          this.state.is3PL &&
          this.getPalletView()} */}

        <div>
          <MultiViewPopup
            popupLvlClass={"popupSizeLevel3"}
            isModulePopup={false}
            isShowPopup={this.state.isShowPtLnPalletDetailsPopup}
            closeOnEsc={false}
            closeAlertModalCallBack={this.closeAlertModalCallBackLvl3}
            title={"PT LINE PALLET LINES"}
            closeOnDocumentClick={false}
            lockScroll={false}
            alertContainerBox={
              <AlertToolBox
                alertMsgList={this.state.alertMessage}
                alertErrorType={this.state.alertType}
                isShowAlert={this.state.isShowAlertLvl3}
                hideAlertCallBack={this.hideAlertCallBackLvl3}
              />
            }
            headerButtonContainer={
              <div className="floatLeft">
                <Button
                  className="header_buttons enterFocus"
                  onClick={(e) => this.addOrUpdatePtLnPalletLines(e)}
                  disabled={this.state.isDisabledFields}
                >
                  Add/Update
                </Button>
              </div>
            }
            content={
              <div>
                <Row>
                  <Col sm="1">
                    <FormLabel>Item</FormLabel>
                  </Col>
                  <Col sm="3">
                    <InputTextbox
                      value={pickTicketLineData.fabricStyleCode}
                      disabled={true}
                    />
                  </Col>
                  <Col sm="4">
                    <InputTextbox
                      value={pickTicketLineData.fabricStyleName}
                      disabled={true}
                    />
                  </Col>
                  <Col sm="1">
                    <FormLabel>Color</FormLabel>
                  </Col>
                  <Col sm="3">
                    <InputTextbox
                      value={pickTicketLineData.colorCode}
                      disabled={true}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col sm="1">
                    <FormLabel>Pickticket</FormLabel>
                  </Col>
                  <Col sm="3">
                    <InputTextbox
                      value={pickTicketLineData.pickTicketNumber}
                      disabled={true}
                    />
                  </Col>
                  <Col sm="1">
                    <FormLabel>PT lineNumber</FormLabel>
                  </Col>
                  <Col sm="3">
                    <InputTextbox
                      value={pickTicketLineData.pickTicketLineNumber}
                      disabled={true}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col>Pallet Lines</Col>
                </Row>
                <div className="div_custom_4">
                  <Table id="fabrics_tables_default">
                    <thead>
                      <tr>
                        <th>
                          <Col sm="4">
                            <Button
                              size="sm"
                              id="fabric_Add_Button"
                              className="enterFocus"
                              onClick={(e) => this.palletLnHandler(e)}
                            >
                              <AddIcon />
                            </Button>
                          </Col>
                        </th>
                        <th>PT</th>
                        <th>PT Line</th>
                        <th>Item</th>
                        <th>Item Name</th>
                        <th>Color</th>
                        <th>Pallet#</th>
                        <th>Weight</th>
                        <th>Weight UOM</th>
                        <th>Dimension</th>
                        <th>Dimension UOM</th>
                        <th>numberOfItemsPerPallet</th>
                      </tr>
                    </thead>
                    <tbody>
                      {!isEmptyArray(ptLnPalletLines) &&
                        ptLnPalletLines.map((ln, i) => (
                          <tr key={i}>
                            <td>
                              <Button
                                variant="secondry"
                                className="hyperLinkText"
                                onClick={(e) =>
                                  this.openPtLnPalletDetails(e, ln)
                                }
                              >
                                {ln.palletLineNumber}
                              </Button>
                            </td>
                            <td>{ln.pickTicketNumber}</td>
                            <td>{ln.pickTicketLineNumber}</td>
                            <td>{ln.fabricStyleCode}</td>
                            <td>{ln.fabricStyleName}</td>
                            <td>{ln.colorCode}</td>
                            <td>{ln.palletNumber}</td>
                            <td className="text-right">{ln.weight}</td>
                            <td>{ln.weightUomCode}</td>
                            <td className="text-right">{ln.palletDimension}</td>
                            <td>{ln.dimensionUomCode}</td>
                            <td className="text-right">
                              {ln.numberOfItemsPerPallet}
                            </td>
                          </tr>
                        ))}
                    </tbody>
                  </Table>
                </div>
              </div>
            }
          />
          <MultiViewPopup
            popupLvlClass={"popupSizeLevel5"}
            isModulePopup={false}
            isShowPopup={this.state.isShowPtlnPalletEntyPopup}
            closeOnEsc={false}
            closeAlertModalCallBack={this.closeAlertModalCallBackLvl5}
            title={"PT LINE PALLET DETAIL"}
            closeOnDocumentClick={false}
            lockScroll={false}
            alertContainerBox={
              <AlertToolBox
                alertMsgList={this.state.alertMessage}
                alertErrorType={this.state.alertType}
                isShowAlert={this.state.isShowAlertLvl5}
                hideAlertCallBack={this.hideAlertCallBackLvl5}
              />
            }
            headerButtonContainer={
              <div className="floatLeft">
                <Button
                  className="header_buttons enterFocus"
                  onClick={(e) => this.addOrUpdatePtLnPalletData(e)}
                  disabled={this.state.isDisabledFields}
                >
                  Add/Update
                </Button>

                <Button
                  className="header_buttons"
                  size="sm"
                  onClick={(e) => this.clearPtLnPalletData(e)}
                  disabled={this.state.isDisabledFields}
                >
                  Clear
                </Button>
              </div>
            }
            content={
              <div>
                <Row>
                  <Col sm="2">
                    <FormLabel>Pickticket</FormLabel>
                  </Col>
                  <Col sm="4">
                    <InputTextbox
                      value={ptLnPalletData.pickTicketNumber}
                      disabled={true}
                    />
                  </Col>
                  <Col sm="2">
                    <FormLabel>PT lineNumber</FormLabel>
                  </Col>
                  <Col sm="4">
                    <InputTextbox
                      value={ptLnPalletData.pickTicketLineNumber}
                      disabled={true}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col sm="2">
                    <FormLabel>Item</FormLabel>
                  </Col>
                  <Col sm="4">
                    <InputTextbox
                      value={ptLnPalletData.fabricStyleCode}
                      disabled={true}
                    />
                  </Col>
                  <Col sm="6">
                    <InputTextbox
                      value={ptLnPalletData.fabricStyleName}
                      disabled={true}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col sm="2">
                    <FormLabel>Color</FormLabel>
                  </Col>
                  <Col sm="4">
                    <InputTextbox
                      value={ptLnPalletData.colorCode}
                      disabled={true}
                    />
                  </Col>
                  <Col sm="2">
                    <FormLabel>Ln#</FormLabel>
                  </Col>
                  <Col sm="4">
                    <InputTextbox
                      value={ptLnPalletData.palletLineNumber}
                      disabled={true}
                    />
                  </Col>
                </Row>

                <Row>
                  <Col sm="2">
                    <FormLabel>PalletNumber</FormLabel>
                  </Col>
                  <Col sm="4">
                    <InputTextbox
                      value={ptLnPalletData.palletNumber}
                      name="palletNumber"
                      onChange={this.ptPlPalletLineOnchange}
                      disabled={ptLnPalletData.isFetched ? true : false}
                    />
                  </Col>
                  <Col sm="2">
                    <FormLabel>NoOfItems PerPallet</FormLabel>
                  </Col>
                  <Col sm="4">
                    <NumberFormatInputbox
                      name="numberOfItemsPerPallet"
                      value={ptLnPalletData.numberOfItemsPerPallet}
                      onChange={this.ptPlPalletLineOnchange}
                      // disabled={true}
                      className="summary_input text-right"
                      decimalScale={2}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col sm="2">
                    <FormLabel>Weight UOM</FormLabel>
                  </Col>
                  <Col sm="4">
                    {/* <InputTextbox
                      name="weightUomCode"
                      value={ptLnPalletData.weightUomCode}
                      onChange={this.ptPlPalletLineOnchange}
                      // disabled={true}
                    /> */}

                    <InputTextbox
                      onChange={this.onWeightUomChange}
                      name="weightUomCode"
                      placeholder="weightUOMCode"
                      value={ptLnPalletData.weightUomCode}
                      lookupRequired={true}
                      lookupHandler={this.state.ptWeightUOMLookupHandler}
                      enterKeyEventHandler={this.weightUomEnterKeyEventHandler}
                      autoCompleteListData={
                        this.state.weightUomPageListForAutoCompleteList
                      }
                      enableAutoCompleteTextBox={true}
                      displayAutoCompleteList={
                        this.displayAutoCompleteWeightUomList
                      }
                      showAutoCompleteList={
                        this.state.showAutoCompleteWeightUomList
                      }
                      disabled={isDisabledFields}
                      isMandatory={true}
                    ></InputTextbox>
                  </Col>
                  <Col sm="2">
                    <FormLabel>Weight</FormLabel>
                  </Col>
                  <Col sm="4">
                    <NumberFormatInputbox
                      name="weight"
                      value={ptLnPalletData.weight}
                      onChange={this.ptPlPalletLineOnchange}
                      // disabled={true}
                      className="summary_input text-right"
                      decimalScale={2}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col sm="2">
                    <FormLabel>Dimension UOM</FormLabel>
                  </Col>
                  <Col sm="4">
                    {/* <InputTextbox
                      name="dimensionUomCode"
                      value={ptLnPalletData.dimensionUomCode}
                      onChange={this.ptPlPalletLineOnchange}
                      // disabled={true}
                    /> */}
                    <InputTextbox
                      onChange={this.onDimensionUomChange}
                      name="dimensionUomCode"
                      placeholder="dimensionUOMCode"
                      value={ptLnPalletData.dimensionUomCode}
                      lookupRequired={true}
                      lookupHandler={this.state.dimensionUOMLookupHandler}
                      enterKeyEventHandler={
                        this.dimensionUomEnterKeyEventHandler
                      }
                      autoCompleteListData={
                        this.state.dimensionUomPageListForAutoCompleteList
                      }
                      enableAutoCompleteTextBox={true}
                      displayAutoCompleteList={
                        this.displayAutoCompleteDimensionUomList
                      }
                      showAutoCompleteList={
                        this.state.showAutoCompleteDimensionUomList
                      }
                      disabled={isDisabledFields}
                      isMandatory={true}
                    ></InputTextbox>
                  </Col>
                  <Col sm="2">
                    <FormLabel>PalletDimension</FormLabel>
                  </Col>
                  <Col sm="4">
                    <NumberFormatInputbox
                      name="palletDimension"
                      value={ptLnPalletData.palletDimension}
                      onChange={this.ptPlPalletLineOnchange}
                      // disabled={true}
                      className="summary_input text-right"
                      decimalScale={2}
                    />
                  </Col>
                </Row>
              </div>
            }
          />
          <MultiViewPopup
            popupLvlClass={"popupSizeLeve2"}
            isModulePopup={true}
            id="modulePopup"
            isShowPopup={this.state.isShowInvoiceModule}
            closeModalCallBack={this.closeModalCallBack}
            module={this.state.moduleForPopup}
            lockScroll={true}
          ></MultiViewPopup>
          <MultiViewPopup
            popupLvlClass={"popupSizeLevel2"}
            isModulePopup={true}
            id="moduleSalesPopup"
            isShowPopup={this.state.isShowSalesModule}
            closeModalCallBack={this.closeModalCallBack}
            module={this.state.moduleForPopup}
            lockScroll={true}
          ></MultiViewPopup>
          <MultiViewPopup
            popupLvlClass={"popupSizeLevel3"}
            isModulePopup={false}
            isShowPopup={this.state.isShowMailPickTicketPopup}
            closeOnEsc={false}
            closeAlertModalCallBack={this.closeAlertModalCallBack}
            title={"Mailing Pick Ticket"}
            closeOnDocumentClick={false}
            lineFunctionalityForm={this.lineFunctionalityForm}
            lockScroll={true}
            alertContainerBox={
              <AlertToolBox
                alertMsgList={this.state.alertMessage}
                alertErrorType={this.state.alertType}
                isShowAlert={this.state.isShowLvl3Alert}
                hideAlertCallBack={this.hidePopupAlertCallBack}
              />
            }
            headerButtonContainer={
              <div className="floatLeft">
                <Button
                  className="header_buttons enterFocus"
                  size="sm"
                  onClick={(e) => this.mailInvoiceContinue(e)}
                >
                  Continue
                </Button>
              </div>
            }
            content={
              <div className="PurchaseOrderPopup">
                <div>
                  <Row>
                    <Col sm="1">
                      <FormLabel>From</FormLabel>
                    </Col>
                    <Col sm="5">
                      <InputTextbox
                        value={mailInfoData.from}
                        onChange={this.onMailChange}
                        disabled={true}
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col sm="1">
                      <FormLabel>TOs</FormLabel>
                    </Col>
                    <Col sm="5">
                      <InputTextbox
                        name="tos"
                        value={mailInfoData.tos}
                        onChange={this.onMailChange}
                        disabled={isDisabledFields}
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col sm="1">
                      <FormLabel>CCs</FormLabel>
                    </Col>
                    <Col sm="5">
                      <InputTextbox
                        name="ccs"
                        value={mailInfoData.ccs}
                        onChange={this.onMailChange}
                        disabled={isDisabledFields}
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col sm="1">
                      <FormLabel>BCCs</FormLabel>
                    </Col>
                    <Col sm="5">
                      <InputTextbox
                        name="bccs"
                        value={mailInfoData.bccs}
                        onChange={this.onMailChange}
                        disabled={isDisabledFields}
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col sm="1">
                      <FormLabel>Title</FormLabel>
                    </Col>
                    <Col sm="5">
                      <InputTextbox
                        name="title"
                        value={mailInfoData.title}
                        onChange={this.onMailChange}
                        disabled={isDisabledFields}
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col sm="1">
                      <FormLabel>Attachments</FormLabel>
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <textarea
                        style={textAreaStyle}
                        className="form-control"
                        name="message"
                        type="text"
                        onChange={this.onMailChange}
                        value={mailInfoData.message}
                        disabled={isDisabledFields}
                      />
                    </Col>
                  </Row>
                  <Row></Row>
                </div>
              </div>
            }
          />
          <MultiViewPopup
            popupLvlClass={"popupSizeLevel3"}
            isModulePopup={false}
            isShowPopup={this.state.isShowOpenInvoicesPopup}
            closeOnEsc={false}
            closeAlertModalCallBack={this.closeAlertModalCallBack}
            title={"Open Invoices"}
            closeOnDocumentClick={false}
            lineFunctionalityForm={this.lineFunctionalityForm}
            lockScroll={true}
            alertContainerBox={
              <AlertToolBox
                alertMsgList={this.state.alertMessage}
                alertErrorType={this.state.alertType}
                isShowAlert={this.state.isShowLvl3Alert}
                hideAlertCallBack={this.hidePopupAlertCallBack}
              />
            }
            headerButtonContainer={
              <div className="floatLeft">
                <Button
                  className="header_buttons enterFocus"
                  size="sm"
                  onClick={(e) => this.updateInvoice(e)}
                >
                  Continue
                </Button>
              </div>
            }
            content={
              <div className="">
                <Row>
                  <Col className="align-items-left" sm="1">
                    <FormLabel>PickTicket#</FormLabel>
                  </Col>
                  <Col sm="3">
                    <InputTextbox
                      name="code"
                      value={pickTicketData.code}
                      disabled={true}
                    />{" "}
                  </Col>
                  <Col className="align-items-left" sm="1">
                    <FormLabel>Customer</FormLabel>{" "}
                  </Col>
                  <Col sm="3">
                    <InputTextbox
                      ref={this.customerCodeRef}
                      name="customerCode"
                      value={pickTicketData.customerCode}
                      disabled={true}
                    />{" "}
                  </Col>
                  <Col sm="4">
                    <InputTextbox
                      name="customerName"
                      value={pickTicketData.customerName}
                      disabled={true}
                    />{" "}
                  </Col>
                </Row>
                <EditableDataGrid
                  columnsList={this.InvoiceColumnDefinitions()}
                  dataList={this.state.openInvoiceLines}
                />
              </div>
            }
          />

          <MultiViewPopup
            popupLvlClass={"popupSizeLevel0"}
            isModulePopup={false}
            isShowPopup={this.state.isShowLinePopup}
            closeOnEsc={false}
            closeAlertModalCallBack={this.closeAlertModalCallBack}
            title={"LINE DETAIL"}
            closeOnDocumentClick={false}
            lineFunctionalityForm={this.lineFunctionalityForm}
            lockScroll={true}
            alertContainerBox={
              <AlertToolBox
                alertMsgList={this.state.alertMessage}
                alertErrorType={this.state.alertType}
                isShowAlert={this.state.isShowPopupAlert}
                hideAlertCallBack={this.hidePopupAlertCallBack}
              />
            }
            headerButtonContainer={
              <div className="floatLeft">
                <Button
                  className="header_buttons enterFocus"
                  onClick={(e) => this.updateLine(e)}
                  disabled={this.state.isDisabledFields}
                >
                  Update
                </Button>
              </div>
            }
            content={
              <div className="sales_line_pop">
                <div className="header_div col-md-12 col-lg-12">
                  <div className="">
                    <Row>
                      <Col className="align-items-left" sm="1">
                        <FormLabel>PickTicket#</FormLabel>
                      </Col>

                      <Col sm="2">
                        <InputTextbox
                          name="code"
                          type="text"
                          onChange={this.onChange}
                          readOnly={disablePickTicketFormFields}
                          value={pickTicketData.code}
                          disabled={true}
                        />{" "}
                      </Col>
                      <Col className="align-items-left" sm="1">
                        <FormLabel>Customer</FormLabel>{" "}
                      </Col>

                      <Col sm="2">
                        <InputTextbox
                          ref={this.customerCodeRef}
                          name="customerCode"
                          type="text"
                          onChange={this.onChange}
                          readOnly={disablePickTicketFormFields}
                          value={pickTicketData.customerCode}
                          disabled={true}
                        />{" "}
                      </Col>

                      <Col sm="3">
                        <InputTextbox
                          name="customerName"
                          type="text"
                          onChange={this.onChange}
                          readOnly={true}
                          value={pickTicketData.customerName}
                          disabled={true}
                        />{" "}
                      </Col>

                      <Col className="align-items-left" sm="1">
                        <FormLabel>PO#</FormLabel>
                      </Col>

                      <Col sm="2">
                        <InputTextbox
                          name="customerPurchaseOrderNumber"
                          onChange={this.onChange}
                          value={pickTicketData.customerPurchaseOrderNumber}
                          disabled={true}
                        />
                      </Col>
                    </Row>
                  </div>

                  <Row>
                    <Col className="align-items-left" sm="1">
                      <FormLabel>SalesOrder# </FormLabel>{" "}
                    </Col>
                    <Col sm="2">
                      <InputTextbox
                        name="salesOrderNumber"
                        onChange={this.onChange}
                        readOnly={true}
                        value={pickTicketData.salesOrderNumber}
                        disabled={true}
                      />{" "}
                    </Col>

                    <Col className="align-items-left" sm="1">
                      <FormLabel>Status</FormLabel>
                    </Col>

                    <Col sm="2">
                      <InputTextbox
                        onChange={this.onChange}
                        name="status"
                        value={status}
                        disabled={true}
                        //className="qty_input text-right summary_input"
                      ></InputTextbox>
                    </Col>

                    <Col className="align-items-left" sm="1">
                      <FormLabel>Currency</FormLabel>
                    </Col>

                    <Col sm="2">
                      <InputTextbox
                        onChange={this.onChange}
                        name="currencyCode"
                        value={pickTicketLineData.currencyCode}
                        disabled={true}
                        // className="qty_input text-right summary_input"
                      ></InputTextbox>
                    </Col>

                    <Col className="align-items-left" sm="1">
                      <FormLabel>Line#</FormLabel>
                    </Col>

                    <Col sm="2">
                      <InputTextbox
                        onChange={this.onChange}
                        name="pickTicketLineNumber"
                        value={pickTicketLineData.pickTicketLineNumber}
                        disabled={true}
                      ></InputTextbox>
                    </Col>
                  </Row>
                  <Row>
                    {is3PL ? (
                      <Col className="align-items-left" sm="1">
                        <FormLabel>Item </FormLabel>{" "}
                      </Col>
                    ) : (
                      <Col className="align-items-left" sm="1">
                        <FormLabel>FabricStyle </FormLabel>{" "}
                      </Col>
                    )}
                    <Col sm="2">
                      <InputTextbox
                        name="fabricStyleCode"
                        // placeholder="Item"
                        onChange={this.onChange}
                        readOnly={true}
                        value={pickTicketLineData.fabricStyleCode}
                        disabled={isDisabledFields}
                        // className="qty_input text-right summary_input"
                      />{" "}
                    </Col>
                    <Col sm="3">
                      <InputTextbox
                        name="fabricStyleName"
                        onChange={this.onChange}
                        readOnly={true}
                        value={pickTicketLineData.fabricStyleName}
                        disabled={true}
                        //className="qty_input text-right summary_input"
                      />{" "}
                    </Col>

                    <Col className="align-items-left" sm="1">
                      <FormLabel>Color</FormLabel>
                    </Col>

                    <Col sm="2">
                      <InputTextbox
                        name="colorCode"
                        onChange={this.onChange}
                        readOnly={true}
                        value={pickTicketLineData.colorCode}
                        disabled={isDisabledFields}
                        // className="qty_input text-right summary_input"
                      />{" "}
                    </Col>

                    <Col className="align-items-left" sm="1">
                      <FormLabel>UOM </FormLabel>{" "}
                    </Col>
                    <Col sm="2">
                      <InputTextbox
                        name="orderUomCode"
                        onChange={this.onLineChange}
                        readOnly={true}
                        value={pickTicketLineData.orderUomCode}
                        disabled={isDisabledFields}
                      />{" "}
                    </Col>
                  </Row>
                  <Row>
                    <Col className="align-items-left" sm="1">
                      <FormLabel>Width </FormLabel>{" "}
                    </Col>
                    <Col sm="2">
                      <InputTextbox
                        name="widthCode"
                        onChange={this.onLineChange}
                        readOnly={true}
                        value={pickTicketLineData.widthCode}
                        disabled={isDisabledFields}
                        className="qty_input text-right summary_input"
                      />{" "}
                    </Col>
                    <Col className="align-items-left" sm="1">
                      <FormLabel>Price </FormLabel>{" "}
                    </Col>
                    <Col sm="2">
                      <NumberFormatInputbox
                        value={pickTicketLineData.price}
                        onChange={this.onLineChange}
                        //className="text-right"
                        decimalScale={2}
                        name={"price"}
                        disabled={true}
                        className="qty_input text-right summary_input"
                      />
                    </Col>

                    <Col className="align-items-left" sm="1">
                      <FormLabel>OrderQty</FormLabel>
                    </Col>

                    <Col sm="2">
                      <NumberFormatInputbox
                        value={pickTicketLineData.orderQuantity}
                        onChange={this.onLineChange}
                        // className="text-right"
                        decimalScale={2}
                        name={"orderQuantity"}
                        disabled={true}
                        className="qty_input text-right summary_input"
                      />
                    </Col>

                    <Col className="align-items-left" sm="1">
                      <FormLabel>ToBePickQty</FormLabel>
                    </Col>

                    <Col sm="2">
                      <NumberFormatInputbox
                        value={pickTicketLineData.toBePickedQuantity}
                        onChange={this.onLineChange}
                        // className="text-right"
                        decimalScale={2}
                        name={"toBePickedQuantity"}
                        disabled={true}
                        className="qty_input text-right summary_input"
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <Button
                        className=""
                        size="sm"
                        id="fabric_Add_Button"
                        onClick={(e) => this.openFindRollsLinePopup(e)}
                      >
                        Find Rolls
                      </Button>
                    </Col>
                    {/*<div className="inv_pay_popup_btn_container"> </div>*/}
                  </Row>
                  <div>
                    {/* <EditableDataGrid
                      customStyles={dataTableStyles}
                      columnsList={this.RollLineLineDetailsColumnDefinitions()}
                      dataList={rollLines}
                    /> */}
                    <CustomTable
                      columns={this.rollLineColumns()}
                      data={rollLines}
                      label={"Roll Lines"}
                    />
                  </div>
                  <Row>
                    <Col sm="1">PickedToDate</Col>
                    <Col sm="2">
                      <NumberFormatInputbox
                        value={pickTicketLineData.pickedQuantity}
                        onChange={this.onLineChange}
                        className="qty_input text-right summary_input"
                        decimalScale={2}
                        name={"pickedQuantity"}
                        disabled={true}
                      />
                    </Col>

                    <Col sm="1">Picked[Current]</Col>
                    <Col sm="2">
                      <NumberFormatInputbox
                        value={pickTicketLineData.currentlyPickedQuantity}
                        onChange={this.onLineChange}
                        className="qty_input text-right summary_input"
                        decimalScale={2}
                        name={"currentlyPickedQuantity"}
                        disabled={true}
                      />
                    </Col>

                    <Col sm="1">Total Rolls</Col>
                    <Col sm="2">
                      <NumberFormatInputbox
                        value={totalRolls}
                        onChange={this.onLineChange}
                        className="qty_input text-right summary_input"
                        //decimalScale={2}
                        // name={"currentlyPickedQuantity"}
                        disabled={true}
                      />
                    </Col>
                  </Row>
                </div>
              </div>
            }
          />
        </div>

        <div>
          <MultiViewPopup
            popupLvlClass={"popupSizeLevel1"}
            isModulePopup={false}
            isShowPopup={this.state.isShowRollPopup}
            closeOnEsc={false}
            closeAlertModalCallBack={this.closeAlertRollModalCallBack}
            title={"Roll DETAIL"}
            closeOnDocumentClick={false}
            lineFunctionalityForm={this.lineFunctionalityForm}
            lockScroll={false}
            alertContainerBox={
              <AlertToolBox
                alertMsgList={this.state.alertMessage}
                alertErrorType={this.state.alertType}
                isShowAlert={this.state.isShowRollPopupAlert}
                hideAlertCallBack={this.hideRollAlertCallBack}
              />
            }
            headerButtonContainer={
              <div className="floatLeft">
                <Button
                  className="header_buttons enterFocus"
                  onClick={(e) => this.applyRollLines(e)}
                  disabled={this.state.isDisabledFields}
                >
                  Apply
                </Button>

                <Button
                  className="header_buttons"
                  size="sm"
                  onClick={(e) => this.cancelFindRolls(e)}
                  disabled={this.state.isDisabledFields}
                >
                  Cancel
                </Button>
              </div>
            }
            content={
              <div>
                <PickTicketRollForm
                  {...this.state}
                  selectedFindRollChange={this.selectedFindRollChange}
                  findRollsOnClick={this.findRollsOnClick}
                  clearRolls={this.clearRolls}
                  selectAllRoll={this.selectAllRoll}
                  unSelectAllRoll={this.unSelectAllRoll}
                  rollOnChange={this.rollOnChange}
                  onLineChange={this.onLineChange}
                />
              </div>
            }
          />
        </div>
        <div>
          <MultiViewPopup
            popupLvlClass={"popupSizeLevel3"}
            isModulePopup={false}
            isShowPopup={this.state.isShowBoxPopup}
            closeOnEsc={false}
            closeAlertModalCallBack={this.closeAlertModalCallBack}
            title={this.state.is3PL ? "Pallet DETAIL" : "BOX DETAIL"}
            closeOnDocumentClick={false}
            lineFunctionalityForm={this.lineFunctionalityForm}
            lockScroll={true}
            alertContainerBox={
              <AlertToolBox
                alertMsgList={this.state.alertMessage}
                alertErrorType={this.state.alertType}
                isShowAlert={this.state.isShowAlert}
                hideAlertCallBack={this.hideAlertCallBack}
              />
            }
            headerButtonContainer={
              <div className="floatLeft">
                <Button
                  className="header_buttons enterFocus"
                  size="sm"
                  onClick={(e) => this.addorupdateBoxLine(e)}
                  disabled={this.state.isDisabledFields}
                >
                  Add/Update
                </Button>

                <Button
                  className="header_buttons"
                  size="sm"
                  onClick={(e) => this.clearBoxLineValues(e)}
                  disabled={this.state.isDisabledFields}
                >
                  Clear
                </Button>
              </div>
            }
            content={
              <div>
                {/* <div className="header_div col-md-12 col-lg-12"> */}

                <div>
                  <div className="">
                    <Row>
                      <Col className="align-items-left" sm="1">
                        <FormLabel>PickTicket#</FormLabel>
                      </Col>

                      <Col sm="3">
                        <InputTextbox
                          name="code"
                          type="text"
                          onChange={this.onChange}
                          readOnly={true}
                          value={pickTicketData.code}
                          disabled={isDisabledFields}
                        />{" "}
                      </Col>
                      <Col className="align-items-left" sm="1">
                        <FormLabel>Customer</FormLabel>{" "}
                      </Col>

                      <Col sm="3">
                        <InputTextbox
                          ref={this.customerCodeRef}
                          name="customerCode"
                          type="text"
                          onChange={this.onChange}
                          readOnly={true}
                          value={pickTicketData.customerCode}
                          disabled={isDisabledFields}
                        />{" "}
                      </Col>

                      <Col sm="4">
                        <InputTextbox
                          name="customerName"
                          type="text"
                          onChange={this.onChange}
                          readOnly={true}
                          value={pickTicketData.customerName}
                          disabled={isDisabledFields}
                        />{" "}
                      </Col>
                    </Row>
                    <Row>
                      <Col className="align-items-left" sm="1">
                        <FormLabel>PO#</FormLabel>
                      </Col>

                      <Col sm="3">
                        <InputTextbox
                          name="customerPurchaseOrderNumber"
                          onChange={this.onChange}
                          readOnly={true}
                          value={pickTicketData.customerPurchaseOrderNumber}
                          disabled={isDisabledFields}
                        />
                      </Col>
                    </Row>
                  </div>

                  <Row>
                    <Col className="align-items-left title_text_div" sm="2">
                      {this.state.is3PL ? (
                        <FormLabel className="label_head">
                          PALLET DETAIL
                        </FormLabel>
                      ) : (
                        <FormLabel className="label_head">BOX DETAIL</FormLabel>
                      )}
                    </Col>
                  </Row>
                  <Row>
                    <Col className="align-items-left" sm="1">
                      <FormLabel>Line# </FormLabel>{" "}
                    </Col>
                    <Col sm="3">
                      <InputTextbox
                        name="boxLineNumber"
                        onChange={this.onBoxLineChange}
                        readOnly={true}
                        value={pickTicketBoxLineData.boxLineNumber}
                        disabled={isDisabledFields}
                        isMandatory={true}
                      />{" "}
                    </Col>

                    <Col className="align-items-left" sm="1">
                      <FormLabel>Box#</FormLabel>
                    </Col>

                    <Col sm="3">
                      <InputTextbox
                        name="boxNumber"
                        placeholder="BoxNumber"
                        onChange={this.onBoxLineChange}
                        disabled={isDisabledFields}
                        value={pickTicketBoxLineData.boxNumber}
                        isMandatory={true}
                      />{" "}
                    </Col>

                    <Col className="align-items-left" sm="1">
                      <FormLabel>WeightIn Lbs</FormLabel>
                    </Col>

                    <Col sm="3">
                      <NumberFormatInputbox
                        value={pickTicketBoxLineData.weightInLbs}
                        onChange={this.onBoxLineChange}
                        decimalScale={2}
                        name={"weightInLbs"}
                        disabled={isDisabledFields}
                        isMandatory={true}
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col className="align-items-left" sm="1">
                      <FormLabel>BoxType</FormLabel>{" "}
                    </Col>
                    <Col sm="3">
                      <InputTextbox
                        onChange={this.onBoxTypeChange}
                        ref={this.boxTypeRef}
                        name="boxType"
                        placeholder="BoxType"
                        // readOnly={disableUpdatableFields}
                        disabled={isDisabledFields}
                        value={pickTicketBoxLineData.boxType}
                        lookupRequired={true}
                        lookupHandler={this.state.boxTypeLookupHandler}
                        enterKeyEventHandler={this.boxTypeEnterKeyEventHandler}
                        autoCompleteListData={
                          this.state.boxTypePageListForAutoCompleteList
                        }
                        enableAutoCompleteTextBox={true}
                        displayAutoCompleteList={
                          this.displayAutoCompleteBoxTypeList
                        }
                        showAutoCompleteList={
                          this.state.showAutoCompleteBoxTypeList
                        }
                      ></InputTextbox>
                    </Col>

                    <Col className="align-items-left" sm="1">
                      <FormLabel>LengthIn Inces</FormLabel>{" "}
                    </Col>
                    <Col sm="3">
                      <NumberFormatInputbox
                        value={pickTicketBoxLineData.lengthInInces}
                        onChange={this.onBoxLineChange}
                        decimalScale={2}
                        name={"lengthInInces"}
                        disabled={isDisabledFields}
                        isMandatory={true}
                      />
                    </Col>
                    <Col className="align-items-left" sm="1">
                      <FormLabel>HeightIn Inces</FormLabel>{" "}
                    </Col>
                    <Col sm="3">
                      <NumberFormatInputbox
                        value={pickTicketBoxLineData.heightInInces}
                        onChange={this.onBoxLineChange}
                        decimalScale={2}
                        name={"heightInInces"}
                        disabled={isDisabledFields}
                        isMandatory={true}
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col className="align-items-left" sm="1">
                      <FormLabel>WidthIn Inces</FormLabel>{" "}
                    </Col>
                    <Col sm="3">
                      <NumberFormatInputbox
                        value={pickTicketBoxLineData.widthInInces}
                        onChange={this.onBoxLineChange}
                        decimalScale={2}
                        name={"widthInInces"}
                        disabled={isDisabledFields}
                        isMandatory={true}
                      />
                    </Col>
                    <Col className="align-items-left" sm="1">
                      <FormLabel>CODValue</FormLabel>{" "}
                    </Col>
                    <Col sm="3">
                      <NumberFormatInputbox
                        value={pickTicketBoxLineData.codValue}
                        onChange={this.onBoxLineChange}
                        decimalScale={2}
                        name={"codValue"}
                        disabled={isDisabledFields}
                        isMandatory={true}
                      />
                    </Col>

                    <Col className="align-items-left" sm="1">
                      <FormLabel>Declared Value</FormLabel>{" "}
                    </Col>
                    <Col sm="3">
                      <NumberFormatInputbox
                        value={pickTicketBoxLineData.declaredValue}
                        onChange={this.onBoxLineChange}
                        decimalScale={2}
                        name={"declaredValue"}
                        disabled={isDisabledFields}
                        isMandatory={true}
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col className="align-items-left" sm="1">
                      <FormLabel>CODFunds</FormLabel>{" "}
                    </Col>
                    <Col sm="3">
                      <InputTextbox
                        name="codFundsCode"
                        placeholder="COD Funds"
                        onChange={this.onBoxLineChange}
                        readOnly={isDisabledFields}
                        value={pickTicketBoxLineData.codFundsCode}
                        disabled={isDisabledFields}
                        isMandatory={true}
                      />{" "}
                    </Col>
                    <Col className="align-items-left" sm="1">
                      <FormLabel>Tracking#</FormLabel>{" "}
                    </Col>
                    <Col sm="3">
                      <InputTextbox
                        name="trackingNumber"
                        placeholder="Tracking#"
                        onChange={this.onBoxLineChange}
                        // readOnly={disableUpdatableFields}
                        value={pickTicketBoxLineData.trackingNumber}
                        disabled={isDisabledFields}
                        isMandatory={true}
                      />{" "}
                    </Col>
                  </Row>
                  <Row>
                    <Col className="align-items-left" sm="2">
                      <FormLabel>Pallet Details</FormLabel>
                    </Col>
                    {/* <Col>
                      <Button
                        size="sm"
                        id="fabric_Add_Button"
                        className="enterFocus"
                        onClick={() => this.openPalletSummary()}
                      >
                        Summary
                      </Button>
                    </Col> */}
                  </Row>
                  {is3PL && (
                    <div className="">
                      <Table id="fabrics_tables_default">
                        <thead>
                          <tr>
                            <th>
                              <Col sm="4">
                                <Button
                                  size="sm"
                                  id="fabric_Add_Button"
                                  className="enterFocus"
                                  onClick={(e) =>
                                    this.openPalletDetails(
                                      e,
                                      new PickTicketBoxPalletLineDetailBean(),
                                      1
                                    )
                                  }
                                >
                                  <AddIcon />
                                </Button>
                              </Col>
                            </th>
                            <th>Item</th>
                            <th>Item Name</th>
                            <th>Color</th>
                            <th>SKU</th>
                            <th>Pallet#</th>
                            <th>Pallet Qty</th>
                          </tr>
                        </thead>
                        <tbody>
                          {!isEmptyArray(palletLines) &&
                            palletLines.map((ln, i) => (
                              <tr key={i}>
                                <td>
                                  <Button
                                    variant="secondry"
                                    className="hyperLinkText"
                                    onClick={(e) =>
                                      this.openPalletDetails(e, ln, 2)
                                    }
                                  >
                                    {ln.palletLineNumber}
                                  </Button>
                                </td>
                                <td>{ln.fabricStyleCode}</td>
                                <td>{ln.fabricStyleName}</td>
                                <td>{ln.colorCode}</td>
                                <td>{ln.skuNumber}</td>
                                <td>{ln.palletNumber}</td>
                                <td className="text-right">
                                  {ln.palletQuantity}
                                </td>
                              </tr>
                            ))}
                        </tbody>
                      </Table>
                    </div>
                  )}
                </div>
              </div>
            }
          />
        </div>
        <MultiViewPopup
          popupLvlClass={"popupSizeLevel4"}
          isModulePopup={false}
          isShowPopup={this.state.isShowPalletSummary}
          closeAlertModalCallBack={this.closeAlertModalCallBackLvl4}
          title={"Pallet Summary"}
          lockScroll={false}
          alertContainerBox={
            <AlertToolBox
              alertMsgList={this.state.alertMessage}
              alertErrorType={this.state.alertType}
              isShowAlert={this.state.isShowAlertLvl4}
              hideAlertCallBack={this.hideAlertCallBackLvl4}
            />
          }
          headerButtonContainer={
            <div className="floatLeft">
              <Button
                className="header_buttons enterFocus"
                onClick={(e) => this.generatePalletSummary(e)}
                disabled={this.state.isDisabledFields}
              >
                Report
              </Button>
            </div>
          }
          content={
            <div>
              <div className="div_Custom_2">
                <Table id="fabrics_tables_default">
                  <thead>
                    <tr>
                      <th>Line#</th>
                      <th>Location#</th>
                      <th>Roll#</th>
                      <th>{this.state.is3PL ? "Inventory#" : "RollSKU#"}</th>
                      <th>ReceivedQty</th>
                      <th>Customer Lot#</th>
                      <th>Box#</th>
                      <th>InvRcdQty#</th>
                      <th>InfoText</th>
                      <th>Bin Location#</th>
                    </tr>
                  </thead>
                  {this.state.palletSummary_List != null ? (
                    <tbody>
                      {this.state.palletSummary_List.map((ln, index) => (
                        <tr key={index}>
                          <td className="hyperLinkText">
                            {ln.logisticRollLineNumber}
                          </td>
                          <td>{ln.locationCode}</td>
                          <td>{ln.rollNumber}</td>
                          <td>{ln.rollSkuNumber}</td>
                          <td>{ln.receivedQuantity}</td>
                          <td>{ln.customerLotNumber}</td>
                          <td>{ln.boxNumber}</td>
                          <td>{ln.inventoryReceivedQuantity}</td>
                          <td>{ln.infoText}</td>
                          <td>{ln.aisleInfoText}</td>
                        </tr>
                      ))}
                    </tbody>
                  ) : null}
                </Table>
                {this.state.palletSummary_List.length != 0 ? null : (
                  <div className="no_Data">{"NO DATA"}</div>
                )}
              </div>
            </div>
          }
        />
        <div>
          <MultiViewPopup
            popupLvlClass={"popupSizeLevel5"}
            isShowPopup={this.state.isShowPalletPopup}
            closeAlertModalCallBack={this.closeAlertModalCallBackLvl5}
            title={"PALLET DETAIL"}
            closeOnDocumentClick={false}
            lockScroll={false}
            alertContainerBox={
              <AlertToolBox
                alertMsgList={this.state.alertMessage}
                alertErrorType={this.state.alertType}
                isShowAlert={this.state.isShowAlertLvl5}
                hideAlertCallBack={this.hideAlertCallBackLvl5}
              />
            }
            headerButtonContainer={
              <div className="floatLeft">
                <Button
                  className="header_buttons enterFocus"
                  size="sm"
                  onClick={(e) => this.addOrUpdatePalletDetail(e)}
                  // disabled={true}
                >
                  Add/Update
                </Button>
              </div>
            }
            content={
              <div>
                <div>
                  <Row>
                    <Col className="align-items-left" sm="2">
                      <FormLabel>PT line#</FormLabel>
                    </Col>
                    <Col sm="4">
                      <InputTextbox
                        name={"pickTicketLineNumber"}
                        value={palletData.pickTicketLineNumber}
                        // disabled={isDisabledPalletFields}
                        onChange={this.onPalletPtLineChange}
                        placeholder="PickTicketLine"
                        lookupRequired={true}
                        lookupHandler={this.state.palletPtLineLookupHandler}
                        enterKeyEventHandler={
                          this.ptLinePalletCodeEnterKeyEventHandler
                        }
                        autoCompleteListData={
                          this.state.ptLinePageListForAutoCompleteList
                        }
                        enableAutoCompleteTextBox={true}
                        displayAutoCompleteList={
                          this.displayAutoCompletePalletPtLineList
                        }
                        showAutoCompleteList={
                          this.state.showAutoCompletePtLineList
                        }
                        isMandatory={true}
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col className="align-items-left" sm="2">
                      <FormLabel>Item#</FormLabel>
                    </Col>
                    <Col sm="4">
                      <InputTextbox
                        name="fabricStyleCode"
                        onChange={this.onPalletChange}
                        disabled={true}
                        value={palletData.fabricStyleCode}
                      />{" "}
                    </Col>
                    <Col sm="6">
                      <InputTextbox
                        name="fabricStyleName"
                        onChange={this.onPalletChange}
                        disabled={true}
                        value={palletData.fabricStyleName}
                      />{" "}
                    </Col>
                  </Row>
                  <Row>
                    <Col className="align-items-left" sm="2">
                      <FormLabel>Color</FormLabel>
                    </Col>
                    <Col sm="4">
                      <InputTextbox
                        value={palletData.colorCode}
                        onChange={this.onBoxLineChange}
                        name={"colorCode"}
                        disabled={true}
                      />
                    </Col>
                    <Col className="align-items-left" sm="2">
                      <FormLabel>Sku</FormLabel>
                    </Col>
                    <Col sm="4">
                      <InputTextbox
                        value={palletData.skuNumber}
                        onChange={this.onPalletChange}
                        name={"skuNumber"}
                        disabled={true}
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col className="align-items-left" sm="2">
                      <FormLabel>Pallet#</FormLabel>
                    </Col>
                    <Col sm="4">
                      <InputTextbox
                        value={palletData.palletNumber}
                        onChange={this.onPalletChange}
                        name={"palletNumber"}
                        isMandatory={true}
                        // disabled={true}
                      />
                    </Col>
                    <Col className="align-items-left" sm="2">
                      <FormLabel>Qty</FormLabel>
                    </Col>
                    <Col sm="4">
                      <NumberFormatInputbox
                        value={palletData.palletQuantity}
                        onChange={this.onPalletChange}
                        name={"palletQuantity"}
                        isMandatory={true}
                        // disabled={true}
                      />
                    </Col>
                  </Row>
                </div>
              </div>
            }
          />
        </div>

        <div>
          <MultiViewPopup
            popupLvlClass={"popupSizeLevel3"}
            isModulePopup={false}
            isShowPopup={this.state.isShowRatePopup}
            closeOnEsc={false}
            closeAlertModalCallBack={this.closeAlertModalCallBack}
            title={"RATE DETAIL"}
            lockScroll={true}
            closeOnDocumentClick={false}
            lineFunctionalityForm={this.lineFunctionalityForm}
            alertContainerBox={
              <AlertToolBox
                alertMsgList={this.state.alertMessage}
                alertErrorType={this.state.alertType}
                isShowAlert={this.state.isShowPopupAlert}
                hideAlertCallBack={this.hidePopupAlertCallBack}
              />
            }
            content={
              <div className="sales_line_pop">
                <div className="header_div col-md-12 col-lg-12">
                  <div className="">
                    <Row>
                      <Col className="align-items-left" sm="1">
                        <FormLabel>PickTicket#</FormLabel>
                      </Col>

                      <Col sm="2">
                        <InputTextbox
                          name="code"
                          type="text"
                          onChange={this.onChange}
                          readOnly={true}
                          value={pickTicketData.code}
                          disabled={isDisabledFields}
                        />{" "}
                      </Col>
                      <Col className="align-items-left" sm="1">
                        <FormLabel>Customer</FormLabel>{" "}
                      </Col>

                      <Col sm="2">
                        <InputTextbox
                          ref={this.customerCodeRef}
                          name="customerCode"
                          type="text"
                          onChange={this.onChange}
                          readOnly={true}
                          value={pickTicketData.customerCode}
                          disabled={isDisabledFields}
                        />{" "}
                      </Col>

                      <Col sm="3">
                        <InputTextbox
                          name="customerName"
                          type="text"
                          onChange={this.onChange}
                          readOnly={true}
                          value={pickTicketData.customerName}
                          disabled={isDisabledFields}
                        />{" "}
                      </Col>

                      <Col className="align-items-left" sm="1">
                        <FormLabel>PO#</FormLabel>
                      </Col>

                      <Col sm="2">
                        <InputTextbox
                          name="customerPurchaseOrderNumber"
                          onChange={this.onChange}
                          readOnly={true}
                          value={pickTicketData.customerPurchaseOrderNumber}
                          disabled={isDisabledFields}
                        />
                      </Col>
                    </Row>
                  </div>
                  <div className="">
                    <div>
                      {" "}
                      <BootstrapDataGrid
                        id="RateDetailsTable"
                        columnsList={this.RateDetailsColumnDefinitions()}
                        dataList={boxRateDetails}
                      />
                    </div>
                  </div>
                </div>
              </div>
            }
          />
        </div>
        <MultiViewPopup
          popupLvlClass={"popupSizeLevel3"}
          isModulePopup={false}
          isShowPopup={this.state.isShowAdvanceSearchPopup}
          closeOnEsc={false}
          closeAlertModalCallBack={this.closeAlertModalCallBack}
          title={"Advance Search"}
          closeOnDocumentClick={false}
          lockScroll={true}
          lineFunctionalityForm={this.lineFunctionalityForm}
          alertContainerBox={
            <AlertToolBox
              alertMsgList={this.state.alertMessage}
              alertErrorType={this.state.alertType}
              isShowAlert={this.state.isShowPopupAlert}
              hideAlertCallBack={this.hidePopupAlertCallBack}
            />
          }
          headerButtonContainer={
            <div className="floatLeft">
              <Button
                className="header_buttons enterFocus"
                size="sm"
                onClick={(e) => this.onAdvanceSearchClick(e)}
              >
                Search
              </Button>
            </div>
          }
          content={
            <div className="criteria header_div ">
              <Row>
                <Col sm="2">
                  <FormLabel>PT#</FormLabel>
                </Col>

                <Col sm="3">
                  <InputTextbox
                    name="pickTicketCode"
                    type="text"
                    placeholder="Enter PTNumber"
                    value={criteria.pickTicketCode}
                    onChange={this.onAdvSearchChange}
                  />
                </Col>
              </Row>
              <Row>
                <Col sm="2">
                  <FormLabel>PickTicketContains</FormLabel>
                </Col>

                <Col sm="3">
                  <InputTextbox
                    name="pickTicketContains"
                    type="text"
                    placeholder="Enter pickTicketContains"
                    value={criteria.pickTicketContains}
                    onChange={this.onAdvSearchChange}
                  />
                </Col>
              </Row>
              <Row>
                <Col sm="2">
                  <FormLabel>PickTicket# StartsWith</FormLabel>
                </Col>

                <Col sm="3">
                  <InputTextbox
                    name="pickTicketStartsWith"
                    type="text"
                    placeholder="Enter PickTicketStartsWith"
                    value={criteria.pickTicketStartsWith}
                    onChange={this.onAdvSearchChange}
                  />
                </Col>
              </Row>

              <Row>
                <Col sm="2">
                  <FormLabel>SO#</FormLabel>
                </Col>

                <Col sm="3">
                  <InputTextbox
                    name="salesOrderNumber"
                    type="text"
                    placeholder="Enter salesOrderNumber#"
                    value={criteria.salesOrderNumber}
                    onChange={this.onAdvSearchChange}
                  />
                </Col>
              </Row>
            </div>
          }
        />
        <MultiViewPopup
          popupLvlClass={"popupSizeLevel7"}
          isModulePopup={false}
          isShowPopup={this.state.isShowShipperPopup}
          closeOnEsc={false}
          closeAlertModalCallBack={this.closeAlertModalCallBackLvl7}
          title={"SHIPPER DETAIL"}
          closeOnDocumentClick={false}
          lockScroll={true}
          alertContainerBox={
            <AlertToolBox
              alertMsgList={this.state.alertMessage}
              alertErrorType={this.state.alertType}
              isShowAlert={this.state.isShowAlertLvl7}
              hideAlertCallBack={this.hideAlertCallBackLvl7}
            />
          }
          headerButtonContainer={
            <div className="floatLeft">
              <Button
                className="header_buttons enterFocus"
                onClick={(e) => this.updateShipperData(e)}
              >
                continue
              </Button>
            </div>
          }
          content={
            <div className="">
              <Row>
                <Col>
                  <FormLabel>Shipper Details</FormLabel>
                </Col>
              </Row>
              <Row>
                <Col sm="1">
                  <FormLabel>PickTicket</FormLabel>
                </Col>
                <Col sm="3">
                  <InputTextbox
                    name="code"
                    value={pickTicketData.code}
                    disabled={true}
                  />
                </Col>
                <Col sm="1">
                  <FormLabel>Customer</FormLabel>
                </Col>
                <Col sm="3">
                  <InputTextbox
                    name="customerCode"
                    value={pickTicketData.customerCode}
                    disabled={true}
                  />
                </Col>
                <Col sm="4">
                  <InputTextbox
                    name="customerName"
                    value={pickTicketData.customerName}
                    disabled={true}
                  />
                </Col>
              </Row>
              <Row>
                <Col sm="1">
                  <FormLabel>Currency</FormLabel>
                </Col>
                <Col sm="3">
                  <InputTextbox
                    name="currencyCode"
                    value={pickTicketData.currencyCode}
                    disabled={true}
                    isMandatory={true}
                  />
                </Col>
                <Col sm="1">
                  <FormLabel>Shipper#</FormLabel>
                </Col>
                <Col sm="3">
                  <InputTextbox
                    name="shippedBy"
                    value={shipperAndPackerData.shippedBy}
                    onChange={this.shipperAndPackerOnChange}
                    isMandatory={true}
                    // disabled={true}
                  />
                </Col>
                <Col sm="1">
                  <FormLabel>Shipper Date</FormLabel>
                </Col>
                <Col sm="3">
                  <DatePickerComponent
                    name="shippedDate"
                    value={shipperAndPackerData.shippedDate}
                    onChange={this.shipperAndPackerOnChange}
                    isMandatory={true}
                    // disabled={true}
                  />
                </Col>
              </Row>
            </div>
          }
        />
        <MultiViewPopup
          popupLvlClass={"popupSizeLevel7"}
          isModulePopup={false}
          isShowPopup={this.state.isShowPackerPopup}
          closeOnEsc={false}
          closeAlertModalCallBack={this.closeAlertModalCallBackLvl7}
          title={"PACKER DETAIL"}
          lockScroll={true}
          closeOnDocumentClick={false}
          alertContainerBox={
            <AlertToolBox
              alertMsgList={this.state.alertMessage}
              alertErrorType={this.state.alertType}
              isShowAlert={this.state.isShowAlertLvl7}
              hideAlertCallBack={this.hideAlertCallBackLvl7}
            />
          }
          headerButtonContainer={
            <div className="floatLeft">
              <Button
                className="header_buttons enterFocus"
                onClick={(e) => this.updatePackerData(e)}
              >
                continue
              </Button>
            </div>
          }
          content={
            <div className="">
              <Row>
                <Col>
                  <FormLabel>Packer Details</FormLabel>
                </Col>
              </Row>
              <Row>
                <Col sm="1">
                  <FormLabel>PickTicket</FormLabel>
                </Col>
                <Col sm="3">
                  <InputTextbox
                    name="code"
                    value={pickTicketData.code}
                    disabled={true}
                  />
                </Col>
                <Col sm="1">
                  <FormLabel>Customer</FormLabel>
                </Col>
                <Col sm="3">
                  <InputTextbox
                    name="customerCode"
                    value={pickTicketData.customerCode}
                    disabled={true}
                  />
                </Col>
                <Col sm="4">
                  <InputTextbox
                    name="customerName"
                    value={pickTicketData.customerName}
                    disabled={true}
                  />
                </Col>
              </Row>
              <Row>
                <Col sm="1">
                  <FormLabel>Currency</FormLabel>
                </Col>
                <Col sm="3">
                  <InputTextbox
                    name="currencyCode"
                    value={pickTicketData.currencyCode}
                    disabled={true}
                    isMandatory={true}
                  />
                </Col>
                <Col sm="1">
                  <FormLabel>Packer#</FormLabel>
                </Col>
                <Col sm="3">
                  <InputTextbox
                    name="packedUpBy"
                    value={shipperAndPackerData.packedUpBy}
                    onChange={this.shipperAndPackerOnChange}
                    isMandatory={true}
                    // disabled={true}
                  />
                </Col>
                <Col sm="1">
                  <FormLabel>Packer Date</FormLabel>
                </Col>
                <Col sm="3">
                  <DatePickerComponent
                    name="packedUpDate"
                    value={shipperAndPackerData.packedUpDate}
                    onChange={this.shipperAndPackerOnChange}
                    isMandatory={true}
                    // disabled={true}
                  />
                </Col>
              </Row>
            </div>
          }
        />
        <ReasonCaptureComponent
          ref={this.cancelReasonDialogRef}
          reasons={this.state.cancelReasons}
          reasonData={this.state.reasonData}
          title="PickTicket Cancel"
          onChange={this.onReasonChange}
          onClick={this.onCancelReasonContinue}
          isShowPopup={this.state.isShowCancelReasonPopup}
          closeReasonModelCallBack={this.closeReasonModelCallBack}
          reasonEnterKeyEventHandler={this.reasonEnterKeyEventHandler}
          reasonPageListForAutoCompleteList={
            this.state.reasonPageListForAutoCompleteList
          }
          displayAutoCompleteReasonList={this.displayAutoCompleteReasonList}
          showAutoCompleteReasonList={this.state.showAutoCompleteReasonList}
          onReasonDescChange={this.onReasonDescChange}
        />
      </div>
    );
  }
}

class PickTicketListForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      pickTicketCriteria: new PickTicketSearchCriteria(),
      filter: "",
      pageList: this.props.pageList,
    };
    this.searchRef = React.createRef();
  }

  componentDidMount() {
    if (this.searchRef.current != null) {
      this.searchRef.current.focus();
    }
  }

  onChange = (e) => {
    this.props.onCriteriaChange(e);
  };

  onKeyDown = (e) => {
    if (e.keyCode == 13) {
      this.props.filterPickTicket();
    }
  };

  advanceSearch = (e) => {
    if (e.detail === 1) this.props.advanceSearch();
  };

  filterPickTicket = (e) => {
    if (e.detail === 1) this.props.filterPickTicket();
  };

  resetFilteredPickTicket = (e) => {
    if (e.detail === 1) {
      let pickTicketCriteria = this.props.pickTicketCriteria;
      // pickTicketCriteria.specialSearchText = "";
      this.props.resetFilteredPickTicket(pickTicketCriteria);
    }
  };

  loadFirst = (e) => {
    if (e.detail === 1) this.props.loadFirst();
  };
  loadNext = (e) => {
    if (e.detail === 1) this.props.loadNext();
  };
  loadPrevious = (e) => {
    if (e.detail === 1) this.props.loadPrevious();
  };
  loadLast = (e) => {
    if (e.detail === 1) this.props.loadLast();
  };

  handlePickTicketCodeChange = (event) => {
    this.setState({ filter: event.target.value });
  };

  handleHyperLinkClick = (e, val) => {
    if (e.detail === 1) this.props.editPickTicket(val);
  };

  //() => this.props.editPickTicket(inv.code)

  // BootstrapColumnDefinitions = () => {
  //   let columnList = [];
  //   let moduleCaption = this.props.moduleCaption;
  //   columnList.push(
  //     new BootstrapDataGridColumnDefinition()
  //       .setDetails(moduleCaption + "#", "code")
  //       .setColumnType("hyperLink")
  //       .callHyperLinkCallback(this.handleHyperLinkClick)
  //       .setSortColumn(true)
  //   );
  //   columnList.push(
  //     new BootstrapDataGridColumnDefinition()
  //       .setDetails("PickTicketDate", "createdDate")
  //       .setSortColumn(true)
  //   );
  //   columnList.push(
  //     new BootstrapDataGridColumnDefinition()
  //       .setDetails("SalesOrder#", "salesOrderNumber")
  //       .setSortColumn(true)
  //   );
  //   columnList.push(
  //     new BootstrapDataGridColumnDefinition()
  //       .setDetails("CustomerCode", "customerCode")
  //       .setSortColumn(true)
  //   );
  //   columnList.push(
  //     new BootstrapDataGridColumnDefinition()
  //       .setDetails("CustomerName", "customerName")
  //       .setSortColumn(true)
  //   );

  //   columnList.push(
  //     new BootstrapDataGridColumnDefinition()
  //       .setDetails("PO#", "customerPurchaseOrderNumber")
  //       .setSortColumn(true)
  //   );

  //   columnList.push(
  //     new BootstrapDataGridColumnDefinition()
  //       .setDetails("Status", "status")
  //       .setColumnType("statusColumn")
  //       .setStatusCaptionConverter(ModuleUtils.getPickTicketStatusCaption)
  //       .setSortColumn(true)
  //   );

  //   return columnList;
  // };
  handleSortingChange = (e, accessor) => {
    if (e.detail === 1) this.props.handleSortingChange(accessor);
  };
  render() {
    let pickTicketList = new Array();
    if (!isEmptyArray(this.props.pickTicketList)) {
      pickTicketList = this.props.pickTicketList;
    }

    let pickTicketCriteria = this.props.pickTicketCriteria;
    let pageList = this.props.pageList;

    let totalPages = 0;
    if (!isEmpty(pageList)) {
      let pageSize = pageList.pageSize;
      let totalCount = pageList.totalCount;
      totalPages = totalCount / pageSize;
      totalPages += totalCount % pageSize == 0 ? 0 : 1;
    }
    let isLoading = this.props.isLoading;
    // let criteriaString = ""; //To-Do Need to Change
    let criteriaString = this.props.getCriteriaString();
    let isAdvanceSearch = this.props.isAdvanceSearch;

    return (
      <div>
        <div className="secondary_module_header">
          {/* <div className="secondary_module_header_title">
            <FormLabel className="secondary_module_search_color">
              Search
            </FormLabel>
            <span className="secondary_module_header_title_2">
              <InputTextbox
                ref={this.searchRef}
                name="searchName"
                type="text"
                value={pickTicketCriteria.searchName}
                placeholder="Enter Value to Filter.."
                onChange={this.onChange}
                onKeyDown={this.onKeyDown}
              />
            </span>
            <span className="px-2"></span>
            <span className="px-2"></span>
            <Button size="sm" onClick={(e) => this.filterPickTicket(e)}>
              Filter
            </Button>
            <span className="px-2"></span>
            <Button size="sm" onClick={(e) => this.resetFilteredPickTicket(e)}>
              Reset
            </Button>
          </div> */}
          <div className="mdle-criteria-wrap">
            <div className="">
              <FormLabel className="criteria-labl">Status</FormLabel>
            </div>
            <div className="criteria-val">
              <FormControl
                as="select"
                custom
                onChange={this.onChange}
                name="status"
                value={pickTicketCriteria.status}
              >
                <option value={""}>All</option>
                <option value={"P"}>Picked</option>
                <option value={"K"}>Partially Picked</option>
                <option value={"F"}>Invoiced / Finished</option>
                <option value={"I"}>Partially Invoiced</option>
                <option value={"X"}>Cancelled</option>
              </FormControl>
            </div>
            <div className="">
              <FormLabel className="criteria-labl">Search</FormLabel>
            </div>
            <div className="criteria-val">
              <InputTextbox
                ref={this.searchRef}
                name="searchName"
                type="text"
                value={pickTicketCriteria.searchName}
                placeholder="Enter Value to Filter.."
                onChange={this.onChange}
                onKeyDown={this.onKeyDown}
              />
            </div>
            <div className="criteria-btn-wrap ">
              <Button
                className="header_buttons secondary"
                size="sm"
                onClick={(e) => this.filterPickTicket(e)}
              >
                Filter
              </Button>
              <Button
                className="header_buttons secondary"
                size="sm"
                onClick={(e) => this.resetFilteredPickTicket(e)}
              >
                Reset
              </Button>
            </div>
          </div>
          <div className="module_header_secondary_buttons">
            <span>
              PAGE - {pageList.currentPage} OF {parseInt(totalPages)}
            </span>

            <Button
              size="sm"
              className="secondary_header_buttons"
              onClick={(e) => this.loadFirst(e)}
            >
              First
            </Button>
            <Button
              size="sm"
              className="secondary_header_buttons"
              onClick={(e) => this.loadPrevious(e)}
            >
              Previous
            </Button>
            <Button
              size="sm"
              className="secondary_header_buttons"
              onClick={(e) => this.loadNext(e)}
            >
              Next
            </Button>
            <Button
              size="sm"
              className="secondary_header_buttons"
              onClick={(e) => this.loadLast(e)}
            >
              Last
            </Button>
          </div>
        </div>
        <div className="div_default">
          <Table id="fabrics_tables_default">
            <thead>
              <tr>
                <th onClick={(e) => this.handleSortingChange(e, "code")}>
                  pickTicket#
                  {this.props.order === "desc" &&
                  this.props.sortField === "code" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                <th onClick={(e) => this.handleSortingChange(e, "createdDate")}>
                  PickTicketDate
                  {this.props.order === "desc" &&
                  this.props.sortField === "createdDate" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                <th
                  onClick={(e) =>
                    this.handleSortingChange(e, "salesOrderNumber")
                  }
                >
                  SalesOrder#
                  {this.props.order === "desc" &&
                  this.props.sortField === "salesOrderNumber" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                <th
                  onClick={(e) => this.handleSortingChange(e, "customerCode")}
                >
                  CustomerCode
                  {this.props.order === "desc" &&
                  this.props.sortField === "customerCode" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                <th
                  onClick={(e) => this.handleSortingChange(e, "customerName")}
                >
                  CustomerName
                  {this.props.order === "desc" &&
                  this.props.sortField === "customerName" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                <th
                  onClick={(e) =>
                    this.handleSortingChange(e, "fabricStyleCode")
                  }
                >
                  {this.props.is3PL ? "Item" : "FabricStyle"}
                  {this.props.order === "desc" &&
                  this.props.sortField === "fabricStyleCode" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                <th
                  onClick={(e) =>
                    this.handleSortingChange(e, "customerPurchaseOrderNumber")
                  }
                >
                  CustPO#
                  {this.props.order === "desc" &&
                  this.props.sortField === "customerPurchaseOrderNumber" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                <th onClick={(e) => this.handleSortingChange(e, "status")}>
                  Status
                  {this.props.order === "desc" &&
                  this.props.sortField === "status" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
              </tr>
            </thead>
            <tbody>
              {pickTicketList.map((ln, index) => (
                <tr key={index}>
                  <td>
                    <Button
                      size="sm"
                      variant="secondry"
                      className="hyperLinkText"
                      onClick={(e) => this.handleHyperLinkClick(e, ln.code)}
                    >
                      {ln.code}
                    </Button>
                  </td>
                  <td>{ln.createdDate}</td>
                  <td>{ln.salesOrderNumber}</td>
                  <td>{ln.customerCode}</td>
                  <td>{ln.customerName}</td>
                  <td>{ln.fabricStyleCode}</td>
                  <td>{ln.customerPurchaseOrderNumber}</td>
                  <td>{ModuleUtils.getPickTicketStatusCaption(ln.status)}</td>
                </tr>
              ))}
            </tbody>
          </Table>
        </div>
      </div>
    );
  }
}

class PickTicketRollForm extends React.Component {
  static contextType = AppContext;

  constructor(props) {
    super(props);
    this.state = {};
  }

  selectedFindRollChange = (e, rowData) => {
    this.props.selectedFindRollChange(e, rowData);
  };
  findRollsOnClick = (e) => {
    if (e.detail === 1) this.props.findRollsOnClick();
  };
  clearRolls = (e) => {
    if (e.detail === 1) this.props.clearRolls();
  };
  selectAllRoll = (e) => {
    if (e.detail === 1) this.props.selectAllRoll();
  };
  unSelectAllRoll = (e) => {
    if (e.detail === 1) this.props.unSelectAllRoll();
  };
  rollOnChange = (e) => {
    this.props.rollOnChange(e);
  };
  onLineChange = (e) => {
    this.props.onLineChange(e);
  };

  rollColumns = () => {
    const columns = new Array();
    columns.push(
      new ColumnDefinition()
        .setDetails("", "isSelected", false)
        .setInputDetails(
          false,
          false,
          true,
          null,
          this.selectedFindRollChange,
          null
        )
        .setStyleDetails("", "", "", "wt-1-5 ", "wt-1-5 ")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("RollSKU#", "rollSkuNumber", true)
        .setStyleDetails("left", "", "", "wt-4 ", "wt-4 ")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Box#", "boxNumber", true)
        .setStyleDetails("left", "", "", "wt-4 ", "wt-4 ")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Roll#", "rollNumber", true)
        .setStyleDetails("left", "", "", "wt-4 ", "wt-4 ")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("AvailQty", "availableQuantity", true, true)
        .setStyleDetails("right", "", "", "wt-4 ", "wt-4 ")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Picked  Qty", "pickedQuantity", true, true)
        .setStyleDetails("right", "", "", "wt-4 ", "wt-4 ")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Current  PickedQty", "currentlyPickedQuantity", true)
        .setStyleDetails("right", "", "", "wt-4 ", "wt-4 ")
    );

    columns.push(
      new ColumnDefinition()
        .setDetails("LOT#", "vendorBatchNumber", true)
        .setStyleDetails("left", "", "", "wt-4 ", "wt-4 ")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Location", "locationCode", true)
        .setStyleDetails("left", "", "", "wt-4 ", "wt-4 ")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("PickedLoc", "pickedLocationCode", true)
        .setStyleDetails("left", "", "", "wt-4 ", "wt-4 ")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Bin#", "binLocation", true)
        .setStyleDetails("left", "", "", "wt-4 ", "wt-4 ")
    );

    return columns;
  };

  rollColumnDefinitions = () => {
    let columnList = [];

    columnList.push(
      new DataGridColumnDefinition()
        .setDetails("", "isSelected", 0, false, null, false, null)
        .setEditableDetails(
          false,
          "",
          null,
          false,
          null,
          true,
          this.selectedFindRollChange
        )
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails(
        this.props.is3PL ? "Inventory#" : "RollKU#",
        "rollSkuNumber"
      )
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails("Box#", "boxNumber")
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails("Roll#", "rollNumber")
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails("AvailQty", "availableQuantity")
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails("Picked  Qty", "pickedQuantity")
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails(
        "Current  PickedQty",
        "currentlyPickedQuantity",
        0,
        false,
        null,
        false,
        null
      )
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails("VenLot#", "vendorBatchNumber")
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails("Location", "locationCode")
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails(
        "PickedLoc",
        "pickedLocationCode"
      )
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails("Bin#", "binLocation")
    );

    return columnList;
  };
  render() {
    let pickTicketData = this.props.pickTicketData;
    let pickTicketLineData = this.props.pickTicketLineData;
    let pickTicketRollLineData = this.props.pickTicketRollLineData;
    let rollList = this.props.rollList;
    let is3PL = this.props.is3PL;
    var dataTableStyles = {
      header: {
        style: {
          minHeight: "0px",
        },
      },
      table: {
        style: {
          minHeight: "200px",
          maxHeight: "200px",
          overflowY: "auto",
        },
      },
    };
    return (
      <div>
        <Row>
          <Col className="align-items-left" sm="1">
            <FormLabel>PickTicket#</FormLabel>
          </Col>

          <Col sm="2">
            <InputTextbox
              name="code"
              type="text"
              //onChange={this.onChange}
              value={pickTicketData.code}
              disabled={true}
            />{" "}
          </Col>
          <Col className="align-items-left" sm="1">
            <FormLabel>Customer</FormLabel>{" "}
          </Col>

          <Col sm="2">
            <InputTextbox
              name="customerCode"
              type="text"
              //onChange={this.onChange}
              value={pickTicketData.customerCode}
              disabled={true}
            />{" "}
          </Col>

          <Col sm="3">
            <InputTextbox
              name="customerName"
              type="text"
              //onChange={this.onChange}
              value={pickTicketData.customerName}
              disabled={true}
            />{" "}
          </Col>

          <Col className="align-items-left" sm="1">
            <FormLabel>SalesOrder# </FormLabel>{" "}
          </Col>
          <Col sm="2">
            <InputTextbox
              name="salesOrderNumber"
              placeholder="SalesOrderNumber"
              //onChange={this.onChange}
              value={pickTicketData.salesOrderNumber}
              disabled={true}
            />{" "}
          </Col>
        </Row>

        <Row>
          {is3PL ? (
            <Col className="align-items-left" sm="1">
              <FormLabel>Item </FormLabel>{" "}
            </Col>
          ) : (
            <Col className="align-items-left" sm="1">
              <FormLabel>FabricStyle </FormLabel>{" "}
            </Col>
          )}
          <Col sm="2">
            <InputTextbox
              name="fabricStyleCode"
              // placeholder="Item"
              // onChange={this.onChange}
              value={pickTicketLineData.fabricStyleCode}
              disabled={true}
            />{" "}
          </Col>
          <Col sm="3">
            <InputTextbox
              name="fabricStyleName"
              value={pickTicketLineData.fabricStyleName}
              disabled={true}
            />{" "}
          </Col>

          <Col className="align-items-left" sm="1">
            <FormLabel>Color</FormLabel>
          </Col>

          <Col sm="2">
            <InputTextbox
              name="colorCode"
              onChange={this.onChange}
              value={pickTicketLineData.colorCode}
              disabled={true}
            />{" "}
          </Col>

          <Col className="align-items-left" sm="1">
            <FormLabel>Line#</FormLabel>
          </Col>

          <Col sm="2">
            <InputTextbox
              //onChange={this.onChange}
              name="pickTicketLineNumber"
              value={pickTicketLineData.pickTicketLineNumber}
              disabled={true}
            ></InputTextbox>
          </Col>
        </Row>

        <Row>
          <Col className="align-items-left" sm="1">
            <FormLabel>ToBePickQty</FormLabel>
          </Col>

          <Col sm="2">
            <NumberFormatInputbox
              value={pickTicketLineData.toBePickedQuantity}
              onChange={this.onLineChange}
              className="text-right"
              decimalScale={2}
              name={"toBePickedQuantity"}
              disabled={true}
            />
          </Col>
        </Row>

        <Row>
          <FormLabel className="label_head">Select Criteria</FormLabel>
        </Row>
        <Row>
          <Col sm="1">
            <FormLabel>From AvailQty</FormLabel>
          </Col>
          <Col sm="2">
            <InputTextbox
              onChange={this.rollOnChange}
              name="availableQuantity"
              value={pickTicketRollLineData.availableQuantity}
              isMandatory={true}
              // disabled={true}
            ></InputTextbox>
          </Col>

          <Col sm="1">
            <FormLabel>To AvailQty</FormLabel>
          </Col>
          <Col sm="2">
            <InputTextbox
              onChange={this.rollOnChange}
              name="toAvailableQuantity"
              value={pickTicketRollLineData.toAvailableQuantity}
              isMandatory={true}
              //disabled={true}
            ></InputTextbox>
          </Col>

          <Col sm="1">
            <FormLabel>Roll</FormLabel>
          </Col>
          <Col sm="2">
            <InputTextbox
              onChange={this.rollOnChange}
              name="rollNumber"
              value={pickTicketRollLineData.rollNumber}
              isMandatory={true}
              // disabled={true}
            ></InputTextbox>
          </Col>

          <Col sm="1">
            <FormLabel>Vendor Lot</FormLabel>
          </Col>
          <Col sm="2">
            <InputTextbox
              onChange={this.rollOnChange}
              name="vendorBatchNumber"
              value={pickTicketRollLineData.vendorBatchNumber}
              isMandatory={true}
              // disabled={true}
            ></InputTextbox>
          </Col>
        </Row>
        <Row>
          <Col sm="1">
            <FormLabel>
              {this.props.is3PL ? "Inventory#" : "RollSKU#"}
            </FormLabel>
          </Col>
          <Col sm="2">
            <InputTextbox
              onChange={this.rollOnChange}
              name="rollSkuNumber"
              value={pickTicketRollLineData.rollSkuNumber}
              isMandatory={true}
              //disabled={true}
            ></InputTextbox>
          </Col>

          <Col sm="1">
            <Button
              className=""
              id="fabric_Add_Button"
              size="sm"
              onClick={(e) => this.findRollsOnClick(e)}
            >
              FindRolls
            </Button>
          </Col>
          <Col sm="1">
            <Button
              className=""
              id="fabric_Add_Button"
              size="sm"
              onClick={(e) => this.clearRolls(e)}
            >
              Clear
            </Button>
          </Col>

          <Col sm="1">
            <Button
              size="sm"
              id="fabric_Add_Button"
              onClick={(e) => this.selectAllRoll(e)}
            >
              SelectAll
            </Button>
          </Col>
          <Col sm="1">
            <Button
              size="sm"
              id="fabric_Add_Button"
              onClick={(e) => this.unSelectAllRoll(e)}
            >
              UnSelectAll
            </Button>
          </Col>
        </Row>
        <Row>
          {/* <EditableDataGrid
            customStyles={dataTableStyles}
            columnsList={this.rollColumnDefinitions()}
            dataList={rollList}
          /> */}
          <CustomTable
            columns={this.rollColumns()}
            data={rollList}
            label={"Roll Lines"}
          />
        </Row>
      </div>
    );
  }
}
class PickTicketEntryForm extends React.Component {
  static contextType = AppContext;

  constructor(props) {
    super(props);

    this.itemCodeRef = React.createRef();
    this.customerCodeRef = React.createRef();
    this.paymentDialogRef = React.createRef();
    this.paymentTermCodeRef = React.createRef();
    this.discountPercentageRef = React.createRef();
    this.locationCodeRef = React.createRef();
    this.itemShortNameRef = React.createRef();

    this.state = {
      pickTicketData: this.props.pickTicketData,
      customerData: this.props.customerData,
      isPickTicketLineAddOpen: false,
      pickTicketLineData: new PickTicketLineBean(),
      isItemDataLoding: false,
      itemList: [],
      isCustomerDataLoding: false,
      customerList: [],
      isLineEditMode: false,
      customerData: new CustomerBean(),
      orderTypes: this.props.orderTypes,
      paymentTerms: this.props.paymentTerms,
      warehouses: this.props.warehouses,
      selected_item_data: new FabricStyleBean(),
      open: false,
      // isShowSalesModule: false,
      // moduleForPopup: [],
    };
  }

  componentDidMount() {
    const { appData } = this.context;
    this.companyCode = appData.companyCode;
    let locationLookupHandler = new GenericAttributeLookupHandler(
      this.props.locations,
      "Location"
    );
    this.setState({ locationLookupHandler: locationLookupHandler });
  }
  componentDidUpdate() {
    this.setInputFocus();
  }
  onPickTicketLineTableChange = (e, line) => {
    this.props.onPickTicketLineTableChange(e, line);
  };
  onHeaderAmountsChange = (e) => {
    this.props.onHeaderAmountsChange(e);
  };
  onChange = (e) => {
    this.props.onChange(e);
  };
  onLineAmountsChange = (e) => {
    this.props.onLineAmountsChange(e);
  };
  getLineDetails = (invocieLinedata) => {
    this.props.getLineDetails(invocieLinedata);
  };
  clearItemCodeRef = () => {
    this.itemCodeRef.current.clearValue();
  };
  focusCustomerCode = () => {
    this.customerCodeRef.current.focus();
  };
  setInputFocus() {
    if (this.props.isFocus == true) {
      this.customerCodeRef.current.focus();
    }
  }
  lnkLineDetailsClick = (e, rowData) => {
    if (e.detail === 1) this.props.lnkLineDetailsClick(rowData);
  };
  pickedQtyHandler = (e, rowData) => {
    if (e.detail === 1) this.props.pickedQtyHandler(rowData);
  };
  palletLnHandler = (e, rowData) => {
    if (e.detail === 1) this.props.palletLnHandler(rowData);
  };
  inputChangeCallback = (e, rowData) => {
    this.onPickTicketLineTableChange(e, rowData);
  };
  buttonClickCallback = (e, rowData) => {
    this.cancelPickTicketLine(rowData);
  };
  editPriceClickCallback = (e, rowData) => {
    this.editLinePrice(rowData);
  };

  toPickTicketState = (pickTicketdata) => {
    let orderState = "Open";

    if (pickTicketdata == null) return orderState;
    if (
      pickTicketdata.orderStatus == LogicConstants.SALES_ORDER_APPROVE_STATUS ||
      pickTicketdata.orderStatus == LogicConstants.SALES_ORDER_UNAPPROVE_STATUS
    ) {
      orderState = "Open";
    } else if (
      pickTicketdata.orderStatus == LogicConstants.SALES_ORDER_PICKED_STATUS
    ) {
      orderState = "In Pick";
    } else if (
      pickTicketdata.orderStatus ==
      LogicConstants.SALES_ORDER_PARTIALLY_PICKED_STATUS
    ) {
      orderState = "In Pick";
    } else if (
      pickTicketdata.orderStatus == LogicConstants.SALES_ORDER_CANCEL_STATUS
    ) {
      orderState = "Cancelled";
    }
    return orderState;
  };
  isModifyPosible = () => {
    return this.props.isModifyPosible();
  };

  // onPopupModalExit = () => {
  //   this.closesubModalCallBack(false);
  // };

  // lnkSalesModule = () => {
  //   let pickTicketData = this.props.pickTicketData;
  //   let code = pickTicketData.salesOrderNumber;
  //   if (code !== "" && code !== undefined) {
  //     this.setState({
  //       isShowSalesModule: true,
  //       moduleForPopup: (
  //         <PopupSalesModule code={code} onModuleExit={this.onPopupModalExit} />
  //       ),
  //     });
  //   }
  // };
  // closesubModalCallBack = (isOpen) => {
  //   this.setState({ isShowSalesModule: isOpen, moduleForPopup: [] });
  // };
  openPackerPopup = (e) => {
    if (e.detail === 1) this.props.openPackerPopup();
  };
  openShipperPopup = (e) => {
    if (e.detail === 1) this.props.openShipperPopup();
  };
  locationCodeOnChange = (e) => {
    this.props.locationCodeOnChange(e);
  };
  locationEnterKeyEventHandler = (e) => {
    this.props.locationEnterKeyEventHandler(e);
  };
  displayAutoCompleteLocationList = () => {
    this.props.displayAutoCompleteLocationList();
  };
  render() {
    let pickTicketdata = new PickTicketBean();
    let customerData = this.state.customerData;
    let orderState = this.toPickTicketState(pickTicketdata);
    let customerList = this.props.customerList;
    if (customerList == null) {
      customerList = [];
    }
    let isModify = this.props.isModifyPosible;
    let disablePickTicketFormFields = this.props.isDisabledFields;
    let disableUpdatableFields = false;
    if (!this.props.isViewMode) {
      if (disablePickTicketFormFields) {
        if (isModify) {
          disableUpdatableFields = false;
        } else {
          disableUpdatableFields = true;
        }
      }
    } else {
      disableUpdatableFields = true;
    }

    pickTicketdata = this.props.pickTicketData;
    let lines = [];

    let address = new AddressBean();
    if (pickTicketdata != null) {
      // address = pickTicketdata.address;
      // if (address == null) {
      //   address = new AddressBean();
      // }
      if (!isEmptyArray(pickTicketdata.pickTicketLines)) {
        pickTicketdata.pickTicketLines.map((line) => {
          lines.push(line);
        });
        lines.reverse();
      }
    }

    let isReadOnlyOrDisable = this.props.isReadOnlyOrDisabled;

    let status = ModuleUtils.getPickTicketStatusCaption(pickTicketdata.status);
    let isDisabledFields = this.props.isDisabledFields;
    const is3PL = this.props.is3PL;
    return (
      <div>
        <div className="header_div col-md-12 col-lg-12">
          <div className="">
            <Row>
              <Col className="align-items-left" sm="1">
                <FormLabel>Date</FormLabel>
              </Col>

              <Col sm="2">
                <DatePickerComponent
                  name="createdDate"
                  value={pickTicketdata.createdDate}
                  onChange={this.onChange}
                  disabled={true}
                />
              </Col>
              <Col className="align-items-left" sm="1">
                <FormLabel>Customer</FormLabel>{" "}
              </Col>

              <Col sm="2">
                <InputTextbox
                  ref={this.customerCodeRef}
                  name="customerCode"
                  type="text"
                  onChange={this.onChange}
                  readOnly={true}
                  value={pickTicketdata.customerCode}
                  disabled={isDisabledFields}
                  isMandatory={true}
                />{" "}
              </Col>

              <Col sm="3">
                <InputTextbox
                  name="customerName"
                  type="text"
                  onChange={this.onChange}
                  readOnly={true}
                  value={pickTicketdata.customerName}
                  disabled={isDisabledFields}
                />{" "}
              </Col>

              <Col className="align-items-left" sm="1">
                <FormLabel>PO#</FormLabel>
              </Col>

              <Col sm="2">
                <InputTextbox
                  name="customerPurchaseOrderNumber"
                  onChange={this.onChange}
                  readOnly={true}
                  value={pickTicketdata.customerPurchaseOrderNumber}
                  disabled={isDisabledFields}
                />
              </Col>
            </Row>
          </div>

          <Row>
            <Col className="so-align-items-left" sm="1">
              <FormLabel
                className="hyperlinklabel"
                onClick={(e) => this.props.lnkSalesModule(e)}
              >
                SO#
              </FormLabel>
            </Col>
            <Col sm="2">
              <InputTextbox
                name="salesOrderNumber"
                onChange={this.onChange}
                readOnly={true}
                value={pickTicketdata.salesOrderNumber}
                disabled={isDisabledFields}
                isMandatory={true}
              />{" "}
            </Col>
            {/* <Col className="align-items-left" sm="1">
              <FormLabel>SalesOrder# </FormLabel>{" "}
            </Col>
            <Col sm="2">
              <InputTextbox
                name="salesOrderNumber"
                placeholder="SalesOrderNumber"
                onChange={this.onChange}
                readOnly={true}
                value={pickTicketdata.salesOrderNumber}
              />{" "}
            </Col>*/}
            <Col className="align-items-left" sm="1">
              <FormLabel>PickedUpBy </FormLabel>{" "}
            </Col>
            <Col sm="2">
              <InputTextbox
                name="pickedUpBy"
                placeholder="PickedUpBy"
                onChange={this.onChange}
                value={pickTicketdata.pickedUpBy}
                disabled={isDisabledFields}
              />{" "}
            </Col>
            <Col className="align-items-left" sm="1">
              <FormLabel>PickedUpDate</FormLabel>
            </Col>

            <Col sm="2">
              <DatePickerComponent
                name="pickedUpDate"
                value={pickTicketdata.pickedUpDate}
                onChange={this.onChange}
                disabled={isDisabledFields}
              />
            </Col>
            <Col className="align-items-left" sm="1">
              <FormLabel>billOfLading</FormLabel>
            </Col>

            <Col sm="2">
              <InputTextbox
                onChange={this.onChange}
                name="billOfLading"
                value={pickTicketdata.billOfLading}
                disabled={isDisabledFields}
              ></InputTextbox>
            </Col>
          </Row>
          <Row>
            <Col sm="1">
              {" "}
              <FormLabel>BusinessDivision</FormLabel>
            </Col>
            <Col sm="1">
              <InputTextbox
                name="businessDivision"
                value={pickTicketdata.businessDivision}
                disabled={true}
              />
            </Col>
            <Col sm="1">
              <FormLabel>Preffered Location</FormLabel>
            </Col>
            <Col sm="1">
              <InputTextbox
                ref={this.locationCodeRef}
                name="prefferedLocationCode"
                onChange={this.locationCodeOnChange}
                value={pickTicketdata.prefferedLocationCode}
                lookupRequired={true}
                lookupHandler={this.state.locationLookupHandler}
                enterKeyEventHandler={this.locationEnterKeyEventHandler}
                autoCompleteListData={
                  this.props.locationPageListForAutoCompleteList
                }
                enableAutoCompleteTextBox={true}
                displayAutoCompleteList={this.displayAutoCompleteLocationList}
                showAutoCompleteList={this.props.showAutoCompleteLocationList}
                disabled={isDisabledFields}
              />
            </Col>

            <Col sm="1">
              <div>
                {is3PL && (
                  <FormLabel
                    className="hyperlinklabel "
                    onClick={(e) => this.openPackerPopup(e)}
                  >
                    Packed
                  </FormLabel>
                )}
                {!is3PL && <FormLabel>Packed</FormLabel>}
              </div>
            </Col>
            <Col sm="1">
              <div>
                <InputCheckbox
                  name="isPackedFlag"
                  type="checkbox"
                  checked={pickTicketdata.isPackedFlag}
                  onChange={this.onChange}
                  disabled={isDisabledFields}
                />
              </div>
            </Col>

            {/* </div>
            </Col> */}

            <Col sm="1">
              <div>
                {is3PL && (
                  <FormLabel
                    className="hyperlinklabel"
                    onClick={(e) => this.openShipperPopup(e)}
                  >
                    Shipped
                  </FormLabel>
                )}
                {!is3PL && <FormLabel>Shipped</FormLabel>}
              </div>
            </Col>
            <Col sm="1">
              <div>
                <InputCheckbox
                  name="isShippedFlag"
                  type="checkbox"
                  checked={pickTicketdata.isShippedFlag}
                  onChange={this.onChange}
                  disabled={disableUpdatableFields}
                />
              </div>
            </Col>
            {/* <Col className="align-items-left" sm="2">
              <div className="so_label_with_checkbox_div">
                {is3PL && (
                  <FormLabel
                    className="hyperlinklabel"
                    onClick={(e) => this.openShipperPopup(e)}
                  >
                    Shipped
                  </FormLabel>
                )}
                {!is3PL && <FormLabel>Shipped</FormLabel>}
                <div className="col-sm-2">
                  <InputCheckbox
                    name="isShippedFlag"
                    type="checkbox"
                    checked={pickTicketdata.isShippedFlag}
                    onChange={this.onChange}
                    disabled={disableUpdatableFields}
                  />
                </div>
              </div>
            </Col> */}
            <Col sm="1">
              <div>
                {is3PL && (
                  <FormLabel
                    className="hyperlinklabel"
                    onClick={(e) => this.openShipperPopup(e)}
                  >
                    Shipped
                  </FormLabel>
                )}
                {!is3PL && <FormLabel>Shipped</FormLabel>}
              </div>
            </Col>
            <Col sm="1">
              <div>
                <InputCheckbox
                  name="isShippedFlag"
                  type="checkbox"
                  checked={pickTicketdata.isShippedFlag}
                  onChange={this.onChange}
                  disabled={disableUpdatableFields}
                />
              </div>
            </Col>

            <Col sm="1">
              <div>
                <FormLabel>Close salesOrder</FormLabel>
              </div>
            </Col>
            <Col sm="1">
              <div>
                <InputCheckbox
                  name="closeSalesOrderFlagAfterInvoiceApproval"
                  type="checkbox"
                  checked={
                    pickTicketdata.closeSalesOrderFlagAfterInvoiceApproval
                  }
                  onChange={this.onChange}
                  disabled={isDisabledFields} //disabled={true}
                />
              </div>
            </Col>
            {/* 
            <Col className="align-items-left" sm="2">
              <div className="so_label_with_checkbox_div">
                <FormLabel>Close salesOrder</FormLabel>
                <div className="">
                  <InputCheckbox
                    name="closeSalesOrderFlagAfterInvoiceApproval"
                    type="checkbox"
                    checked={
                      pickTicketdata.closeSalesOrderFlagAfterInvoiceApproval
                    }
                    onChange={this.onChange}
                    disabled={isDisabledFields} //disabled={true}
                  />
                </div>
              </div>
            </Col> */}
            <Col sm="1">
              <div>
                <FormLabel>IsBackOrder</FormLabel>
              </div>
            </Col>
            <Col sm="1">
              <div>
                <InputCheckbox
                  name="isBackOrderFlag"
                  type="checkbox"
                  checked={pickTicketdata.isBackOrderFlag}
                  onChange={this.onChange}
                  disabled={true}
                />
              </div>
            </Col>
            {/* <Col className="align-items-left" sm="1">
              <div className="so_label_with_checkbox_div">
                <FormLabel>IsBackOrder</FormLabel>
                <div className="">
                  <InputCheckbox
                    name="isBackOrderFlag"
                    type="checkbox"
                    checked={pickTicketdata.isBackOrderFlag}
                    onChange={this.onChange}
                    disabled={true}
                  />
                </div>
              </div>
            </Col>
            <Col></Col> */}
            {pickTicketdata.isShippedFlag == true && (
              <Col className="align-items-left" sm="2">
                <InputTextbox
                  value="Shipped"
                  className="qty_input text-left summary_input"
                  disabled={true}
                ></InputTextbox>
              </Col>
            )}
          </Row>

          <div className="total_amounts_and_table_div col-md-12 col-lg-12">
            <Row>
              <Col sm="2" className="title_text_div">
                <FormLabel>PickTicket Lines</FormLabel>
              </Col>
              <Col sm="1"></Col>
            </Row>
            {/* <DataGrid
              columnsList={this.columnDefinitions()}
              dataList={lines}
              isLoading={false}
            /> */}

            <div className="div_Custom_2">
              <Table id="fabrics_tables_default">
                <thead>
                  <tr>
                    <th>Line#</th>
                    <th>Item#</th>
                    <th>Name</th>
                    <th>Color</th>
                    <th>UOM</th>
                    <th>Price</th>
                    <th>OrdQty</th>
                    <th>ToBePicked</th>
                    <th>TotalPicked</th>
                    <th>Picked[current]</th>
                  </tr>
                </thead>
                <tbody>
                  {lines.map((ln, index) => (
                    <tr key={index}>
                      <td>
                        <Button
                          size="sm"
                          variant="secondry"
                          className="hyperLinkText"
                          onClick={(e) => this.lnkLineDetailsClick(e, ln)}
                        >
                          {ln.pickTicketLineNumber}
                        </Button>
                      </td>
                      <td>{ln.fabricStyleCode}</td>
                      <td>{ln.fabricStyleName}</td>
                      <td>{ln.colorCode}</td>
                      <td>{ln.orderUomCode}</td>
                      <td>{ln.price}</td>
                      <td>{ln.orderQuantity}</td>
                      <td>{ln.toBePickedQuantity}</td>
                      {is3PL ? (
                        <td>
                          <Button
                            size="sm"
                            variant="secondry"
                            className="hyperLinkText"
                            onClick={(e) => this.pickedQtyHandler(e, ln)}
                          >
                            {ln.pickedQuantity}
                          </Button>
                        </td>
                      ) : (
                        <td>{ln.pickedQuantity}</td>
                      )}
                      <td>{ln.currentlyPickedQuantity}</td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </div>
          </div>
        </div>{" "}
      </div>
    );
  }
}

class ShippingInformationEntryForm extends React.Component {
  static contextType = AppContext;

  constructor(props) {
    super(props);

    this.itemCodeRef = React.createRef();
    this.customerCodeRef = React.createRef();
    this.paymentDialogRef = React.createRef();
    this.paymentTermCodeRef = React.createRef();
    this.discountPercentageRef = React.createRef();
    this.itemShortNameRef = React.createRef();
    this.shipToCodeRef = React.createRef();
    this.shipViaCodeRef = React.createRef();
    this.freightMethodCodeRef = React.createRef();
    this.cityRef = React.createRef();
    this.stateRef = React.createRef();
    this.countryRef = React.createRef();
    this.state = {};
  }

  componentDidMount() {
    const { appData } = this.context;
    this.companyCode = appData.companyCode;
    this.initLookupHandlers();
    this.setInputFocus();
  }

  componentDidUpdate() {
    //
  }
  initLookupHandlers = () => {
    let shipToLookupHandler = new GenericAttributeLookupHandler(
      this.props.shipTos,
      "ShipTo"
    );
    this.setState({ shipToLookupHandler: shipToLookupHandler });
    let shipViaLookupHandler = new GenericAttributeLookupHandler(
      this.props.shipVias,
      "ShipVia"
    );
    this.setState({ shipViaLookupHandler: shipViaLookupHandler });

    let logisticLookupHandler = new GenericAttributeLookupHandler(
      this.props.logisticMethods,
      "Logistic Method"
    );
    this.setState({ logisticLookupHandler: logisticLookupHandler });
    let freightMethodLookupHandler = new GenericAttributeLookupHandler(
      this.props.freightMethods,
      "FreightMethods"
    );
    this.setState({ freightMethodLookupHandler: freightMethodLookupHandler });
    let cityLookupHandler = new GenericAttributeLookupHandler(
      this.props.cityList,
      "City"
    );
    this.setState({ cityLookupHandler: cityLookupHandler });
    let stateLookupHandler = new GenericAttributeLookupHandler(
      this.props.stateList,
      "State"
    );
    this.setState({ stateLookupHandler: stateLookupHandler });
    let countryLookupHandler = new GenericAttributeLookupHandler(
      this.props.countryList,
      "Country"
    );
    this.setState({ countryLookupHandler: countryLookupHandler });
  };
  onChange = (e) => {
    this.props.onChange(e);
  };
  onShipToChange = (e) => {
    this.props.onShipToChange(e);
  };

  shipToEnterKeyEventHandler = (e) => {
    this.props.shipToEnterKeyEventHandler(e);
  };
  displayAutoCompleteShipToList = (showAutoCompleteList) => {
    this.props.displayAutoCompleteShipToList(showAutoCompleteList);
  };
  onLogisticMethodCodeChange = (e) => {
    this.props.onLogisticMethodCodeChange(e);
  };
  logisticEnterKeyEventHandler = (e) => {
    this.props.logisticEnterKeyEventHandler(e);
  };
  displayAutoCompleteLogisticList = (showAutoCompleteList) => {
    this.props.displayAutoCompleteLogisticList(showAutoCompleteList);
  };
  updateandFetchRates = (e) => {
    if (e.detail === 1) this.props.updateandFetchRates();
  };

  saveShipment = (e) => {
    if (e.detail === 1) this.props.saveShipment();
  };

  generateAllLabels = (e) => {
    if (e.detail === 1) this.props.generateAllLabels();
  };
  manualVoidShipment = (e) => {
    if (e.detail === 1) this.props.manualVoidShipment();
  };
  voidShipment = (e) => {
    if (e.detail === 1) this.props.voidShipment();
  };

  onShipToAddressChange = (e) => {
    this.props.onShipToAddressChange(e);
  };
  addNewBoxLine = (e) => {
    if (e.detail === 1) this.props.addNewBoxLine();
  };
  setInputFocus() {
    this.customerCodeRef.current.focus();
  }

  lnkBoxLineDetailsClick = (e, rowData) => {
    if (e.detail === 1) this.props.lnkBoxLineDetailsClick(rowData);
  };

  inputChangeCallback = (e, rowData) => {
    this.onPickTicketLineTableChange(e, rowData);
  };

  buttonClickCallback = (e, rowData) => {
    this.cancelPickTicketLine(rowData);
  };
  deleteBoxLine = (e, rowData) => {
    if (e.detail <= 1) this.props.deleteBoxLine(rowData);
  };
  printLabelBox = (e, rowData) => {
    if (e.detail === 1) this.props.printLabelBox(rowData);
  };
  isModifyPosible = () => {
    return this.props.isModifyPosible();
  };
  render() {
    let pickTicketData = new PickTicketBean();

    let customerList = this.props.customerList;
    if (customerList == null) {
      customerList = [];
    }
    let isModify = this.props.isModifyPosible;
    let disablePickTicketFormFields = this.props.isDisabledFields;
    let disableUpdatableFields = false;
    if (!this.props.isViewMode) {
      if (disablePickTicketFormFields) {
        if (isModify) {
          disableUpdatableFields = true;
        } else {
          disableUpdatableFields = true;
        }
      }
    } else {
      disableUpdatableFields = true;
    }

    pickTicketData = this.props.pickTicketData;
    let lines = [];
    let boxDetailLines = [];
    let isShipConfirmProcessCompletedFlag = false;
    let isSaveShipmentPosible = false;
    let address = new AddressBean();
    let shipToAddress = new AddressBean();
    if (pickTicketData != null) {
      if (this.props.addressData != null) {
        address = this.props.addressData;
      }
      // if (pickTicketData.address != null) {
      //   shipToAddress = pickTicketData.address;
      // }
      isShipConfirmProcessCompletedFlag =
        pickTicketData.shipConfirmProcessCompletedFlag;

      if (
        !isEmptyString(pickTicketData.shipmentCarrier) &&
        !isEmptyString(pickTicketData.ShipmentCarrierMethod)
      )
        isSaveShipmentPosible = true;
      // if (!isEmpty(pickTicketData.address)) {
      //   address = pickTicketData.address;
      // }
      if (!isEmpty(pickTicketData.shipToAddress)) {
        shipToAddress = pickTicketData.shipToAddress;
      }
      if (!isEmptyArray(pickTicketData.pickTicketLines)) {
        pickTicketData.pickTicketLines.map((line) => {
          lines.push(line);
        });
        lines.reverse();
      }
      if (!isEmptyArray(pickTicketData.boxDetails)) {
        pickTicketData.boxDetails.map((line) => {
          boxDetailLines.push(line);
        });
      }
    }

    let status = ModuleUtils.getPickTicketStatusCaption(pickTicketData.status);
    let is3PL = this.props.is3PL;
    const textAreaStyle = {
      maxHeight: "75px",
      minHeight: "9em",
      resize: "none",
      padding: "9px",
      boxSizing: "border-box",
      fontSize: "15px",
    };
    let isDisabledFields = this.props.isDisabledFields;
    return (
      <div>
        <div className="header_div col-md-12 col-lg-12">
          <div className="">
            <Row>
              <Col className="align-items-left" sm="1">
                <FormLabel>PickTicket#</FormLabel>
              </Col>

              <Col sm="2">
                <InputTextbox
                  name="code"
                  type="text"
                  onChange={this.onChange}
                  readOnly={true}
                  value={pickTicketData.code}
                  disabled={isDisabledFields}
                />{" "}
              </Col>
              <Col className="align-items-left" sm="1">
                <FormLabel>Customer</FormLabel>{" "}
              </Col>

              <Col sm="2">
                <InputTextbox
                  ref={this.customerCodeRef}
                  name="customerCode"
                  type="text"
                  onChange={this.onChange}
                  readOnly={true}
                  value={pickTicketData.customerCode}
                  disabled={isDisabledFields}
                />{" "}
              </Col>

              <Col sm="3">
                <InputTextbox
                  name="customerName"
                  type="text"
                  onChange={this.onChange}
                  readOnly={true}
                  value={pickTicketData.customerName}
                  disabled={isDisabledFields}
                />{" "}
              </Col>

              <Col className="align-items-left" sm="1">
                <FormLabel>PO#</FormLabel>
              </Col>

              <Col sm="2">
                <InputTextbox
                  name="customerPurchaseOrderNumber"
                  onChange={this.onChange}
                  readOnly={true}
                  value={pickTicketData.customerPurchaseOrderNumber}
                  disabled={isDisabledFields}
                />
              </Col>
            </Row>
          </div>

          <Row>
            <Col className="align-items-left" sm="1">
              <FormLabel>SalesOrder# </FormLabel>{" "}
            </Col>
            <Col sm="2">
              <InputTextbox
                name="salesOrderNumber"
                onChange={this.onChange}
                readOnly={true}
                value={pickTicketData.salesOrderNumber}
                disabled={isDisabledFields}
              />{" "}
            </Col>
            <Col className="align-items-left" sm="1">
              <FormLabel>Currency </FormLabel>{" "}
            </Col>
            <Col sm="2">
              <InputTextbox
                name="currencyCode"
                onChange={this.onChange}
                readOnly={true}
                value={pickTicketData.currencyCode}
                disabled={isDisabledFields}
                isMandatory={true}
              />{" "}
            </Col>
            <Col className="align-items-left" sm="1">
              <FormLabel>ShipmentCrg</FormLabel>
            </Col>

            <Col sm="2">
              <NumberFormatInputbox
                value={pickTicketData.shipmentCharges}
                onChange={this.onChange}
                className="text-right"
                decimalScale={2}
                name={"shipmentCharges"}
                disabled={isDisabledFields}
                isMandatory={true}
              />
            </Col>
            <Col className="align-items-left" sm="1">
              <FormLabel>Status</FormLabel>
            </Col>

            <Col sm="2">
              <InputTextbox
                onChange={this.onChange}
                name="status"
                value={status}
                disabled={true}
              ></InputTextbox>
            </Col>
          </Row>

          <Row>
            <Col className="align-items-left" sm="1">
              <FormLabel>Shipment Carrier</FormLabel>{" "}
            </Col>
            <Col sm="2">
              <InputTextbox
                name="shipmentCarrier"
                placeholder="ShipmentCarrier"
                onChange={this.onChange}
                // readOnly={disableUpdatableFields}
                value={pickTicketData.shipmentCarrier}
                disabled={disableUpdatableFields}
              />{" "}
            </Col>
            <Col className="align-items-left" sm="1">
              <FormLabel>ServiceCode </FormLabel>{" "}
            </Col>
            <Col sm="2">
              <InputTextbox
                name="shipmentCarrierMethod"
                placeholder="ServiceCode"
                onChange={this.onChange}
                // readOnly={disableUpdatableFields}
                value={pickTicketData.shipmentCarrierMethod}
                disabled={disableUpdatableFields}
              />{" "}
            </Col>

            <Col className="align-items-left" sm="1">
              <FormLabel>ServiceName</FormLabel>
            </Col>

            <Col sm="2">
              <InputTextbox
                name="shipmentCarrierMethodName"
                placeholder="ServiceName"
                onChange={this.onChange}
                // readOnly={disableUpdatableFields}
                value={pickTicketData.shipmentCarrierMethodName}
                disabled={disableUpdatableFields}
              />{" "}
            </Col>
            <Col className="align-items-left" sm="1">
              <FormLabel>CarrierCharges</FormLabel>
            </Col>

            <Col sm="2">
              <NumberFormatInputbox
                value={pickTicketData.totalCarrierShipmentCharges}
                onChange={this.onChange}
                className="text-right"
                decimalScale={2}
                name={"totalCarrierShipmentCharges"}
                disabled={disableUpdatableFields}
              />
            </Col>
          </Row>

          <div className="pickticket_shipment_main_div">
            <div className="pickticket_shipment_details_div">
              <Row>
                <Col sm="3" className="title_text_div">
                  <FormLabel className="label_head">ShippingDetails</FormLabel>
                </Col>
              </Row>
              <Row>
                <Col sm="4">
                  <FormLabel>ShipVia</FormLabel>
                </Col>
                <Col sm="8">
                  {/* <InputTextbox
                    name="shipViaCode"
                    placeholder="ShipVia"
                    onChange={this.onChange}
                    readOnly={disablePickTicketFormFields}
                    value={pickTicketData.shipViaCode}
                    disabled={isDisabledFields}
                  />{" "} */}
                  <InputTextbox
                    ref={this.shipViaCodeRef}
                    name="shipViaCode"
                    placeholder="shipViaCode"
                    onChange={this.props.onShipViaChange}
                    // readOnly={disablePickTicketFormFields}
                    value={pickTicketData.shipViaCode}
                    lookupRequired={true}
                    lookupHandler={this.state.shipViaLookupHandler}
                    enterKeyEventHandler={
                      this.props.shipViaEnterKeyEventHandler
                    }
                    autoCompleteListData={
                      this.props.shipViaPageListForAutoCompleteList
                    }
                    enableAutoCompleteTextBox={true}
                    displayAutoCompleteList={
                      this.props.displayAutoCompleteShipViaList
                    }
                    showAutoCompleteList={
                      this.props.showAutoCompleteShipViaList
                    }
                    isMandatory={true}
                    disabled={disableUpdatableFields}
                  />
                </Col>
              </Row>
              <Row>
                <Col className="align-items-left" sm="4">
                  <FormLabel>Fr.Method </FormLabel>{" "}
                </Col>
                <Col sm="8">
                  <InputTextbox
                    ref={this.freightMethodCodeRef}
                    name="freightMethodCode"
                    placeholder="freightMethodCode"
                    onChange={this.props.onFreightMethodChange}
                    // readOnly={disablePickTicketFormFields}
                    value={pickTicketData.freightMethodCode}
                    lookupRequired={true}
                    lookupHandler={this.state.freightMethodLookupHandler}
                    enterKeyEventHandler={
                      this.props.freightMethodEnterKeyEventHandler
                    }
                    autoCompleteListData={
                      this.props.freightMethodPageListForAutoCompleteList
                    }
                    enableAutoCompleteTextBox={true}
                    displayAutoCompleteList={
                      this.props.displayAutoCompleteFreightMethodList
                    }
                    showAutoCompleteList={
                      this.props.showAutoCompleteFreightMethodList
                    }
                    disabled={disableUpdatableFields}
                  />
                </Col>
              </Row>
              <Row>
                <Col sm="4">
                  <FormLabel>ShipTo</FormLabel>
                </Col>
                <Col sm="8">
                  <InputTextbox
                    ref={this.shipToCodeRef}
                    name="shipToCode"
                    placeholder="ShipToCode"
                    onChange={this.onShipToChange}
                    readOnly={disablePickTicketFormFields}
                    value={pickTicketData.shipToCode}
                    lookupRequired={true}
                    lookupHandler={this.state.shipToLookupHandler}
                    enterKeyEventHandler={this.shipToEnterKeyEventHandler}
                    autoCompleteListData={
                      this.props.shipToPageListForAutoCompleteList
                    }
                    enableAutoCompleteTextBox={true}
                    displayAutoCompleteList={this.displayAutoCompleteShipToList}
                    showAutoCompleteList={this.props.showAutoCompleteShipToList}
                    disabled={disableUpdatableFields}
                    isMandatory={true}
                  />
                </Col>{" "}
              </Row>
              <Row>
                <Col sm="4">
                  <FormLabel>ShipToName</FormLabel>
                </Col>
                <Col sm="8">
                  <InputTextbox
                    name="shipToName"
                    placeholder="ShipToName"
                    onChange={this.onChange}
                    readOnly={disablePickTicketFormFields}
                    value={pickTicketData.shipToName}
                    disabled={isDisabledFields}
                    isMandatory={true}
                  />{" "}
                </Col>
              </Row>
            </div>
            <div className="pickticket_shipment_carrier_detail_div">
              <Row>
                <Col sm="12" className="title_text_div">
                  <FormLabel className="label_head">CarrierDetails</FormLabel>
                </Col>
              </Row>
              <Row>
                <Col sm="12">
                  <textarea
                    style={textAreaStyle}
                    className="form-control"
                    name="carrierDetails"
                    type="text"
                    placeholder="CarrierDetails"
                    onChange={this.onChange}
                    value={pickTicketData.carrierDetails}
                    disabled={isDisabledFields}
                  />
                </Col>
              </Row>
            </div>
            <div className="pickticket_shipment_shipping_instructions_div">
              <Row>
                <Col sm="12" className="title_text_div">
                  <FormLabel className="label_head">
                    ShippingInstructions
                  </FormLabel>
                </Col>
              </Row>
              <Row>
                <Col sm="12">
                  <textarea
                    style={textAreaStyle}
                    className="form-control"
                    name="shipmentInstructions"
                    type="text"
                    placeholder="ShipmentInstructions"
                    onChange={this.onChange}
                    value={pickTicketData.shipmentInstructions}
                    disabled={isDisabledFields}
                  />
                </Col>
              </Row>
            </div>
            <div className="pickticket_shipment_cus_shipment_account_div">
              <Row>
                <Col sm="12" className="title_text_div">
                  <FormLabel className="label_head">
                    Shipment AccDetail
                  </FormLabel>
                </Col>
              </Row>
              <Row>
                <Col sm="4">
                  <FormLabel>Acc#</FormLabel>
                </Col>
                <Col sm="8">
                  <InputTextbox
                    name="customerShippingAccountNumber"
                    placeholder="CustomerShippingAccountNumber"
                    onChange={this.onChange}
                    readOnly={disablePickTicketFormFields}
                    value={pickTicketData.customerShippingAccountNumber}
                    disabled={isDisabledFields}
                  />{" "}
                </Col>
              </Row>
              <Row>
                <Col sm="4">
                  <FormLabel>Country</FormLabel>
                </Col>
                <Col sm="8">
                  <InputTextbox
                    name="customerShippingAccountCountryCode"
                    placeholder="CustomerShippingAccountCountryCode"
                    onChange={this.onChange}
                    readOnly={disablePickTicketFormFields}
                    value={pickTicketData.customerShippingAccountCountryCode}
                    disabled={isDisabledFields}
                  />{" "}
                </Col>
              </Row>
              <Row>
                <Col sm="4">
                  <FormLabel>ZIP</FormLabel>
                </Col>
                <Col sm="8">
                  <InputTextbox
                    name="customerShippingAccountPostalCode"
                    placeholder="CustomerShippingAccountPostalCode"
                    onChange={this.onChange}
                    readOnly={disablePickTicketFormFields}
                    value={pickTicketData.customerShippingAccountPostalCode}
                    disabled={isDisabledFields}
                  />{" "}
                </Col>
              </Row>
            </div>
            <div className="pickticket_shipment_buttons_div">
              {!isShipConfirmProcessCompletedFlag && (
                <div>
                  <Button
                    className="header_buttons"
                    size="md"
                    onClick={(e) => this.updateandFetchRates(e)}
                    disabled={disablePickTicketFormFields}
                  >
                    Save & Rates
                  </Button>
                </div>
              )}
              {isSaveShipmentPosible && (
                <div>
                  <Button
                    className="header_buttons"
                    size="md"
                    onClick={(e) => this.saveShipment(e)}
                    disabled={disablePickTicketFormFields}
                  >
                    Save & Ship
                  </Button>
                </div>
              )}
              {isShipConfirmProcessCompletedFlag && (
                <div>
                  <div>
                    <Button
                      className="header_buttons"
                      size="md"
                      onClick={(e) => this.generateAllLabels(e)}
                    >
                      PrintLabels
                    </Button>
                  </div>
                  <div>
                    <Button
                      className="header_buttons"
                      size="md"
                      onClick={(e) => this.manualVoidShipment(e)}
                    >
                      ManualVoid
                    </Button>
                  </div>
                  <div>
                    <Button
                      className="header_buttons"
                      size="md"
                      onClick={(e) => this.voidShipment(e)}
                    >
                      Void
                    </Button>
                  </div>
                </div>
              )}
            </div>
          </div>

          <Row>
            <Col sm="1">
              <FormLabel>Address1</FormLabel>
            </Col>
            <Col sm="2">
              <InputTextbox
                name="address1"
                placeholder="Address1"
                onChange={this.onShipToAddressChange}
                readOnly={disablePickTicketFormFields}
                value={shipToAddress.address1}
                disabled={isDisabledFields}
              />{" "}
            </Col>
            <Col sm="1">
              <FormLabel>Address2</FormLabel>
            </Col>
            <Col sm="2">
              <InputTextbox
                name="address2"
                placeholder="Address2"
                onChange={this.onShipToAddressChange}
                readOnly={disablePickTicketFormFields}
                value={shipToAddress.address2}
                disabled={isDisabledFields}
              />{" "}
            </Col>
            <Col sm="1">
              <FormLabel>City</FormLabel>
            </Col>
            <Col sm="2">
              <InputTextbox
                onChange={this.props.onCityChange}
                ref={this.cityRef}
                name="city"
                placeholder="city"
                value={shipToAddress.city}
                lookupRequired={true}
                lookupHandler={this.state.cityLookupHandler}
                enterKeyEventHandler={this.props.cityEnterKeyEventHandler}
                autoCompleteListData={
                  this.props.cityPageListForAutoCompleteList
                }
                enableAutoCompleteTextBox={true}
                displayAutoCompleteList={this.props.displayAutoCompleteCityList}
                showAutoCompleteList={this.props.showAutoCompleteCityList}
                disabled={disablePickTicketFormFields}
                // isModifyView={isModify}
              ></InputTextbox>
            </Col>
            <Col sm="1">
              <FormLabel>State</FormLabel>
            </Col>
            <Col sm="2">
              <InputTextbox
                onChange={this.props.onStateChange}
                ref={this.stateRef}
                name="state"
                placeholder="state"
                value={shipToAddress.state}
                lookupRequired={true}
                lookupHandler={this.state.stateLookupHandler}
                enterKeyEventHandler={this.props.stateEnterKeyEventHandler}
                autoCompleteListData={
                  this.props.statePageListForAutoCompleteList
                }
                enableAutoCompleteTextBox={true}
                displayAutoCompleteList={
                  this.props.displayAutoCompleteStateList
                }
                showAutoCompleteList={this.props.showAutoCompleteStateList}
                disabled={disablePickTicketFormFields}
                // isModifyView={isModify}
              ></InputTextbox>
            </Col>
          </Row>
          <Row>
            <Col sm="1">
              <FormLabel>Country</FormLabel>
            </Col>
            <Col sm="2">
              <InputTextbox
                onChange={this.props.onCountryChange}
                ref={this.countryRef}
                name="country"
                placeholder="country"
                value={shipToAddress.country}
                lookupRequired={true}
                lookupHandler={this.state.countryLookupHandler}
                enterKeyEventHandler={this.props.countryEnterKeyEventHandler}
                autoCompleteListData={
                  this.props.countryPageListForAutoCompleteList
                }
                enableAutoCompleteTextBox={true}
                displayAutoCompleteList={
                  this.props.displayAutoCompleteCountryList
                }
                showAutoCompleteList={this.props.showAutoCompleteCountryList}
                disabled={disablePickTicketFormFields}
                // isModifyView={isModify}
              ></InputTextbox>
            </Col>
            <Col sm="1">
              <FormLabel>Zip</FormLabel>
            </Col>
            <Col sm="2">
              <InputTextbox
                name="zip"
                placeholder="Zip"
                onChange={this.onShipToAddressChange}
                readOnly={disablePickTicketFormFields}
                value={shipToAddress.zip}
                disabled={isDisabledFields}
              />{" "}
            </Col>
            <Col sm="1">
              <FormLabel>Phone1#</FormLabel>
            </Col>
            <Col sm="2">
              <InputTextbox
                name="phone1"
                placeholder="Phone1"
                onChange={this.onShipToAddressChange}
                readOnly={disablePickTicketFormFields}
                value={shipToAddress.phone1}
                disabled={isDisabledFields}
              />{" "}
            </Col>
            <Col sm="1">
              <FormLabel>Phone2#</FormLabel>
            </Col>
            <Col sm="2">
              <InputTextbox
                name="phone2"
                placeholder="Phone2"
                onChange={this.onShipToAddressChange}
                readOnly={disablePickTicketFormFields}
                value={shipToAddress.phone2}
                disabled={isDisabledFields}
              />{" "}
            </Col>
          </Row>
          <Row>
            <Col sm="1">
              <FormLabel>Mobile#</FormLabel>
            </Col>
            <Col sm="2">
              <InputTextbox
                name="mobilePhone"
                placeholder="Mobile"
                onChange={this.onShipToAddressChange}
                readOnly={disablePickTicketFormFields}
                value={shipToAddress.mobilePhone}
                disabled={isDisabledFields}
              />{" "}
            </Col>
            <Col sm="1">
              <FormLabel>EMail</FormLabel>
            </Col>
            <Col sm="2">
              <InputTextbox
                name="email"
                placeholder="EMail"
                onChange={this.onShipToAddressChange}
                readOnly={disablePickTicketFormFields}
                value={shipToAddress.email}
                disabled={isDisabledFields}
              />{" "}
            </Col>
            <Col sm="1">
              <FormLabel>Website</FormLabel>
            </Col>
            <Col sm="2">
              <InputTextbox
                name="website"
                placeholder="Website"
                onChange={this.onShipToAddressChange}
                readOnly={disablePickTicketFormFields}
                value={shipToAddress.website}
                disabled={isDisabledFields}
              />{" "}
            </Col>
            <Col sm="1">
              <FormLabel>Logistic Method</FormLabel>
            </Col>
            <Col sm="2">
              <InputTextbox
                name="logisticMethodCode"
                placeholder="logisticMethodCode"
                onChange={this.onLogisticMethodCodeChange}
                readOnly={disablePickTicketFormFields}
                value={pickTicketData.logisticMethodCode}
                lookupRequired={true}
                lookupHandler={this.state.logisticLookupHandler}
                enterKeyEventHandler={this.logisticEnterKeyEventHandler}
                autoCompleteListData={
                  this.props.logisticPageListForAutoCompleteList
                }
                enableAutoCompleteTextBox={true}
                displayAutoCompleteList={this.displayAutoCompleteLogisticList}
                showAutoCompleteList={this.props.showAutoCompleteLogisticList}
                disabled={disableUpdatableFields}
                isMandatory={true}
              ></InputTextbox>
            </Col>
          </Row>

          <div className="total_amounts_and_table_div col-md-12 col-lg-12">
            <Row>
              <Col sm="1" className="title_text_div">
                {is3PL ? (
                  <FormLabel className="table_title">Pallet Details</FormLabel>
                ) : (
                  <FormLabel className="table_title">Box Details</FormLabel>
                )}
              </Col>

              {/* <Col sm="1">
                <Button
                  size="sm"
                  onClick={() => this.addNewBoxLine()}
                  disabled={disablePickTicketFormFields}
                >
                  <AddIcon />
                </Button>
              </Col> */}
            </Row>

            <Table id="fabrics_tables_default">
              <thead>
                <tr>
                  <th>
                    <Button
                      size="sm"
                      id="fabric_Add_Button"
                      onClick={(e) => this.addNewBoxLine(e)}
                      disabled={disablePickTicketFormFields}
                    >
                      <AddIcon />
                    </Button>
                  </th>
                  <th>Line#</th>
                  <th>Box#</th>
                  <th>Weight</th>
                  <th>Length</th>
                  <th>Width</th>
                  <th>COD</th>
                  <th>Declared</th>
                  <th>ShipCharges</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {boxDetailLines.map(
                  (bx, i) =>
                    bx.isDeleted != true && (
                      <tr key={i} data-item={bx}>
                        <td>
                          <Button
                            size="sm"
                            variant="primary"
                            onClick={(e) => this.printLabelBox(e, bx)}
                          >
                            PrintLabel
                          </Button>
                        </td>
                        <td>
                          <Button
                            size="sm"
                            variant="secondry"
                            className="hyperLinkText"
                            onClick={(e) => this.lnkBoxLineDetailsClick(e, bx)}
                          >
                            {bx.boxLineNumber}
                          </Button>
                        </td>
                        <td>{bx.boxNumber}</td>
                        <td>{bx.weightInLbs}</td>
                        <td>{bx.lengthInInces}</td>
                        <td>{bx.widthInInces}</td>
                        <td>{bx.codValue}</td>
                        <td>{bx.declaredValue}</td>
                        <td>{bx.shipmentCharges}</td>
                        <td>
                          <button
                            id="fabric_Add_Button"
                            className="enterFocus"
                            size="sm1"
                            bssize="large"
                            onClick={(e) => this.deleteBoxLine(e, bx)}
                          >
                            <DeleteIcon />
                          </button>
                        </td>
                      </tr>
                    )
                )}
              </tbody>
            </Table>
          </div>
        </div>{" "}
      </div>
    );
  }
}
class InvoicesForm extends React.Component {
  static contextType = AppContext;

  constructor(props) {
    super(props);
    this.state = {
      isShowInvoiceModule: false,
    };
  }
  onChange = (e) => {
    this.props.onChange(e);
  };
  onPopupModalExit = () => {
    this.closeModalCallBack(false);
  };
  closeModalCallBack = (isOpen) => {
    this.setState({ isShowInvoiceModule: isOpen, moduleForPopup: [] });
  };
  viewInvoiceModule = (e, code, rowData) => {
    if (e.detail === 1) {
      if (code !== "" && code !== undefined) {
        this.setState({
          isShowInvoiceModule: true,
          moduleForPopup: (
            <PopupInvoiceModule
              invoiceCode={code}
              onModuleExit={this.onPopupModalExit}
            />
          ),
        });
      }
    }
  };
  // invColumnDefinitions = () => {
  //   let columnList = [];

  //   columnList.push(
  //     new BootstrapDataGridColumnDefinition()
  //       .setDetails("Invoice#", "code")
  //       .setColumnType("hyperLink")
  //       .callHyperLinkCallback(this.viewInvoiceModule)
  //       .setSortColumn(true)
  //   );
  //   columnList.push(
  //     new BootstrapDataGridColumnDefinition()
  //       .setDetails("Date", "createdDate")
  //       .setSortColumn(true)
  //   );
  //   columnList.push(
  //     new BootstrapDataGridColumnDefinition()
  //       .setDetails("Status", "invoiceStatus")
  //       .setColumnType("statusColumn")
  //       .setStatusCaptionConverter(ModuleUtils.getInvoiceStatusCaption)
  //       .setSortColumn(true)
  //   );
  //   return columnList;
  // };

  render() {
    let pickTicketData = new PickTicketBean();
    pickTicketData = this.props.pickTicketData;

    let dependenciesBean = new PickTicketModuleDependenciesBean();
    dependenciesBean = this.props.dependenciesBean;

    let invList = [];
    if (!isEmpty(dependenciesBean) && !isEmptyArray(dependenciesBean.invoices))
      invList = dependenciesBean.invoices;

    return (
      <div className="header_div">
        <div className="div_Custom_1">
          <Table id="fabrics_tables_default">
            <thead>
              <tr>
                <th>Invoice</th>
                <th>Date</th>
                <th>Status</th>
              </tr>
            </thead>
            {invList != null ? (
              <tbody>
                {invList.map((ln, index) => (
                  <tr key={index}>
                    <td className="text-right">
                      {" "}
                      <Button
                        size="sm"
                        variant="secondry"
                        className="hyperLinkText"
                        onClick={(e) => this.viewInvoiceModule(e, ln.code)}
                      >
                        {ln.code}
                      </Button>
                    </td>
                    <td className="text-right">{ln.createdDate}</td>
                    <td className="text-right">
                      {ModuleUtils.getInvoiceStatusCaption(ln.invoiceStatus)}
                    </td>
                  </tr>
                ))}
              </tbody>
            ) : null}
          </Table>
          {invList.length != 0 ? null : (
            <div className="no_Data">{"NO DATA"}</div>
          )}
        </div>
        <MultiViewPopup
          popupLvlClass={"popupSizeLeve2"}
          isModulePopup={true}
          id="modulePopup"
          isShowPopup={this.state.isShowInvoiceModule}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
          lockScroll={true}
        ></MultiViewPopup>
      </div>
    );
  }
}
class ChangesHistoryForm extends React.Component {
  static contextType = AppContext;

  constructor(props) {
    super(props);
  }
  onChange = (e) => {
    this.props.onChange(e);
  };
  // statusTrackColumnDefinitions = () => {
  //   let columnList = [];

  //   columnList.push(
  //     new BootstrapDataGridColumnDefinition()
  //       .setDetails("Date", "createdDate")
  //       .setSortColumn(true)
  //   );
  //   columnList.push(
  //     new BootstrapDataGridColumnDefinition()
  //       .setDetails("Amount", "totalOrderAmount")
  //       .setSortColumn(true)
  //   );

  //   columnList.push(
  //     new BootstrapDataGridColumnDefinition()
  //       .setDetails("Status", "currentStatus")
  //       .setColumnType("statusColumn")
  //       .setStatusCaptionConverter(ModuleUtils.getPickTicketStatusCaption)
  //       .setSortColumn(true)
  //   );
  //   columnList.push(
  //     new BootstrapDataGridColumnDefinition()
  //       .setDetails("Pre Status", "previousStatus")
  //       .setColumnType("statusColumn")
  //       .setStatusCaptionConverter(ModuleUtils.getPickTicketStatusCaption)
  //       .setSortColumn(true)
  //   );

  //   return columnList;
  // };
  // changesHistoryColumnDefinitions = () => {
  //   let columnList = [];
  //   columnList.push(
  //     new BootstrapDataGridColumnDefinition()
  //       .setDetails("Date", "updatedDate")
  //       .setSortColumn(true)
  //   );
  //   columnList.push(
  //     new BootstrapDataGridColumnDefinition()
  //       .setDetails("Done By", "updatedBy")
  //       .setSortColumn(true)
  //   );
  //   columnList.push(
  //     new BootstrapDataGridColumnDefinition()
  //       .setDetails("Changes", "description")
  //       .setSortColumn(true)
  //   );

  //   return columnList;
  // };

  render() {
    let pickTicketData = new PickTicketBean();
    pickTicketData = this.props.pickTicketData;
    let statusTracks = [];
    if (!isEmpty(pickTicketData) && !isEmptyArray(pickTicketData.statusTracks))
      statusTracks = pickTicketData.statusTracks;

    let changeHistoryTracks = [];
    if (
      !isEmpty(pickTicketData) &&
      !isEmptyArray(pickTicketData.changeHistoryTracks)
    )
      changeHistoryTracks = pickTicketData.changeHistoryTracks;

    return (
      <div className="header_div">
        <div className="div_inline">
          {" "}
          <div class="div_Equal">
            <FormLabel className="table_title">Status History</FormLabel>
            <Table id="fabrics_tables_default">
              <thead>
                <th>Date</th>
                <th>Status</th>
                <th>Previous Status</th>
                <th>Done By</th>
                <th>Remarks</th>
              </thead>
              <tbody>
                {statusTracks.map((list, index) => (
                  <tr key={index}>
                    <td className="text-right">{list.createdDate}</td>
                    <td className="text-right">
                      {ModuleUtils.getPickTicketStatusCaption(
                        list.currentStatus
                      )}
                    </td>
                    <td className="text-right">
                      {ModuleUtils.getPickTicketStatusCaption(
                        list.previousStatus
                      )}
                    </td>
                    <td className="text-right">{list.createdBy}</td>
                    <td className="text-right">{list.remarks}</td>
                  </tr>
                ))}
              </tbody>
            </Table>
            {statusTracks.length != 0 ? null : (
              <div className="no_Data_small">{"NO DATA"}</div>
            )}
          </div>
          <div class="div_Equal">
            <FormLabel className="table_title">Check Printed History</FormLabel>
            <Table id="fabrics_tables_default">
              <thead>
                <th>Date</th>
                <th>Done By</th>
                <th>Changes</th>
              </thead>
              <tbody>
                {changeHistoryTracks.map((list, index) => (
                  <tr key={index}>
                    <td className="text-right">{list.updatedDate}</td>
                    <td className="text-right">{list.updatedby}</td>
                    <td className="text-right">{list.description}</td>
                  </tr>
                ))}
              </tbody>
            </Table>
            {changeHistoryTracks.length != 0 ? null : (
              <div className="no_Data_small">{"NO DATA"}</div>
            )}
          </div>
        </div>
      </div>
    );
  }
}

function PickTicketMaintenanceModule(props) {
  return (
    <div id="moduleContainer" className="module_container">
      <div className="App">
        <PickTicketList {...props} name="" /> <br />
      </div>
    </div>
  );
}

export default PickTicketMaintenanceModule;
